import React, { useEffect, useRef } from "react";

import "./SVGMap.css";

function SVGMap(props) {
  const svgRef = useRef(null);

  // click/touch and drag
  let startDragPoint;
  let viewboxStartDragPoint;

  // pinch-zoom
  let cachedPoints = [];
  let startPinchZoomPoints = [];
  let pinchZoomAction = false;

  useEffect(() => {
    const viewBox = svgRef.current.viewBox.baseVal;
    if(window.matchMedia("(max-width: 980px)").matches) {
      let scale = 0.7;
      viewBox.x = (viewBox.width - viewBox.width * scale) / 2;
      viewBox.y = (viewBox.height - viewBox.height * scale) / 2;
      viewBox.width *= scale;
      viewBox.height *= scale;
    }
    window.initialSVGViewbox = {x:viewBox.x, y:viewBox.y, width:viewBox.width, height:viewBox.height}
  }, []);

  function onSVGWheel(e) {
    cachedPoints = []
    pinchZoomAction = false;

    let delta = e.deltaY;
    let scale = 1.2;

    //calculate starting svg point
    let point = svgRef.current.createSVGPoint();
    point.x = e.clientX;
    point.y = e.clientY;
    let startPoint = point.matrixTransform(svgRef.current.getScreenCTM().inverse());

    if (delta < 0) {
      //zoom in
      scale = 1 / scale;
      zoomIn(scale, startPoint);
    } else {
      //zooming out
      zoomOut(scale, startPoint)
    }
  }

  function onSVGPointerDown(e) {
    cachedPoints.push({id: e.pointerId, x: e.clientX, y: e.clientY});

    if (cachedPoints.length == 1) {
      startDragPoint = {x: e.clientX, y: e.clientY}
      let viewBox = svgRef.current.viewBox.baseVal;
      viewboxStartDragPoint = {x: viewBox.x, y: viewBox.y}
    }

    if (cachedPoints.length == 2) {
      startPinchZoomPoints = [{x: cachedPoints[0].x, y: cachedPoints[0].y}, {x: cachedPoints[1].x, y: cachedPoints[1].y}];
      pinchZoomAction = true;
    }
  }

  function onSVGPointerMove(e) {
    // Find this event in the cache and update its record with this event
    for (let i = 0; i < cachedPoints.length; i++) {
      if (e.pointerId == cachedPoints[i].id) {
        cachedPoints[i].x = e.clientX;
        cachedPoints[i].y = e.clientY;
      break;
      }
    }

    // Click/touch and drag
    if (!pinchZoomAction && cachedPoints.length == 1) {
      //start drag point on svg canvas
      let startPoint = svgRef.current.createSVGPoint();
      startPoint.x = startDragPoint.x;
      startPoint.y = startDragPoint.y;
      let startDragSVGPoint = startPoint.matrixTransform(svgRef.current.getScreenCTM().inverse());

      //current drag point on svg canvas
      let currentPoint = svgRef.current.createSVGPoint();
      currentPoint.x = e.clientX;
      currentPoint.y = e.clientY;
      let currentDragSVGPoint = currentPoint.matrixTransform(svgRef.current.getScreenCTM().inverse());

      //add diff to viewBox x and y
      let diff = {x: currentDragSVGPoint.x - startDragSVGPoint.x, y: currentDragSVGPoint.y - startDragSVGPoint.y}
      let viewBox = svgRef.current.viewBox.baseVal;
      viewBox.x = viewboxStartDragPoint.x - diff.x;
      viewBox.y = viewboxStartDragPoint.y - diff.y;

      //check limits
      if (viewBox.x < window.initialSVGViewbox.x) {
        viewBox.x = window.initialSVGViewbox.x;
      }
      if (viewBox.y < window.initialSVGViewbox.y) {
        viewBox.y = window.initialSVGViewbox.y;
      }
      if ((viewBox.x + viewBox.width) > (window.initialSVGViewbox.x + window.initialSVGViewbox.width)) {
        let over = (viewBox.x + viewBox.width) - (window.initialSVGViewbox.x + window.initialSVGViewbox.width);
        viewBox.x -= over;
      }
      if ((viewBox.y + viewBox.height) > (window.initialSVGViewbox.y + window.initialSVGViewbox.height)) {
        let over = (viewBox.y + viewBox.height) - (window.initialSVGViewbox.y + window.initialSVGViewbox.height);
        console.log(over);
        console.log(viewBox.y);
        viewBox.y -= over;
        console.log(viewBox.y);
      }

    }

    // Pinch-zoom
    if (cachedPoints.length == 2) {
      // Calculate the distance between the two pointers
      let startDiff = Math.sqrt(Math.pow(Math.abs(startPinchZoomPoints[0].x - startPinchZoomPoints[1].x), 2) + Math.pow(Math.abs(startPinchZoomPoints[0].y - startPinchZoomPoints[1].y), 2));
      let curDiff = Math.sqrt(Math.pow(Math.abs(cachedPoints[0].x - cachedPoints[1].x), 2) + Math.pow(Math.abs(cachedPoints[0].y - cachedPoints[1].y), 2));
      let scale = curDiff / startDiff;

      let startPinchZoomSVGPoints = [];
      let point = svgRef.current.createSVGPoint();
      point.x = startPinchZoomPoints[0].x;
      point.y = startPinchZoomPoints[0].y;
      startPinchZoomSVGPoints.push(point.matrixTransform(svgRef.current.getScreenCTM().inverse()));
      point.x = startPinchZoomPoints[1].x;
      point.y = startPinchZoomPoints[1].y;
      startPinchZoomSVGPoints.push(point.matrixTransform(svgRef.current.getScreenCTM().inverse()));
      let startPinchZoomSVGMidPoint = svgRef.current.createSVGPoint();
      startPinchZoomSVGMidPoint.x = (startPinchZoomSVGPoints[0].x + startPinchZoomSVGPoints[1].x) / 2;
      startPinchZoomSVGMidPoint.y = (startPinchZoomSVGPoints[0].y + startPinchZoomSVGPoints[1].y) / 2;


      if (scale > 1) {
        zoomIn(0.93, startPinchZoomSVGMidPoint);
      }
      else {
        zoomOut(1.07, startPinchZoomSVGMidPoint);
      }
    }
  }

  function onSVGPointerUp(e) {
    for (var i = 0; i < cachedPoints.length; i++) {
      if (cachedPoints[i].id == e.pointerId) {
        cachedPoints.splice(i, 1);
        break;
      }
    }

    if (cachedPoints.length == 0) {
      pinchZoomAction = false;
    }
  }

  function zoomIn(scale, startPoint) {
    let viewBox = svgRef.current.viewBox.baseVal;

    if(viewBox.width * scale < window.initialSVGViewbox.width * 0.1) {
      scale = window.initialSVGViewbox.width * 0.1 / viewBox.width;
    }

    //scale width and height
    viewBox.width *= scale;
    viewBox.height *= scale;

    //calculate x and y so that mouse stays on the same point after zoom in
    let pointDelta = {x: (startPoint.x - viewBox.x) * (1 - scale), y: (startPoint.y - viewBox.y) * (1 - scale)}
    viewBox.x += pointDelta.x;
    viewBox.y += pointDelta.y;
  }

  function zoomOut(scale, startPoint) {
    let viewBox = svgRef.current.viewBox.baseVal;

    if(viewBox.width * scale >= window.initialSVGViewbox.width) {
      viewBox.x = window.initialSVGViewbox.x;
      viewBox.y = window.initialSVGViewbox.y;
      viewBox.width = window.initialSVGViewbox.width;
      viewBox.height = window.initialSVGViewbox.height;
    }
    else {
      //scale width and height
      viewBox.width *= scale;
      viewBox.height *= scale;

      //calculate x and y so that mouse stays on the same point after zoom in
      let pointDelta = {x: (startPoint.x - viewBox.x) * (1 - scale), y: (startPoint.y - viewBox.y) * (1 - scale)}
      viewBox.x += pointDelta.x;
      viewBox.y += pointDelta.y;
    }
  }

  function onObjectMouseEnter(e) {
    e.target.style.fillOpacity = "0.2";
    props.onObjectMouseEnter(e);
  }

  function onObjectMouseLeave(e) {
    e.target.style.fillOpacity = "0";
    props.onObjectMouseLeave(e);
  }

  function onObjectMouseMove(e) {
    props.onObjectMouseMove(e);
  }

  function onObjectClicked(e) {
    props.onObjectClicked(e);
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg8851"
      version="1.1"
      viewBox="0 0 1920 1080"
      ref={svgRef}
      onWheel = {onSVGWheel}
      onPointerDown = {onSVGPointerDown}
      onPointerUp = {onSVGPointerUp}
      onPointerMove = {onSVGPointerMove}
    >
      <path
        d="M1499.133 912.108l1.814-121.318m-6.359 121.5l2.899-120.441m1.646 120.26l-4.545.182m2.899-120.442l3.46-1.059M1273.277 999.446l224.204 1.655m-224.204-1.655l-.233-4.55m221.668 3.118l-221.668-3.119m222.214-33.527l3.17-.01m-3.17.01l-.546 36.646m3.716-36.651l-.947 39.738M610.95 992.526l638.153 6.652M610.662 989.17l638.462 6.827m0 0l-.022 3.181m-638.44-10.008l.287 3.356M344.949 786.587l-.593 45.748m-5.793-45.662l6.386-.086m6.939-257.053l-13.326 257.138m8.594-257.474l4.732.336m-18.84 262.056l14.108-262.393m252.384 457.26l-.05 3.847m-111.407-4.847l111.457 1m-129.65-1.803l18.193.803m.766 3.528l110.642 1.32m-129.987-1.7l19.345.38M333.047 791.59l7.31-.094m-.364 40.472l.363-40.472m88.957 194.31l40.191 2.8m-39.816-6.556l40.202 2.604m-123.023-93.15l1.464 18.443 5.27 17.728 8.832 16.25 12.022 14.055 14.693 11.25 16.693 7.944 17.99 4.307 5.857.57m-82.821-90.547l-2.51-59.17m-1.86 58.817l-2.504-59.183m2.504 59.183l1.13 18.91 5.04 18.27 8.73 16.828 12.032 14.639 14.812 11.818 16.946 8.477 18.334 4.775 9.792.938M985.7 149.28l1.3-3.434m-522.843-44.21l130.2 9.542L987 145.846m-590.1 18.981l-44.655 326.635 3.504-.316m0 0l44.513-325.355m62.595-60.72l130.2 9.542L985.7 149.28m-522.843-44.21l-13.647 2.133-12.915 4.915-11.613 7.489-9.797 9.748-7.55 11.564-4.987 12.896-2.086 11.976m63.895-64.155l-14.043 1.513-13.421 4.403-12.222 7.102-10.48 9.478-8.276 11.455-5.711 12.922-2.899 13.83-.206 2.488M1205.066 166.053l2.568-6.558 2.837-4.308 3.239-4.031 3.586-3.711 3.923-3.365 32.971-11.055 180.119-34.907 75.371-8.003 20.471.338 4.598 2.866 1.093 2.3 2.358 21.322-.202 31.944m3.54.11l.25-32.073m-32.45-29.418l21.092.177m-38.71 101.806l-.315 3.894m49.286-18.891l.847-25.494m-37.47 269.68l-.016 1.692m-33.494-1.362l33.494 1.362m-342.933-258.577l-.873 5.495m-1.428-.199l1.428.199m-47.9 234l18.458 1.659m-116.088-254.35l3.76.905M989.98 334.97l.341 2.444 1.324 1.61 2.319 1.708m511.154 60.366l.444-21.299m-4.156 20.988l3.712.311m-3.41-21.109l-.302 20.798m2.304-153.871l-2.002 133.073m5.547-133.043l-1.693 132.853m-1.336-185.63l-.516 52.747m4.1-56.016l-.555 56.046m28.419-70.675l-27.875 15.637m30.497-13.037l-30.212 16.937m29.098-22.276l-1.508 2.74m5.016-1.781l-2.394 4.38m-.3-29.985l-.814 24.646m2.683-77.988l1.922 21.379m-5.131-26.022l3.21 4.643m-9.437-7.862l6.227 3.22m-318.022 50.397l34.238-11.73 143.77-28.358 39.856-6.402 72.838-7.304m-290.702 53.794l-3.922 3.365-3.587 3.712-3.239 4.03-2.837 4.31-2.432 4.562-2 4.763m-58.277-5.594l.304-3.02m-93.71-5.894l2.726-2.485 90.984 8.379m12.605 3.404l5.869.96m-5.87-.96l-.947 5.808m0 0l1.22.196m-18.861 236.646l367.407 15.196M1018.476 149.5l-3.07 3.25-1.764 5.12-23.66 177.099m24.734-186.373l-3.07 3.249-1.764 5.12-23.66 177.1m150.439 69.415l22.157-236.393m-3.296-.253l-24.718 236.11m-20.08 2.441l359.834 13.62m33.67-224.837l-12.823-.787m16.405-2.482l-16.09-1.412m-419.707 184.685l40.333 27.113m-42.7-23.95l41.079 28.05m-116.76-64.654l78.048 33.441m-79.656-29.56l77.29 32.722m-83.426-43.27l.154 2.127.54 2.07.9 1.935 1.237 1.738 1.535 1.487 1.77 1.191m270.518-170.106l149.456 12.233m-149.456-12.233l-62.31-4.529.052-3.937m62.314 4.538l-62.314-4.538m211.714 20.699l.689-3.538-150.09-12.623"
        className="wall"
      ></path>
      <path
        d="M351.036 529.854l237.746 13.455 53.32 47.588 197.691 17.467 40.321-53.846-6.072-64.934-56.075-50.052-24.41-69.51 250.53 14.558 131.327 197.25 76.962 21.896 272.406 6.627M641.648 591.384L627.339 704l-7.49 42.46-20.75 246.976"
        className="track"
      ></path>
      <path
        d="M1257.361 603.598l-10.315 216.908-3.918 175.509"
        className="track"
      ></path>
      <path
        d="M1429.568 184.633l62.152 4.855m-64.307 22.202l62.152 4.854m2.155-27.056l-2.155 27.056m-59.997-31.91l-2.155 27.056"
        className="wall"
      ></path>
      <text x="1448.397" y="207.191" className="other-label">
        Wc
      </text>
      <path
        d="M1370.622 312.79l-.385 12.287-17.307-.851-14.15-.641m14.547-11.516l-.397 12.157m-13.778-12.156l-.372 11.515m11.806-113.706l12.945.326 11.766.737m-11.766-.737l-.42 8.72m12.186-7.983l-.406 8.726m-24.305-9.79l.088 8.588m-39.966 20.096l39.026 1.206m0 0l.94-21.302m24.217 1.202l-24.217-1.202m29.358 1.4l-5.14-.198m4.2 21.5l.94-21.303m38.124 22.879l-39.065-1.577m36.627 73.618l2.438-72.041m-64.828 69.325l17.295.72m-31.47-.72h14.175m-45.268-1.55l31.093 1.55m-28.445-73.507l-2.648 71.956m62.563 2.272l45.095 1.995"
        className="wall"
      ></path>
      <text x="1340.066" y="281.524" className="other-label">
        Muzej
      </text>
      <g>
        <path
          d="M1055.743 218.569l-.806 5.826m-12.63-6.817l13.436.99m65.589 12.13l-66.395-6.303m67.272.779l-.877 5.524m14.349-4.399l-13.472-1.125m20.132-64.728l-6.66 65.853m-93.374-8.721l6.627-66.045m93.407 8.913l-93.407-8.913"
          className="wall"
        ></path>
        <text x="1052.046" y="191.713" className="other-label">
          Mrtvačnica
        </text>
      </g>
      <g>
        <path
          d="M723.841 129.926l26.052 1.962m0 0l-3.166 32.684m-26.058-1.95l26.058 1.95m-22.886-34.646l-3.172 32.696"
          className="wall"
        ></path>
        <text x="704.676" y="151.516" className="other-label">
          Kapelica
        </text>
      </g>
      <g>
        <path
          d="M861.666 194.97l21.514 3.17 1.828-6.883 3.22.359-1.004 6.72 63.383 9.847-.934 4.097-87.608-13.733-.399-3.578M676.09 484.476l-.018-19.218 1.787-4.112 47.724.786m-22.845 22.944l.12-18.724-22.012-.32-.38 18.758m44.866-17.928l-17.389-.213-.985 18.482M628.165 372.968l-1.883 11.781-3.012-.216-.229 2.587 3.39.65-3.219 17.972-2.303-.418-.5 3.394 2.593.509-2.876 16.26m7.743-48.214l64.58 6.572-5.528 43.807-4.857-.748 2.303-32.372-3.951.134-2.653 31.725-54.61-7.198m-3.298 6.163l4.674.383.448-2.313 6.387 1.152.028 2.058 12.505 1.496.298-1.9 21.205 2.736.078 2.334 11.724 1.88-.012 5.415 3.662.363.68-5.083 3.463.082-.384-2.498 32.778 3.992m-87.471-77.79l32.528 3.469.787-7.311 3.923.531-.625 7.22 8.835 1.533-.169 3.537-30.068-3.117-16.01-1.8m-.954 11.243l68.552 7.37-5.637 47.775 26.524 3.673-.215 3.667m-72.018-72.012l.007.8 29.711 3.455.108-1.054M804.047 579.793l-4.945.819-.331 1.741-69.486-.81m74.762-1.75l2.43-.35 2.293-.843 2.078-1.3 1.761-1.72 1.36-2.032.914-2.272.423-2.418-.097-2.45-.602-2.378-1.082-2.198-1.516-1.923-1.88-1.57-2.17-1.142-2.358-.67-2.195-.174m4.13 16.397l.985-.964.757-1.134.516-1.275.228-1.356-.058-1.368-.329-1.332-.61-1.233-.847-1.072-1.055-.886-1.216-.639-1.314-.367-.192-.034m-102.795 15.116l36.891.492-.447-11.5 2.664-.363.635 11.943 5.213.308.73-11.526 3.041.172-.688 11.094 12.75.417-.336-10.534 4.396.072.1 10.312 28.257.314-.154-13.286m-120.063-1.359l-.383 13.044 4.947.13m-9.304-13.195l-.968 17.754 44.27.758m-33.998-5.318l.317-11.902 22.274.489-.144 11.684-22.447-.27m119.542-11.754l.277 11.661M804.172 452.298l-.283 10.862m.283-10.862l-34.224-.326m-53.834-.658l-.809 6.404 3.9.042m29.85 1.872l-29.488-3.816-.362 1.944m28.083-2.065l7.536-67.231-3.875-.424m-30.644 58.867l-.107 4.815 23.149 3.098 7.091-62.344.511-4.436m-30.644 58.867l-2.635-.043-1.556 4.45m87.93 18.095l-.105-2.539 14.588 1.674-.736-3.346-13.902-2.038m.27 33.565l2.804-.638 2.612-1.192 2.305-1.717 1.9-2.164 1.401-2.498.864-2.74.269-2.862-.338-2.852-.914-2.72-1.47-2.47-1.944-2.113-2.343-1.67-2.643-1.135-2.619-.545m-56.755-13.714l22.113 2.522m34.85 34.297l1.934-.64 1.748-1.015 1.5-1.37 1.175-1.651.822-1.856.405-1.982-.007-2.031-.441-1.981-.835-1.844-1.202-1.637-1.51-1.35-1.76-1.002-1.931-.615-.507-.094m-34.241-15.23l.547-6.244"
          className="wall"
        ></path>
        <text x="697.564" y="409.039" className="other-label">
          Iskopine
        </text>
      </g>
      <g>
        <path
          d="M640.055 562.537l1.555-78.207 162.603 1.965.207 15.237 42.613.63-.608 47.445-42.917-.63-.187 15.209z"
          className="wall"
        ></path>
        <text x="685.432" y="525.324" className="other-label">
          Stara crkva
        </text>
      </g>
      <g>
        <text x="1336.189" y="824.737" className="field-label">
          E
        </text>
        <text x="1271.59" y="621.152" className="object-label">
          1
        </text>
        <text x="1270.338" y="644.216" className="object-label">
          2
        </text>
        <text x="1269.112" y="667.745" className="object-label">
          3
        </text>
        <text x="1268.568" y="687.719" className="object-label">
          4
        </text>
        <text x="1267.385" y="706.95" className="object-label">
          5
        </text>
        <text x="1267.624" y="726.998" className="object-label">
          6
        </text>
        <text x="1266.477" y="770.071" className="object-label">
          9
        </text>
        <text x="1264.727" y="812.318" className="object-label">
          11
        </text>
        <text x="1263.62" y="856.958" className="object-label">
          14
        </text>
        <text x="1263.041" y="871.336" className="object-label">
          15
        </text>
        <text x="1261.001" y="887.016" className="object-label">
          16
        </text>
        <text x="1257.432" y="908.144" className="object-label">
          17
        </text>
        <text x="1259.392" y="938.119" className="object-label">
          19
        </text>
        <text x="1259.545" y="956.219" className="object-label">
          20
        </text>
        <text x="1292.132" y="975.536" className="object-label">
          40
        </text>
        <text x="1281.136" y="948.762" className="object-label">
          39
        </text>
        <text x="1280.948" y="932.152" className="object-label">
          38
        </text>
        <text x="1285.44" y="916.245" className="object-label">
          37
        </text>
        <text x="1287.481" y="844.628" className="object-label">
          34
        </text>
        <text x="1290.866" y="774.369" className="object-label">
          30
        </text>
        <text x="1293.844" y="721.024" className="object-label">
          27
        </text>
        <text x="1294.673" y="705.718" className="object-label">
          26
        </text>
        <text x="1296.155" y="688.125" className="object-label">
          25
        </text>
        <text x="1300.935" y="653.383" className="object-label">
          23
        </text>
        <text x="1333.111" y="624.171" className="object-label">
          41
        </text>
        <text x="1332.212" y="643.39" className="object-label">
          42
        </text>
        <text x="1329.244" y="667.22" className="object-label">
          43
        </text>
        <text x="1321.652" y="737.257" className="object-label">
          46
        </text>
        <text x="1316.412" y="753.273" className="object-label">
          47
        </text>
        <text x="1317.142" y="769.894" className="object-label">
          48
        </text>
        <text x="1312.114" y="820.434" className="object-label">
          51
        </text>
        <text x="1310.741" y="847.048" className="object-label">
          52
        </text>
        <text x="1309.601" y="867.145" className="object-label">
          53
        </text>
        <text x="1309.183" y="889.014" className="object-label">
          54
        </text>
        <text x="1308.652" y="912.184" className="object-label">
          55
        </text>
        <text x="1307.641" y="933.251" className="object-label">
          56
        </text>
        <text x="1306.388" y="952.06" className="object-label">
          57
        </text>
        <text x="1312.632" y="975.649" className="object-label">
          58
        </text>
        <text x="1335.702" y="967.203" className="object-label">
          76
        </text>
        <text x="1336.619" y="948.036" className="object-label">
          75
        </text>
        <text x="1336.536" y="929.344" className="object-label">
          74
        </text>
        <text x="1337.173" y="906.444" className="object-label">
          73
        </text>
        <text x="1336.904" y="837.135" className="object-label">
          69
        </text>
        <text x="1340.85" y="773.654" className="object-label">
          65
        </text>
        <text x="1344.148" y="752.351" className="object-label">
          64
        </text>
        <text x="1344.674" y="735.141" className="object-label">
          63
        </text>
        <text x="1342.926" y="720.243" className="object-label">
          62
        </text>
        <text x="1345.275" y="703.628" className="object-label">
          61
        </text>
        <text x="1359.434" y="668.286" className="object-label">
          60
        </text>
        <text x="1361.332" y="631.492" className="object-label">
          59
        </text>
        <text x="1366.021" y="705.643" className="object-label">
          78
        </text>
        <text x="1365.15" y="763.798" className="object-label">
          81
        </text>
        <text x="1363.63" y="814.777" className="object-label">
          82
        </text>
        <text x="1363.538" y="839.726" className="object-label">
          83
        </text>
        <text x="1361.344" y="865.203" className="object-label">
          84
        </text>
        <text x="1358.965" y="885.792" className="object-label">
          85
        </text>
        <text x="1361.718" y="965.914" className="object-label">
          90
        </text>
        <text x="1384.945" y="972.558" className="object-label">
          108
        </text>
        <text x="1388.517" y="920.86" className="object-label">
          105
        </text>
        <text x="1389.352" y="901.064" className="object-label">
          104
        </text>
        <text x="1387.119" y="874.836" className="object-label">
          103
        </text>
        <text x="1388.53" y="847.084" className="object-label">
          102
        </text>
        <text x="1388.412" y="806.283" className="object-label">
          101
        </text>
        <text x="1388.528" y="787.238" className="object-label">
          100
        </text>
        <text x="1387.965" y="768.77" className="object-label">
          99
        </text>
        <text x="1387.567" y="750.328" className="object-label">
          98
        </text>
        <text x="1386.881" y="730.078" className="object-label">
          97
        </text>
        <text x="1387.294" y="712.096" className="object-label">
          96
        </text>
        <text x="1387.07" y="695.184" className="object-label">
          95
        </text>
        <text x="1387.022" y="669.957" className="object-label">
          94
        </text>
        <text x="1386.508" y="647.575" className="object-label">
          93
        </text>
        <text x="1387.879" y="626.456" className="object-label">
          92
        </text>
        <text x="1413.787" y="626.825" className="object-label">
          109
        </text>
        <text x="1413.28" y="650.127" className="object-label">
          110
        </text>
        <text x="1412.728" y="690.908" className="object-label">
          111
        </text>
        <text x="1410.937" y="725.643" className="object-label">
          112
        </text>
        <text x="1410.838" y="759.496" className="object-label">
          113
        </text>
        <text x="1410.559" y="816.795" className="object-label">
          116
        </text>
        <text x="1435.382" y="755.291" className="object-label">
          134
        </text>
        <text x="1439.244" y="846.985" className="object-label">
          139
        </text>
        <text x="1439.11" y="875.711" className="object-label">
          140
        </text>
        <text x="1439.133" y="902.453" className="object-label">
          141
        </text>
        <text x="1466.951" y="786.807" className="object-label">
          155
        </text>
        <text x="1490.1" y="660.806" className="object-label">
          166
        </text>
        <text x="1488.794" y="679.312" className="object-label">
          167
        </text>
        <text x="1490.412" y="755.671" className="object-label">
          171
        </text>
        <text x="1487.952" y="779.763" className="object-label">
          172
        </text>
        <text x="1464.817" y="815.983" className="object-label">
          156
        </text>
        <text x="1464.192" y="848.374" className="object-label">
          157
        </text>
        <text x="1464.767" y="943.813" className="object-label">
          162
        </text>
        <text x="1458.882" y="975.055" className="object-label">
          163
        </text>
        <text x="1435.524" y="953.781" className="object-label">
          144
        </text>
        <text x="1480.988" y="973.752" className="object-label">
          176
        </text>
        <text x="1487.904" y="951.56" className="object-label">
          175
        </text>
        <text x="1488.749" y="927.475" className="object-label">
          174
        </text>
        <text x="1486.317" y="818.983" className="object-label">
          173
        </text>
        <text x="1266.967" y="754.8" className="object-label">
          8
        </text>
        <text x="1266.924" y="743.065" className="object-label">
          7
        </text>
        <text x="1263.35" y="839.742" className="object-label">
          13
        </text>
        <text x="1264.121" y="826.924" className="object-label">
          12
        </text>
        <text x="1285.865" y="893.109" className="object-label">
          36
        </text>
        <text x="1286.396" y="872.788" className="object-label">
          35
        </text>
        <text x="1289.431" y="821.918" className="object-label">
          33
        </text>
        <text x="1290.328" y="790.42" className="object-label">
          31
        </text>
        <text x="1289.878" y="806.117" className="object-label">
          32
        </text>
        <text x="1290.737" y="752.773" className="object-label">
          29
        </text>
        <text x="1291.674" y="736.509" className="object-label">
          28
        </text>
        <text x="1301.64" y="637.935" className="object-label">
          22
        </text>
        <text x="1302.288" y="621.015" className="object-label">
          21
        </text>
        <text x="1320.783" y="718.973" className="object-label">
          45
        </text>
        <text x="1323.107" y="696.202" className="object-label">
          44
        </text>
        <text x="1315.907" y="800.531" className="object-label">
          50
        </text>
        <text x="1316.398" y="786.52" className="object-label">
          49
        </text>
        <text x="1339.63" y="803.588" className="object-label">
          67
        </text>
        <text x="1340.663" y="789.601" className="object-label">
          66
        </text>
        <text x="1337.379" y="884.591" className="object-label">
          72
        </text>
        <text x="1337.546" y="853.508" className="object-label">
          70
        </text>
        <text x="1337.463" y="869.052" className="object-label">
          71
        </text>
        <text x="1356.215" y="985.058" className="object-label">
          91
        </text>
        <text x="1336.751" y="984.455" className="object-label">
          77
        </text>
        <text x="1361.939" y="948.725" className="object-label">
          89
        </text>
        <text x="1361.656" y="934.372" className="object-label">
          88
        </text>
        <text x="1359.143" y="911.616" className="object-label">
          87
        </text>
        <text x="1359.094" y="898.844" className="object-label">
          86
        </text>
        <text x="1365.71" y="737.262" className="object-label">
          80
        </text>
        <text x="1365.893" y="722.805" className="object-label">
          79
        </text>
        <text x="1388.587" y="952.763" className="object-label">
          107
        </text>
        <text x="1388.89" y="937.859" className="object-label">
          106
        </text>
        <text x="1412.7" y="935.504" className="object-label">
          123
        </text>
        <text x="1412.768" y="916.924" className="object-label">
          122
        </text>
        <text x="1412.831" y="899.032" className="object-label">
          121
        </text>
        <text x="1412.89" y="883.025" className="object-label">
          120
        </text>
        <text x="1412.947" y="866.784" className="object-label">
          119
        </text>
        <text x="1412.028" y="848.4" className="object-label">
          118
        </text>
        <text x="1411.85" y="833.023" className="object-label">
          117
        </text>
        <text x="1410.921" y="795.931" className="object-label">
          115
        </text>
        <text x="1410.582" y="780.527" className="object-label">
          114
        </text>
        <text x="1440.569" y="644.894" className="object-label">
          128
        </text>
        <text x="1441.718" y="623.124" className="object-label">
          126
        </text>
        <text x="1441.138" y="634.124" className="object-label">
          127
        </text>
        <text x="1438.408" y="661.2" className="object-label">
          129
        </text>
        <text x="1436.475" y="695.82" className="object-label">
          131
        </text>
        <text x="1437.008" y="680.052" className="object-label">
          130
        </text>
        <text x="1435.949" y="734.722" className="object-label">
          133
        </text>
        <text x="1435.983" y="717.88" className="object-label">
          132
        </text>
        <text x="1435.182" y="793.885" className="object-label">
          136
        </text>
        <text x="1435.737" y="776.881" className="object-label">
          135
        </text>
        <text x="1435.259" y="828.057" className="object-label">
          138
        </text>
        <text x="1435.256" y="811.74" className="object-label">
          137
        </text>
        <text x="1439.636" y="932.99" className="object-label">
          143
        </text>
        <text x="1439.637" y="919.05" className="object-label">
          142
        </text>
        <text x="1433.084" y="986.649" className="object-label">
          146
        </text>
        <text x="1434.605" y="970.966" className="object-label">
          145
        </text>
        <text x="1465.618" y="924.74" className="object-label">
          161
        </text>
        <text x="1465.528" y="910.015" className="object-label">
          160
        </text>
        <text x="1474.024" y="896.034" className="object-label">
          159
        </text>
        <text x="1473.229" y="877.988" className="object-label">
          158
        </text>
        <text x="1488.012" y="733.179" className="object-label">
          170
        </text>
        <text x="1466.79" y="756.963" className="object-label">
          154
        </text>
        <text x="1467.349" y="733.298" className="object-label">
          153
        </text>
        <text x="1467.618" y="713.194" className="object-label">
          152
        </text>
        <text x="1467.959" y="694.701" className="object-label">
          151
        </text>
        <text x="1467.702" y="678.978" className="object-label">
          150
        </text>
        <text x="1468.11" y="664.138" className="object-label">
          149
        </text>
        <text x="1465.155" y="642.228" className="object-label">
          148
        </text>
        <text x="1465.591" y="626.987" className="object-label">
          147
        </text>
        <text x="1489.964" y="716.707" className="object-label">
          169
        </text>
        <text x="1490.262" y="699.342" className="object-label">
          168
        </text>
        <text x="1488.441" y="643.704" className="object-label">
          165
        </text>
        <text x="1488.97" y="628.235" className="object-label">
          164
        </text>
        <text x="1256.876" y="924.694" className="object-label">
          18
        </text>
        <text x="1264.344" y="790.299" className="object-label">
          10
        </text>
        <text x="1336.943" y="823.654" className="object-label">
          68
        </text>
        <text x="1295.672" y="672.832" className="object-label">
          24
        </text>
        <text x="1412.298" y="954.109" className="object-label">
          124
        </text>
        <text x="1411.546" y="970.773" className="object-label">
          125
        </text>
        <g>
          <path
            id="5001"
            d="M1260.396 629.55l.906-17.834 21.482 1.035-.916 17.837z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5002"
            d="M1259.727 652.474l.768-17.323 20.453.807-.767 17.322z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5003"
            d="M1258.198 675.912l1.18-17.567 20.648 1.235-1.17 17.564z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5004"
            d="M1258.414 696.868l.05-18.348 20.257.05-.049 18.348z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5005"
            d="M1257.349 715.086l.581-17.563 19.492 1.288-.592 17.566z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5006"
            d="M1257.892 734.583l.396-15.567 19.069.397-.396 15.567z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5009"
            d="M1256.316 779.228l.288-18.602 20.035.286-.298 18.605z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5011"
            d="M1254.46 821.056l.058-18.059 20.478.583-.06 18.059z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5014"
            d="M1253.757 864.74l.282-16.543 19.444.988-.285 16.534z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5015"
            d="M1254.24 876.15l.158-9.894 17.444.274-.171 9.886z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5016"
            d="M1251.208 896.147l-.776-17.7 20.361-.562.776 17.7z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5017"
            d="M1246.475 917.618l1.526-20.366 20.388 1.428-1.53 20.356z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5019"
            d="M1249.883 946.701l-.043-17.119 19.072-.046.033 17.123z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5020"
            d="M1249.648 963.703l.425-15.87 19.369.901-.426 15.871z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5040"
            d="M1281.565 985.592l.3-18.99 20.833-1.121-.303 18.979z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5039"
            d="M1271.28 960.27l.56-23.688 19.153.671-.56 23.69z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5038"
            d="M1270.55 935.924l.11-8.114 20.687.567-.121 8.118z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5037"
            d="M1276.176 926.555l.303-21.023 18.225.407-.293 21.02z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5034"
            d="M1277.29 854.896l.758-21.306 19.623.757-.764 21.32z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5030"
            d="M1281.071 778.83l.24-9.3 19.349.389-.244 9.29z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5027"
            d="M1284.65 725.017l.379-8.32 18.008.335-.378 8.32z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5026"
            d="M1284.633 713.129l1.428-16.367 18.652 1.536-1.424 16.376z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5025"
            d="M1285.968 695.586l1.254-15.99 19.121 1.068-1.254 15.99z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5023"
            d="M1291.265 660.004l-.277-13.119 19.622-.124.273 13.11z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5041"
            d="M1323.133 632.71l.949-17.872 19.006.802-.962 17.865z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5042"
            d="M1322.736 651.744l.216-17.153 18.735.444-.216 17.154z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5043"
            d="M1318.928 674.994l1.294-17.01 19.339 1.466-1.284 17.006z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5046"
            d="M1310.954 744.275l1.455-16.84 19.94 2.804-1.455 16.84z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5047"
            d="M1306.887 759.55l.646-13.485 18.405.921-.643 13.495z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5048"
            d="M1306.26 778.02l.716-17.338 21.048 1.085-.716 17.34z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5051"
            d="M1301.113 832.165l.484-24.656 21.518 1.204-.487 24.646z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5052"
            d="M1300.58 854.896l.29-16.423 20.031.728-.29 16.422z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5053"
            d="M1298.225 878.102l1.117-22.708 21.634.791-1.127 22.711z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5054"
            d="M1298.424 898.036l.64-19.277 20.877 1.246-.633 19.264z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5055"
            d="M1298.745 920.56l1.268-17.994 18.546 1.233-1.264 18.004z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5056"
            d="M1297.167 941.88l1.376-18.754 19.572 1.486-1.372 18.764z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5057"
            d="M1296.86 959.97l-.062-16.199 19.106.372.074 16.205z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5058"
            d="M1303.532 983.996l.38-16.453 17.82-.242-.385 16.444z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5076"
            d="M1325.926 959.301l-.193 15.406 19.747.397.192-15.405z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5075"
            d="M1326.914 955.523l.745-15.96 18.665.99-.735 15.955z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5074"
            d="M1326.735 937.785l-.125-16.413 19.738-.47.115 16.417z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5073"
            d="M1327.375 920.326l.273-27.79 19.323.025-.273 27.79z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5069"
            d="M1327.828 845.373l-1.48-15.377 19.632-1.098 1.48 15.376z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5065"
            d="M1331.274 780.537l.95-14.528 18.202.766-.94 14.524z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5064"
            d="M1337.009 753.804l.438-3.8 13.84.884-.435 3.81z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5063"
            d="M1334.916 742.798l1.199-16.795 18.317 1.482-1.2 16.795z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5062"
            d="M1333.757 724.226l.193-9.013 18.146 1.056-.197 9.003z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5061"
            d="M1335.025 710.806l1.549-16.374 18.951 2.007-1.545 16.385z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5060"
            d="M1347.988 682.708l.853-29.302 22.038.458-.853 29.302z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5059"
            d="M1350.19 644.533l2.004-27.557 20.28 1.476-2.003 27.557z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5078"
            d="M1356.269 713.235l.375-15.887 19.13.703-.375 15.887z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5081"
            d="M1354.881 778.562l1.546-30.492 18.992.954-1.543 30.503z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5082"
            d="M1353.328 827.717l.652-26.217 19.951.338-.652 26.216z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5083"
            d="M1353.406 848.179l1.155-17.797 19.109.902-1.16 17.787z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5084"
            d="M1351.141 872.619l1.26-16.33 19.147 1.498-1.26 16.33z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5085"
            d="M1351.25 888.89l.082-6.805 15.346.609-.08 6.805z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5090"
            d="M1350.939 974.92l.785-18.504 20.773.492-.785 18.504z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5108"
            d="M1374.728 984.527l1.046-24.694 19.387.76-1.036 24.69z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5105"
            d="M1378.904 929.704l-.653-16.828 19.885-.86.646 16.842z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5104"
            d="M1379.79 907.664l-.143-12.77 19.266-.43.144 12.77z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5103"
            d="M1376.392 885.546l.45-22.092 21.005.671-.45 22.092z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5102"
            d="M1378.154 855.091l.908-16.66 19.844.646-.908 16.66z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5101"
            d="M1378.61 814.462l.241-16.53 19.363.17-.242 16.53z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5100"
            d="M1378.617 795.507l.058-16.341 19.765-.197-.048 16.338z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5099"
            d="M1378.087 777.575l.14-17.601 19.616-.01-.15 17.605z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5098"
            d="M1378.093 758.326l-.302-15.527 19.253-.47.298 15.517z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5097"
            d="M1377.505 738.279l-.521-16.06 19.274-.342.521 16.06z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5096"
            d="M1377.752 720.37l.19-17.032 18.895.48-.201 17.035z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5095"
            d="M1377.666 703.355l.148-16.214 18.66-.128-.144 16.225z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5094"
            d="M1377.126 682.896l.14-26.129 19.65.25-.14 26.13z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5093"
            d="M1375.9 656.283l.465-17.997 20.751.59-.468 17.987z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5092"
            d="M1377.243 635.293l.945-18.661 20.328.997-.949 18.65z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5109"
            d="M1402.625 636.077l.567-19.162 21.757.658-.567 19.161z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5110"
            d="M1403.144 663.354l.702-27.013 19.57.572-.695 27z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5111"
            d="M1402.38 703.423l1.252-25.792 19.444.762-1.251 25.793z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5112"
            d="M1399.938 742.078l1.279-33.596 20.719.725-1.279 33.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5113"
            d="M1400.488 772.62l.379-26.709 20.32.458-.389 26.712z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5116"
            d="M1401.946 825.752l-1.553-16.266 18.775-1.647 1.556 16.276z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5134"
            d="M1424.909 763.348l.023-16.216 20.923.111-.026 16.207z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5139"
            d="M1429.348 853.257l.474-13.007 19.319.467-.464 13.004z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5140"
            d="M1428.833 892.517l-.09-33.763 20.648.162.086 33.753z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5141"
            d="M1429.308 910.875l.165-16.943 19.486.104-.179 16.937z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5155"
            d="M1456.413 798.709l1.756-25.088 19.32 1.28-1.766 25.091z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5166"
            d="M1480.051 669.192l.436-17.14 19.662.382-.43 17.126z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5167"
            d="M1479.035 686.805l.53-15.636 18.987.65-.53 15.636z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5171"
            d="M1481.16 763.13l.333-15.489 18.17.574-.322 15.485z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5172"
            d="M1478.286 786.822l.394-14.662 18.939.543-.394 14.662z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5156"
            d="M1454.27 828.754l1.375-26.446 19.72.904-1.375 26.446z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5157"
            d="M1453.98 862.006l.4-27.553 20.025.29-.4 27.552z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5162"
            d="M1454.126 954.867l.614-22.725 20.667.608-.61 22.735z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5163"
            d="M1447.984 983.188l1.08-17.138 20.717.884-1.083 17.127z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5144"
            d="M1425.52 958.22l.686-10.29 19.322 1.415-.676 10.287z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5176"
            d="M1470.985 984.53l1.077-22.4 18.929.84-1.087 22.404z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5175"
            d="M1478.574 959.196l.358-15.61 18.302.335-.369 15.614z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5174"
            d="M1479.573 936.28l.245-17.75 18.107.132-.231 17.758z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5173"
            d="M1478.037 822.793l.12-8.027 16.44.408-.119 8.027z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5008"
            d="M1276.307 760.282l-.042-11.02-18.637.063.029 11.014z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5007"
            d="M1276.264 749.262l-.034-12.458-18.647.068.044 12.453z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5013"
            d="M1272.481 848.19l.947-15.736-19.21-1.16-.947 15.736z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5012"
            d="M1273.428 832.454l.597-9.899-19.21-1.16-.597 9.899z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5036"
            d="M1295.155 905.353l.628-23.983-19.209-.506-.627 23.983z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5035"
            d="M1295.783 881.37l.435-16.654-19.198-.509-.446 16.657z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5033"
            d="M1298.975 830.143l.452-15.892-19.543-.558-.449 15.901z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5031"
            d="M1299.871 798.532l.452-15.665-19.542-.559-.449 15.675z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5032"
            d="M1299.427 814.251l.444-15.719-19.539-.549-.448 15.71z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5029"
            d="M1299.558 762.181l1.028-17.74-18.673-1.077-1.024 17.751z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5028"
            d="M1300.586 744.44l.848-14.786-18.672-1.077-.849 14.787z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5022"
            d="M1311.709 646.706l.64-16.747-20.778-.795-.64 16.747z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5021"
            d="M1312.349 629.959l.655-17.092-20.777-.795-.656 17.092z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5045"
            d="M1310.96 725.252l1.473-14.417 18.174 1.849-1.47 14.427z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5044"
            d="M1312.433 710.835l3.17-31.115 18.178 1.859-3.174 31.105z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5050"
            d="M1305.244 807.278l.502-14.225 20.823.734-.491 14.222z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5049"
            d="M1326.57 793.787l.48-13.8-20.824-.734-.48 13.8z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5067"
            d="M1349.457 811.41l1.036-14.117-20.683-1.529-1.042 14.132z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5066"
            d="M1350.493 797.293l1.022-13.865-20.679-1.518-1.026 13.854z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5072"
            d="M1347.1 892.12l.092-14.952-19.544-.106-.08 14.948z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5070"
            d="M1347.28 861.042l.076-14.958-19.533-.11-.087 14.962z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5071"
            d="M1347.191 877.168l.088-16.126-19.543-.106-.088 16.126z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5091"
            d="M1364.694 993.533l.557-16.402-17.562-.549-.51 16.409z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5077"
            d="M1347.179 992.99l.51-16.408-21.319-.663-.557 16.402z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5089"
            d="M1371.544 955.76l-.288-14.447-18.923.377.288 14.448z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5088"
            d="M1352.333 941.69l-.278-14.259 18.923-.377.278 14.259z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5087"
            d="M1369.475 919.524l-.057-15.895-20.607.083.067 15.891z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5086"
            d="M1369.417 903.63l-.04-9.655-20.607.083.04 9.654z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5080"
            d="M1375.667 742.375l.12-9.97-20.024-.255-.13 9.973z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5079"
            d="M1355.763 732.15l.236-18.945 20.025.842-.237 18.358z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5107"
            d="M1398.019 960.106l.295-14.3-19.166-.385-.288 14.286z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5106"
            d="M1398.314 945.806l.32-15.495-19.16-.399-.326 15.509z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5123"
            d="M1402.212 944.674l.068-18.423 20.909.072-.064 18.433z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5122"
            d="M1402.28 926.251l.064-18.726 20.912.082-.067 18.716z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5121"
            d="M1402.343 907.524l.066-17.067 20.91.072-.063 17.077z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5120"
            d="M1402.409 890.458l.05-14.938 20.913.082-.054 14.928z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5119"
            d="M1402.459 875.52l.066-17.553 20.909.072-.062 17.563z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5118"
            d="M1421.498 856.273l-.187-15.974-18.753.217.19 15.984z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5117"
            d="M1402.558 840.516l-.17-14.76 18.75-.227.173 14.77z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5115"
            d="M1420.676 787.683l.582 15.746-20.092.75-.582-15.746z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5114"
            d="M1400.584 788.433l-.096-15.813 19.64.446.549 14.617z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5128"
            d="M1451.344 651.008l.588-11.059-22.139-1.168-.588 11.059z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5126"
            d="M1430.345 628.299l.608-11.518 22.139 1.168-.609 11.518z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5127"
            d="M1429.793 638.78l.552-10.481 22.138 1.168-.552 10.482z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5129"
            d="M1429.205 649.84l-1.144 21.689 19.55 1.031 1.143-21.69z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5131"
            d="M1425.509 703.185l.525-15.454 21.407.723-.525 15.454z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5130"
            d="M1426.034 687.732l.545-16.082 21.403.939-.541 15.865z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5133"
            d="M1446.263 742.9l.035-16.311-20.663-.045-.035 16.311z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5132"
            d="M1425.635 726.545l.038-17.374 20.659.035-.034 17.383z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5136"
            d="M1445.792 802.656l.541-16.837-21.75-.705-.552 16.84z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5135"
            d="M1424.582 785.114l.56-17.171 21.751.704-.56 17.172z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5138"
            d="M1425.218 835.946l-.011-15.769 20.102-.01.001 15.769z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5137"
            d="M1425.206 820.182v-16.874l20.102-.01v16.874z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5143"
            d="M1450.031 939.994l-.01-14.026-20.781.017.01 14.027z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5142"
            d="M1450.026 925.968l-.013-13.854-20.766.014v13.858z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5146"
            d="M1442.917 994.033l1.236-12.73-20.905-2.039-1.233 12.741z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5145"
            d="M1444.153 981.302l1.81-18.645-20.903-2.028-1.812 18.635z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5161"
            d="M1455.713 931.95l-.085-14.45 19.884-.114.096 14.707z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5160"
            d="M1475.512 917.386l-.085-14.71-19.884-.146.085 14.97z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5159"
            d="M1484.082 900.577l-.422-9.872-19.693.793.442 9.864z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5158"
            d="M1463.967 891.498l-1.17-26.226 19.727-.793 1.136 26.226z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5170"
            d="M1478.191 725.445l.472 15.366 19.17.101-.462-15.37z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5154"
            d="M1456.64 771.533l.701-29.611 19.599.46-.697 29.621z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5153"
            d="M1457.341 741.922l.418-17.709 19.598.359-.417 17.81z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5152"
            d="M1476.709 724.56l.403-22.39-18.576-.343-.412 22.395z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5151"
            d="M1458.536 701.827l.261-14.594 18.585.34-.27 14.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5150"
            d="M1477.286 686.68l.415-14.863-19.593-.54-.405 14.858z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5149"
            d="M1458.108 671.276l.42-14.818 19.583.545-.41 14.814z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5148"
            d="M1474.58 650.077l.44-15.152-19.29-.546-.439 15.153z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5147"
            d="M1455.73 634.379l.433-15.331 19.289.546-.433 15.331z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5169"
            d="M1499.432 725.559l.294-17.384-19.223-.32-.3 17.623z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5168"
            d="M1480.504 707.855l.284-17.346 19.233.316-.295 17.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5165"
            d="M1478.497 650.328l.476-13.911 19.412.672-.478 13.901z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5164"
            d="M1478.973 636.417l.595-17.037 19.4.665-.583 17.044z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5124"
            d="M1402.102 959.314l.068-14.669 20.99.057-.065 14.677z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5125"
            d="M1421.754 977.011l1.234-14.272-20.864-2.285-1.23 14.284z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
        <g>
          <path
            id="5018"
            d="M1247.207 921.294l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5010"
            d="M1255.054 787.913l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5068"
            d="M1326.72 823.354l3.957-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="5024"
            d="M1285.266 669.82l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
      </g>
      <g>
        <text x="1292.536" y="542.868" className="field-label">
          D
        </text>
        <text x="1135.565" y="427.676" className="object-label">
          1
        </text>
        <text x="1163.862" y="428.124" className="object-label">
          2
        </text>
        <text x="1162.42" y="461.702" className="object-label">
          3
        </text>
        <text x="1161.314" y="495.017" className="object-label">
          4
        </text>
        <text x="1189.576" y="529.583" className="object-label">
          8
        </text>
        <text x="1191.137" y="496.007" className="object-label">
          7
        </text>
        <text x="1192.11" y="462.793" className="object-label">
          6
        </text>
        <text x="1193.041" y="429.806" className="object-label">
          5
        </text>
        <text x="1222.351" y="424.123" className="object-label">
          9
        </text>
        <text x="1221.878" y="443.097" className="object-label">
          10
        </text>
        <text x="1221.269" y="462.478" className="object-label">
          11
        </text>
        <text x="1220.649" y="481.614" className="object-label">
          12
        </text>
        <text x="1220.073" y="500.784" className="object-label">
          13
        </text>
        <text x="1219.603" y="519.737" className="object-label">
          14
        </text>
        <text x="1218.895" y="538.986" className="object-label">
          15
        </text>
        <text x="1218.378" y="557.991" className="object-label">
          16
        </text>
        <text x="1246.974" y="578.308" className="object-label">
          25
        </text>
        <text x="1247.512" y="559.202" className="object-label">
          24
        </text>
        <text x="1247.898" y="540.014" className="object-label">
          23
        </text>
        <text x="1248.614" y="520.888" className="object-label">
          22
        </text>
        <text x="1249.28" y="501.801" className="object-label">
          21
        </text>
        <text x="1249.872" y="482.593" className="object-label">
          20
        </text>
        <text x="1250.476" y="463.495" className="object-label">
          19
        </text>
        <text x="1250.775" y="444.337" className="object-label">
          18
        </text>
        <text x="1251.625" y="425.279" className="object-label">
          17
        </text>
        <text x="1280.442" y="426.274" className="object-label">
          26
        </text>
        <text x="1279.947" y="445.19" className="object-label">
          27
        </text>
        <text x="1279.523" y="464.534" className="object-label">
          28
        </text>
        <text x="1278.844" y="483.717" className="object-label">
          29
        </text>
        <text x="1278.18" y="502.975" className="object-label">
          30
        </text>
        <text x="1277.581" y="522.108" className="object-label">
          31
        </text>
        <text x="1277.04" y="541.175" className="object-label">
          32
        </text>
        <text x="1276.337" y="560.447" className="object-label">
          33
        </text>
        <text x="1275.752" y="579.536" className="object-label">
          34
        </text>
        <text x="1305.175" y="561.654" className="object-label">
          42
        </text>
        <text x="1306.009" y="542.49" className="object-label">
          41
        </text>
        <text x="1306.571" y="523.202" className="object-label">
          40
        </text>
        <text x="1307.139" y="504.167" className="object-label">
          39
        </text>
        <text x="1307.684" y="484.857" className="object-label">
          38
        </text>
        <text x="1308.19" y="465.797" className="object-label">
          37
        </text>
        <text x="1308.867" y="446.499" className="object-label">
          36
        </text>
        <text x="1309.698" y="426.669" className="object-label">
          35
        </text>
        <text x="1484.145" y="458.027" className="object-label">
          88
        </text>
        <text x="1334.542" y="562.9" className="object-label">
          51
        </text>
        <text x="1335.366" y="543.608" className="object-label">
          50
        </text>
        <text x="1336.107" y="524.452" className="object-label">
          49
        </text>
        <text x="1336.659" y="505.065" className="object-label">
          48
        </text>
        <text x="1337.524" y="486.454" className="object-label">
          47
        </text>
        <text x="1338.459" y="466.78" className="object-label">
          46
        </text>
        <text x="1339.282" y="447.728" className="object-label">
          45
        </text>
        <text x="1340.1" y="428.466" className="object-label">
          44
        </text>
        <text x="1368.371" y="448.633" className="object-label">
          54
        </text>
        <text x="1369.015" y="429.409" className="object-label">
          53
        </text>
        <text x="1367.42" y="467.86" className="object-label">
          55
        </text>
        <text x="1366.669" y="487.251" className="object-label">
          56
        </text>
        <text x="1365.863" y="506.495" className="object-label">
          57
        </text>
        <text x="1365.062" y="525.648" className="object-label">
          58
        </text>
        <text x="1364.228" y="544.45" className="object-label">
          59
        </text>
        <text x="1394.1" y="524.808" className="object-label">
          67
        </text>
        <text x="1395.398" y="491.387" className="object-label">
          66
        </text>
        <text x="1396.405" y="466.859" className="object-label">
          65
        </text>
        <text x="1397.004" y="453.614" className="object-label">
          64
        </text>
        <text x="1397.476" y="440.335" className="object-label">
          63
        </text>
        <text x="1398.001" y="427.896" className="object-label">
          62
        </text>
        <text x="1426.932" y="431.19" className="object-label">
          70
        </text>
        <text x="1426.178" y="451.194" className="object-label">
          71
        </text>
        <text x="1425.391" y="471.02" className="object-label">
          72
        </text>
        <text x="1424.466" y="490.308" className="object-label">
          73
        </text>
        <text x="1423.529" y="509.331" className="object-label">
          74
        </text>
        <text x="1422.915" y="528.626" className="object-label">
          75
        </text>
        <text x="1452.986" y="506.362" className="object-label">
          82
        </text>
        <text x="1453.976" y="482.435" className="object-label">
          81
        </text>
        <text x="1455.018" y="456.638" className="object-label">
          80
        </text>
        <text x="1455.906" y="433.984" className="object-label">
          79
        </text>
        <text x="1482.383" y="497.674" className="object-label">
          90
        </text>
        <text x="1483.25" y="478.237" className="object-label">
          89
        </text>
        <text x="1484.229" y="437.893" className="object-label">
          87
        </text>
        <text x="1304.844" y="580.689" className="object-label">
          43
        </text>
        <text x="1333.854" y="582.119" className="object-label">
          52
        </text>
        <text x="1363.497" y="564.08" className="object-label">
          60
        </text>
        <text x="1392.832" y="558.316" className="object-label">
          68
        </text>
        <text x="1421.917" y="547.403" className="object-label">
          76
        </text>
        <text x="1452.06" y="526.96" className="object-label">
          83
        </text>
        <text x="1481.506" y="516.695" className="object-label">
          91
        </text>
        <text x="1391.514" y="584.516" className="object-label">
          69
        </text>
        <text x="1421.321" y="566.767" className="object-label">
          77
        </text>
        <text x="1420.576" y="585.555" className="object-label">
          78
        </text>
        <text x="1450.33" y="567.66" className="object-label">
          85
        </text>
        <text x="1451.241" y="547.159" className="object-label">
          84
        </text>
        <text x="1480.54" y="542.884" className="object-label">
          92
        </text>
        <text x="1362.579" y="583.116" className="object-label">
          61
        </text>
        <text x="1449.628" y="586.953" className="object-label">
          86
        </text>
        <text x="1478.628" y="588.234" className="object-label">
          94
        </text>
        <text x="1479.318" y="569.148" className="object-label">
          93
        </text>
        <g>
          <path
            id="4001"
            d="M1125.664 435.378l.7-16.316 19.102.915-.69 16.313z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4002"
            d="M1154.007 441.389l1.533-27.902 18.177 1.373-1.533 27.902z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4003"
            d="M1152.452 476.56l.789-30.364 19.146.652-.779 30.36z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4004"
            d="M1151.082 509.827l.96-30.583 19.505.968-.95 30.579z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4008"
            d="M1178.893 545.061l2.051-31.605 19.315.65-2.05 31.605z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4007"
            d="M1180.998 511.212l1.01-30.735 19.267.316-1.007 30.745z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4006"
            d="M1182.576 477.275l.939-29.513 18.129.554-.929 29.509z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4005"
            d="M1183.462 444.109l.871-28.993 18.286.387-.871 28.993z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4009"
            d="M1212.226 432.127l.5-16.63 19.75.633-.504 16.62z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4010"
            d="M1212.136 450.942l.47-16.395 19.015.698-.456 16.4z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4011"
            d="M1211.25 470.452l.664-16.451 19.373.494-.66 16.46z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4012"
            d="M1210.54 489.855l.564-16.935 19.653.452-.563 16.936z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4013"
            d="M1210.073 508.914l.447-16.85 19.553.59-.446 16.85z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4014"
            d="M1209.616 527.936l.39-16.943 19.584.545-.391 16.943z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4015"
            d="M1208.891 547.198l.528-16.81 19.48.377-.525 16.82z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4016"
            d="M1209.035 565.061l.37-15.026 18.316.895-.373 15.017z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4025"
            d="M1237.068 586.27l.767-16.577 19.045.653-.767 16.577z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4024"
            d="M1237.6 567.2l.593-16.653 19.23.668-.596 16.642z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4023"
            d="M1237.882 547.934l.507-16.577 19.525.734-.517 16.58z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4022"
            d="M1238.773 528.795l.427-16.583 19.255.772-.416 16.579z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4021"
            d="M1239.88 509.106l.402-15.354 18.399.743-.403 15.354z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4020"
            d="M1239.722 490.717l.625-17.081 19.675.84-.639 17.075z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4019"
            d="M1240.662 471.392l.372-16.35 19.255.546-.368 16.36z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4018"
            d="M1240.68 452.342l.601-16.926 19.588.916-.6 16.925z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4017"
            d="M1241.58 433.29l.777-16.58 19.313.548-.773 16.59z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4026"
            d="M1270.312 434.094l.668-16.373 19.593.733-.67 16.374z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4027"
            d="M1269.892 453.193l.554-16.638 19.557.633-.554 16.638z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4028"
            d="M1270.175 471.844l.318-15.336 18.378.716-.319 15.336z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4029"
            d="M1269.019 491.651l.539-16.486 19.112.619-.54 16.486z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4030"
            d="M1267.951 510.705l.768-16.283 19.691.823-.768 16.283z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4031"
            d="M1267.517 530.023l.726-16.664 19.401.834-.725 16.664z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4032"
            d="M1267.1 549.099l.648-16.501 19.23.667-.64 16.488z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4033"
            d="M1266.404 568.374l.496-16.641 19.37.777-.493 16.65z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4034"
            d="M1265.767 587.401l.562-16.29 19.408.56-.562 16.29z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4042"
            d="M1295.268 569.526l.266-16.458 19.548.703-.262 16.47z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4041"
            d="M1296.7 549.962l.399-15.658 18.219.715-.398 15.658z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4040"
            d="M1296.598 531.18l.56-16.652 19.387.693-.57 16.655z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4039"
            d="M1297.856 511.665l.3-15.353 18.266.36-.291 15.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4038"
            d="M1297.509 493.025l.604-16.915 19.745.59-.607 16.905z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4037"
            d="M1298.102 473.55l.64-16.229 19.535.731-.653 16.222z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4036"
            d="M1298.811 454.632l.26-16.604 19.85.339-.26 16.604z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4035"
            d="M1299.653 434.799l.618-16.842 19.473.583-.619 16.842z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4088"
            d="M1493.94 466.886l.72-16.843-20.286-.876-.743 16.84z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4051"
            d="M1324.503 570.867l.622-16.606 19.456.668-.631 16.61z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4050"
            d="M1325.356 551.617l.69-16.833 19.33.825-.693 16.822z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4049"
            d="M1325.966 532.35l.603-16.69 19.679.885-.6 16.7z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4048"
            d="M1326.646 512.832l.572-16.554 19.454 1.019-.571 16.554z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4047"
            d="M1327.398 493.844l.764-15.515 19.488.725-.76 15.525z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4046"
            d="M1328.361 474.522l.648-16.14 19.548.67-.642 16.126z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4045"
            d="M1329.996 454.954l.5-15.264 18.073.81-.501 15.265z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4044"
            d="M1329.892 436.557l1.031-16.725 19.385.557-1.025 16.712z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4054"
            d="M1358.048 456.627l.624-16.889 20.023.9-.624 16.89z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4053"
            d="M1359.891 420.892l-.533 16.439 18.788.596.526-16.426z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4055"
            d="M1357.462 475.705l.692-16.664 19.225.975-.692 16.663z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4056"
            d="M1357.35 494.516l.467-15.23 18.172.709-.471 15.22z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4057"
            d="M1356.582 513.624l.433-15.106 18.13.848-.433 15.105z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4058"
            d="M1355.14 533.451l.686-16.323 19.157.716-.686 16.323z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4059"
            d="M1354.257 552.486l.514-16.884 19.428.813-.513 16.884z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4067"
            d="M1383.794 539.805l1.302-30.87 19.31.865-1.297 30.881z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4066"
            d="M1385.552 506.19l1.335-30.126 18.358.531-1.339 30.115z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4065"
            d="M1386.481 471.495l.409-10.341 19.438 1.07-.408 10.34z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4064"
            d="M1386.918 458.445l.377-10.399 19.795.731-.364 10.405z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4063"
            d="M1387.613 444.84l.405-9.606 19.32.603-.418 9.6z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4062"
            d="M1388.139 432.403l.404-9.607 19.321.603-.408 9.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4070"
            d="M1416.739 438.99l.774-16.523 19.612.919-.785 16.526z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4071"
            d="M1416.097 459.138l.749-16.661 19.414.773-.75 16.66z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4072"
            d="M1415.074 478.808l.905-16.636 19.728 1.059-.905 16.636z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4073"
            d="M1414.575 498.037l.502-16.463 19.28 1.001-.513 16.466z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4074"
            d="M1413.555 517.164l.646-16.603 19.301.937-.645 16.602z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4075"
            d="M1413.441 535.874l.681-15.429 18.266.947-.674 15.415z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4082"
            d="M1443.542 513.623l.734-15.47 18.155.951-.724 15.467z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4081"
            d="M1443.5 494.108l1.206-24.173 19.745.816-1.202 24.183z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4080"
            d="M1445.363 466.148l.898-19.672 18.41.648-.907 19.676z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4079"
            d="M1445.935 441.778l.76-16.405 19.182.82-.75 16.401z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4090"
            d="M1472.254 505.646l.53-16.709 19.727.766-.53 16.708z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4089"
            d="M1474.054 485.547l.247-15.572 18.145.955-.238 15.568z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4087"
            d="M1494.022 446.753l.72-16.843-20.286-.876-.74 16.85z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4043"
            d="M1295.07 588.548l.41-16.531 19.139.824-.414 16.521z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4052"
            d="M1324.078 589.787l.883-15.985 18.67.648-.883 15.985z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4060"
            d="M1354.034 571.403l.7-15.344 18.225.7-.689 15.342z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4068"
            d="M1383.173 572.856l1.18-29.405 18.139.325-1.18 29.405z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4076"
            d="M1411.797 555.219l.576-16.443 19.665.81-.577 16.443z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4083"
            d="M1442.65 534.32l.625-15.431 18.195.712-.624 15.431z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4091"
            d="M1471.839 524.043l.804-15.562 18.531.866-.804 15.562z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4069"
            d="M1381.536 592.221l.642-16.06 19.315.65-.643 16.06z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4077"
            d="M1411.411 574.837l.6-16.733 19.22.603-.604 16.724z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4078"
            d="M1410.622 593.07l.54-16.125 19.368 1.095-.54 16.125z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4085"
            d="M1441.001 575.252l.438-15.706 18.22.522-.438 15.706z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4084"
            d="M1441.062 555.25l.645-17.055 19.713.884-.65 17.045z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4092"
            d="M1470.222 557.87l1.36-30.767 19.277.798-1.35 30.764z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4061"
            d="M1352.396 591.153l.929-16.792 19.437.709-.926 16.802z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4086"
            d="M1439.538 595.019l1.051-17.026 19.13.895-1.052 17.026z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4094"
            d="M1468.496 596.117l.522-16.763 19.741.998-.522 16.763z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="4093"
            d="M1469.934 576.437l.39-15.52 18.377.943-.39 15.52z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
      </g>
      <g>
        <text x="893.944" y="793.295" className="field-label">
          C
        </text>
        <text x="701.241" y="683.426" className="object-label">
          57
        </text>
        <text x="651.883" y="618.686" className="object-label">
          1
        </text>
        <text x="650.386" y="636.461" className="object-label">
          2
        </text>
        <text x="648.611" y="654.343" className="object-label">
          3
        </text>
        <text x="646.168" y="680.683" className="object-label">
          4
        </text>
        <text x="643.271" y="711.045" className="object-label">
          5
        </text>
        <text x="633.774" y="810.269" className="object-label">
          12
        </text>
        <text x="629.02" y="850.548" className="object-label">
          15
        </text>
        <text x="627.517" y="868.2" className="object-label">
          16
        </text>
        <text x="624.48" y="894.539" className="object-label">
          17
        </text>
        <text x="622.872" y="910.994" className="object-label">
          18
        </text>
        <text x="621.302" y="930.503" className="object-label">
          19
        </text>
        <text x="619.75" y="951.545" className="object-label">
          20
        </text>
        <text x="617.544" y="972.186" className="object-label">
          21
        </text>
        <text x="646.389" y="944.431" className="object-label">
          38
        </text>
        <text x="647.895" y="923.62" className="object-label">
          37
        </text>
        <text x="654.689" y="900.232" className="object-label">
          36
        </text>
        <text x="656.913" y="868.203" className="object-label">
          35
        </text>
        <text x="657.535" y="849.326" className="object-label">
          34
        </text>
        <text x="659.675" y="812.856" className="object-label">
          32
        </text>
        <text x="662.264" y="788.774" className="object-label">
          31
        </text>
        <text x="671.474" y="741.613" className="object-label">
          28
        </text>
        <text x="676.74" y="718.151" className="object-label">
          27
        </text>
        <text x="677.723" y="630.98" className="object-label">
          22
        </text>
        <text x="701.862" y="662.325" className="object-label">
          56
        </text>
        <text x="702.308" y="715.079" className="object-label">
          59
        </text>
        <text x="701.747" y="733.563" className="object-label">
          60
        </text>
        <text x="700.852" y="755.169" className="object-label">
          61
        </text>
        <text x="684.247" y="779.511" className="object-label">
          41
        </text>
        <text x="678.476" y="829.727" className="object-label">
          44
        </text>
        <text x="680.875" y="885.051" className="object-label">
          48
        </text>
        <text x="677.011" y="907.314" className="object-label">
          49
        </text>
        <text x="673.747" y="928.523" className="object-label">
          50
        </text>
        <text x="708.588" y="817.636" className="object-label">
          66
        </text>
        <text x="700.649" y="831.849" className="object-label">
          67
        </text>
        <text x="706.427" y="887.494" className="object-label">
          70
        </text>
        <text x="701.937" y="916.538" className="object-label">
          71
        </text>
        <text x="699.648" y="933.446" className="object-label">
          72
        </text>
        <text x="693.811" y="967.201" className="object-label">
          73
        </text>
        <text x="670.04" y="952.56" className="object-label">
          51
        </text>
        <text x="669.607" y="965.21" className="object-label">
          52
        </text>
        <text x="669.085" y="982.33" className="object-label">
          53
        </text>
        <text x="693.763" y="984.205" className="object-label">
          74
        </text>
        <text x="729.734" y="641.443" className="object-label">
          76
        </text>
        <text x="726.623" y="691.54" className="object-label">
          79
        </text>
        <text x="725.37" y="710.394" className="object-label">
          80
        </text>
        <text x="728.94" y="755.019" className="object-label">
          83
        </text>
        <text x="734.022" y="793.672" className="object-label">
          86
        </text>
        <text x="725.901" y="844.861" className="object-label">
          89
        </text>
        <text x="723.172" y="868" className="object-label">
          90
        </text>
        <text x="728.123" y="907.565" className="object-label">
          92
        </text>
        <text x="723.026" y="925.405" className="object-label">
          93
        </text>
        <text x="717.606" y="953.28" className="object-label">
          94
        </text>
        <text x="716.747" y="978.453" className="object-label">
          95
        </text>
        <text x="741.658" y="983.277" className="object-label">
          115
        </text>
        <text x="743.026" y="967.496" className="object-label">
          114
        </text>
        <text x="744.208" y="947.238" className="object-label">
          113
        </text>
        <text x="748.654" y="917.95" className="object-label">
          112
        </text>
        <text x="750.611" y="897.787" className="object-label">
          111
        </text>
        <text x="745.554" y="882.077" className="object-label">
          110
        </text>
        <text x="761.756" y="823.562" className="object-label">
          107
        </text>
        <text x="763.696" y="806.196" className="object-label">
          106
        </text>
        <text x="765.369" y="788.332" className="object-label">
          105
        </text>
        <text x="832.66" y="636.159" className="object-label">
          163
        </text>
        <text x="832.057" y="655.643" className="object-label">
          164
        </text>
        <text x="822.365" y="752.795" className="object-label">
          169
        </text>
        <text x="823.082" y="735.501" className="object-label">
          168
        </text>
        <text x="825.856" y="716.224" className="object-label">
          167
        </text>
        <text x="752.766" y="757.676" className="object-label">
          102
        </text>
        <text x="753.437" y="745.899" className="object-label">
          101
        </text>
        <text x="868.455" y="592.685" className="object-label">
          182
        </text>
        <text x="864.026" y="614.686" className="object-label">
          183
        </text>
        <text x="860.132" y="636.735" className="object-label">
          184
        </text>
        <text x="912.044" y="590.905" className="object-label">
          261
        </text>
        <text x="913.574" y="575.514" className="object-label">
          260
        </text>
        <text x="918.282" y="556.084" className="object-label">
          259
        </text>
        <text x="930.978" y="536.67" className="object-label">
          258
        </text>
        <text x="834.949" y="432.07" className="object-label">
          139
        </text>
        <text x="855.271" y="450.197" className="object-label">
          162
        </text>
        <text x="878.162" y="453.978" className="object-label">
          181
        </text>
        <text x="883.556" y="417.75" className="object-label">
          179
        </text>
        <text x="886.932" y="401.285" className="object-label">
          178
        </text>
        <text x="910.4" y="638.015" className="object-label">
          264
        </text>
        <text x="896.424" y="676.567" className="object-label">
          266
        </text>
        <text x="918.796" y="666.791" className="object-label">
          270
        </text>
        <text x="917.621" y="686.71" className="object-label">
          271
        </text>
        <text x="912.518" y="699.268" className="object-label">
          272
        </text>
        <text x="933.514" y="711.782" className="object-label">
          287
        </text>
        <text x="932.647" y="689.444" className="object-label">
          286
        </text>
        <text x="930.5" y="630.912" className="object-label">
          269
        </text>
        <text x="932.036" y="611.94" className="object-label">
          268
        </text>
        <text x="933.777" y="578.147" className="object-label">
          267
        </text>
        <text x="1036.177" y="428.703" className="object-label">
          362
        </text>
        <text x="1025.208" y="448.793" className="object-label">
          363
        </text>
        <text x="1019.125" y="468.074" className="object-label">
          364
        </text>
        <text x="1011.402" y="491.224" className="object-label">
          365
        </text>
        <text x="1021.433" y="408.241" className="object-label">
          330
        </text>
        <text x="1014.737" y="426.911" className="object-label">
          331
        </text>
        <text x="998.569" y="453.932" className="object-label">
          332
        </text>
        <text x="994.298" y="471.348" className="object-label">
          333
        </text>
        <text x="984.33" y="525.899" className="object-label">
          335
        </text>
        <text x="983.363" y="542.309" className="object-label">
          336
        </text>
        <text x="983.787" y="567.84" className="object-label">
          337
        </text>
        <text x="983.288" y="584.678" className="object-label">
          338
        </text>
        <text x="982.563" y="599.232" className="object-label">
          339
        </text>
        <text x="978.912" y="644.218" className="object-label">
          341
        </text>
        <text x="981.498" y="617.474" className="object-label">
          340
        </text>
        <text x="982.685" y="663.268" className="object-label">
          342
        </text>
        <text x="982.176" y="673.278" className="object-label">
          343
        </text>
        <text x="981.686" y="683.956" className="object-label">
          344
        </text>
        <text x="980.765" y="698.281" className="object-label">
          345
        </text>
        <text x="979.549" y="717.677" className="object-label">
          346
        </text>
        <text x="952.249" y="712.754" className="object-label">
          318
        </text>
        <text x="955.015" y="694.876" className="object-label">
          317
        </text>
        <text x="950.653" y="643.462" className="object-label">
          314
        </text>
        <text x="953.105" y="626.265" className="object-label">
          313
        </text>
        <text x="954.719" y="603.757" className="object-label">
          312
        </text>
        <text x="957.381" y="542.786" className="object-label">
          308
        </text>
        <text x="958.423" y="524.152" className="object-label">
          307
        </text>
        <text x="960.193" y="505.437" className="object-label">
          306
        </text>
        <text x="964.653" y="489.409" className="object-label">
          305
        </text>
        <text x="968.495" y="472.094" className="object-label">
          304
        </text>
        <text x="974.776" y="453.255" className="object-label">
          303
        </text>
        <text x="988.169" y="433.306" className="object-label">
          302
        </text>
        <text x="992.795" y="410.012" className="object-label">
          301
        </text>
        <text x="1112.979" y="716.469" className="object-label">
          494
        </text>
        <text x="1117.784" y="691.834" className="object-label">
          493
        </text>
        <text x="1120.814" y="674.65" className="object-label">
          492
        </text>
        <text x="1124.652" y="655.949" className="object-label">
          491
        </text>
        <text x="1079.002" y="754.342" className="object-label">
          473
        </text>
        <text x="1086.489" y="719.344" className="object-label">
          471
        </text>
        <text x="1095.091" y="679.718" className="object-label">
          469
        </text>
        <text x="1101.4" y="658.635" className="object-label">
          468
        </text>
        <text x="1103.242" y="641.097" className="object-label">
          467
        </text>
        <text x="1108.878" y="604.914" className="object-label">
          464
        </text>
        <text x="1055.996" y="742.25" className="object-label">
          447
        </text>
        <text x="1061.519" y="717.67" className="object-label">
          446
        </text>
        <text x="1064.072" y="689.377" className="object-label">
          445
        </text>
        <text x="1077.21" y="629.783" className="object-label">
          441
        </text>
        <text x="1079.57" y="614.094" className="object-label">
          440
        </text>
        <text x="1081.686" y="599.801" className="object-label">
          439
        </text>
        <text x="1085.186" y="576.778" className="object-label">
          438
        </text>
        <text x="1084.266" y="546.445" className="object-label">
          437
        </text>
        <text x="1059.173" y="501.357" className="object-label">
          409
        </text>
        <text x="1056.254" y="521.112" className="object-label">
          410
        </text>
        <text x="1044.861" y="554.35" className="object-label">
          411
        </text>
        <text x="1039.958" y="572.086" className="object-label">
          412
        </text>
        <text x="1064.362" y="570.488" className="object-label">
          413
        </text>
        <text x="1057.566" y="602.058" className="object-label">
          414
        </text>
        <text x="1052.894" y="626.521" className="object-label">
          415
        </text>
        <text x="1048.743" y="652.049" className="object-label">
          416
        </text>
        <text x="1034.205" y="733.171" className="object-label">
          421
        </text>
        <text x="1033.93" y="711.18" className="object-label">
          420
        </text>
        <text x="1037.711" y="696.97" className="object-label">
          419
        </text>
        <text x="1039.597" y="681.476" className="object-label">
          418
        </text>
        <text x="1046.691" y="668.762" className="object-label">
          417
        </text>
        <text x="1009.383" y="717.036" className="object-label">
          394
        </text>
        <text x="1012.312" y="674.827" className="object-label">
          392
        </text>
        <text x="1014.669" y="655.173" className="object-label">
          391
        </text>
        <text x="1016.329" y="638.759" className="object-label">
          390
        </text>
        <text x="1018.488" y="623.849" className="object-label">
          389
        </text>
        <text x="1017.49" y="568.948" className="object-label">
          386
        </text>
        <text x="1020.123" y="550.872" className="object-label">
          385
        </text>
        <text x="1024.934" y="523.873" className="object-label">
          384
        </text>
        <text x="1047.412" y="464.39" className="object-label">
          381
        </text>
        <text x="889.569" y="592.664" className="object-label">
          236
        </text>
        <text x="893.52" y="573.129" className="object-label">
          235
        </text>
        <text x="899.844" y="554.008" className="object-label">
          234
        </text>
        <text x="904.72" y="536.14" className="object-label">
          233
        </text>
        <text x="888.52" y="617.545" className="object-label">
          237
        </text>
        <text x="871.558" y="703.453" className="object-label">
          242
        </text>
        <text x="877.475" y="722.003" className="object-label">
          243
        </text>
        <text x="875.259" y="738.959" className="object-label">
          244
        </text>
        <text x="879.784" y="768.944" className="object-label">
          245
        </text>
        <text x="882.53" y="792.688" className="object-label">
          246
        </text>
        <text x="886.233" y="805.39" className="object-label">
          247
        </text>
        <text x="883.985" y="817.827" className="object-label">
          248
        </text>
        <text x="879.747" y="841.366" className="object-label">
          249
        </text>
        <text x="876.516" y="864.913" className="object-label">
          250
        </text>
        <text x="867.219" y="897.506" className="object-label">
          212
        </text>
        <text x="866.767" y="912.279" className="object-label">
          213
        </text>
        <text x="813.318" y="968.062" className="object-label">
          177
        </text>
        <text x="814.537" y="941.514" className="object-label">
          176
        </text>
        <text x="827.427" y="909.681" className="object-label">
          198
        </text>
        <text x="827.549" y="893.915" className="object-label">
          197
        </text>
        <text x="828.709" y="877.382" className="object-label">
          196
        </text>
        <text x="830.16" y="843.647" className="object-label">
          195
        </text>
        <text x="842.031" y="811.344" className="object-label">
          194
        </text>
        <text x="838.493" y="794.713" className="object-label">
          193
        </text>
        <text x="840.519" y="777.942" className="object-label">
          192
        </text>
        <text x="843.405" y="763.432" className="object-label">
          191
        </text>
        <text x="845.973" y="736.582" className="object-label">
          189
        </text>
        <text x="852.974" y="723.375" className="object-label">
          188
        </text>
        <text x="858.653" y="651.786" className="object-label">
          185
        </text>
        <text x="755.471" y="720.209" className="object-label">
          100
        </text>
        <text x="756.083" y="689.879" className="object-label">
          99
        </text>
        <text x="754.986" y="662.434" className="object-label">
          98
        </text>
        <text x="781.337" y="661.672" className="object-label">
          118
        </text>
        <text x="785.538" y="677.253" className="object-label">
          119
        </text>
        <text x="785.022" y="694.217" className="object-label">
          120
        </text>
        <text x="778.72" y="722.593" className="object-label">
          121
        </text>
        <text x="785.063" y="824.699" className="object-label">
          127
        </text>
        <text x="775.192" y="844.311" className="object-label">
          128
        </text>
        <text x="781.822" y="892.711" className="object-label">
          131
        </text>
        <text x="770.91" y="908.569" className="object-label">
          132
        </text>
        <text x="766.379" y="951.523" className="object-label">
          135
        </text>
        <text x="765.243" y="968.912" className="object-label">
          136
        </text>
        <text x="788.031" y="967.799" className="object-label">
          157
        </text>
        <text x="789.546" y="948.779" className="object-label">
          156
        </text>
        <text x="793.384" y="909.262" className="object-label">
          153
        </text>
        <text x="804.712" y="886.077" className="object-label">
          175
        </text>
        <text x="803.869" y="862.714" className="object-label">
          174
        </text>
        <text x="809.873" y="839.282" className="object-label">
          173
        </text>
        <text x="814.316" y="820.628" className="object-label">
          172
        </text>
        <text x="800.438" y="739.646" className="object-label">
          148
        </text>
        <text x="801.014" y="718.337" className="object-label">
          145
        </text>
        <text x="1099.244" y="789.482" className="object-label">
          497
        </text>
        <text x="1093.779" y="808.377" className="object-label">
          498
        </text>
        <text x="1090.604" y="821.901" className="object-label">
          499
        </text>
        <text x="1087.821" y="872.015" className="object-label">
          502
        </text>
        <text x="1086.071" y="890.054" className="object-label">
          503
        </text>
        <text x="1085.015" y="939.626" className="object-label">
          507
        </text>
        <text x="1086.839" y="967.636" className="object-label">
          508
        </text>
        <text x="1085.924" y="984.89" className="object-label">
          509
        </text>
        <text x="1064.331" y="967.046" className="object-label">
          484
        </text>
        <text x="1060.885" y="940.259" className="object-label">
          483
        </text>
        <text x="1059.741" y="926.097" className="object-label">
          482
        </text>
        <text x="1068.7" y="849.098" className="object-label">
          479
        </text>
        <text x="965.574" y="750.86" className="object-label">
          347
        </text>
        <text x="958.794" y="784.128" className="object-label">
          348
        </text>
        <text x="955.418" y="813.751" className="object-label">
          349
        </text>
        <text x="953.151" y="854.321" className="object-label">
          351
        </text>
        <text x="955.751" y="893.772" className="object-label">
          354
        </text>
        <text x="953.998" y="935.39" className="object-label">
          357
        </text>
        <text x="926.093" y="980.974" className="object-label">
          329
        </text>
        <text x="1057.002" y="782.395" className="object-label">
          448
        </text>
        <text x="1051.367" y="807.428" className="object-label">
          449
        </text>
        <text x="1050.246" y="827.885" className="object-label">
          450
        </text>
        <text x="1049.16" y="853.203" className="object-label">
          452
        </text>
        <text x="1010.661" y="984.539" className="object-label">
          434
        </text>
        <text x="1015.298" y="969.169" className="object-label">
          433
        </text>
        <text x="1015.885" y="946.814" className="object-label">
          432
        </text>
        <text x="1025.025" y="886.817" className="object-label">
          431
        </text>
        <text x="1029.881" y="848.378" className="object-label">
          429
        </text>
        <text x="1029.733" y="834.651" className="object-label">
          428
        </text>
        <text x="1030.085" y="824.119" className="object-label">
          427
        </text>
        <text x="1030.306" y="804.954" className="object-label">
          426
        </text>
        <text x="1037.731" y="773.263" className="object-label">
          424
        </text>
        <text x="1040.166" y="763.208" className="object-label">
          423
        </text>
        <text x="1022.439" y="763.223" className="object-label">
          422
        </text>
        <text x="1001.695" y="774.375" className="object-label">
          395
        </text>
        <text x="1005.346" y="798.591" className="object-label">
          396
        </text>
        <text x="1004.119" y="817.196" className="object-label">
          397
        </text>
        <text x="1009.15" y="836.187" className="object-label">
          398
        </text>
        <text x="1002.983" y="853.521" className="object-label">
          399
        </text>
        <text x="1002.879" y="871.314" className="object-label">
          400
        </text>
        <text x="1002.395" y="924.568" className="object-label">
          403
        </text>
        <text x="997.93" y="945.25" className="object-label">
          404
        </text>
        <text x="994.911" y="962.95" className="object-label">
          405
        </text>
        <text x="985.737" y="979.311" className="object-label">
          406
        </text>
        <text x="974.635" y="959.802" className="object-label">
          379
        </text>
        <text x="978.465" y="931.239" className="object-label">
          378
        </text>
        <text x="969.541" y="915.739" className="object-label">
          377
        </text>
        <text x="974.755" y="891.577" className="object-label">
          376
        </text>
        <text x="976.612" y="867.104" className="object-label">
          375
        </text>
        <text x="977.295" y="849.279" className="object-label">
          374
        </text>
        <text x="990.232" y="833.965" className="object-label">
          373
        </text>
        <text x="982.582" y="760.252" className="object-label">
          368
        </text>
        <text x="990.148" y="746.622" className="object-label">
          366
        </text>
        <text x="933.429" y="830.726" className="object-label">
          321
        </text>
        <text x="928.308" y="734.933" className="object-label">
          288
        </text>
        <text x="918.909" y="782.765" className="object-label">
          291
        </text>
        <text x="912.224" y="804.729" className="object-label">
          292
        </text>
        <text x="910.999" y="823.981" className="object-label">
          293
        </text>
        <text x="916.401" y="851.736" className="object-label">
          294
        </text>
        <text x="908.386" y="923.037" className="object-label">
          298
        </text>
        <text x="906.35" y="943.336" className="object-label">
          299
        </text>
        <text x="904.438" y="967.915" className="object-label">
          300
        </text>
        <text x="883.673" y="979.409" className="object-label">
          284
        </text>
        <text x="884.51" y="957.673" className="object-label">
          283
        </text>
        <text x="886.906" y="937.158" className="object-label">
          282
        </text>
        <text x="890.359" y="909.745" className="object-label">
          281
        </text>
        <text x="893.702" y="888.933" className="object-label">
          280
        </text>
        <text x="896.654" y="856.856" className="object-label">
          278
        </text>
        <text x="898.991" y="837.999" className="object-label">
          277
        </text>
        <text x="902.205" y="765.274" className="object-label">
          275
        </text>
        <text x="902.594" y="750.681" className="object-label">
          274
        </text>
        <text x="907.431" y="733.54" className="object-label">
          273
        </text>
        <text x="1141.562" y="721.418" className="object-label">
          518
        </text>
        <text x="1138.126" y="742.332" className="object-label">
          519
        </text>
        <text x="1131.798" y="766.506" className="object-label">
          520
        </text>
        <text x="1116.918" y="874.389" className="object-label">
          525
        </text>
        <text x="1114.64" y="897.215" className="object-label">
          526
        </text>
        <text x="1106.822" y="968.046" className="object-label">
          532
        </text>
        <text x="1107.647" y="984.199" className="object-label">
          533
        </text>
        <text x="1129.855" y="986.171" className="object-label">
          550
        </text>
        <text x="1128.128" y="969.3" className="object-label">
          549
        </text>
        <text x="1130.327" y="949.9" className="object-label">
          548
        </text>
        <text x="1134.2" y="924.396" className="object-label">
          547
        </text>
        <text x="1140.376" y="899.211" className="object-label">
          546
        </text>
        <text x="1138.559" y="875.179" className="object-label">
          545
        </text>
        <text x="1143.886" y="855.642" className="object-label">
          544
        </text>
        <text x="1143.875" y="836.636" className="object-label">
          543
        </text>
        <text x="1148.977" y="803.059" className="object-label">
          542
        </text>
        <text x="1151.313" y="779.147" className="object-label">
          541
        </text>
        <text x="1165.7" y="878.666" className="object-label">
          556
        </text>
        <text x="1154.389" y="944.055" className="object-label">
          560
        </text>
        <text x="1153.782" y="963.943" className="object-label">
          561
        </text>
        <text x="1153.511" y="984.072" className="object-label">
          562
        </text>
        <text x="860.635" y="793.085" className="object-label">
          207
        </text>
        <text x="864.671" y="809.783" className="object-label">
          208
        </text>
        <text x="862.927" y="823.292" className="object-label">
          209
        </text>
        <text x="1157.788" y="752.851" className="object-label">
          540
        </text>
        <text x="1187.107" y="870.612" className="object-label">
          575
        </text>
        <text x="1185.419" y="891.621" className="object-label">
          576
        </text>
        <text x="1185.98" y="915.106" className="object-label">
          577
        </text>
        <text x="1180.752" y="938.643" className="object-label">
          578
        </text>
        <text x="1182.83" y="955.966" className="object-label">
          579
        </text>
        <text x="1178.493" y="977.791" className="object-label">
          580
        </text>
        <text x="1204.588" y="987.612" className="object-label">
          587
        </text>
        <text x="1204.02" y="970.747" className="object-label">
          586
        </text>
        <text x="1203.543" y="937.939" className="object-label">
          584
        </text>
        <text x="837.37" y="408.985" className="object-label">
          138
        </text>
        <text x="838.966" y="393.573" className="object-label">
          137
        </text>
        <text x="858.817" y="426.036" className="object-label">
          161
        </text>
        <text x="862.349" y="389.681" className="object-label">
          159
        </text>
        <text x="860.954" y="403.976" className="object-label">
          160
        </text>
        <text x="639.423" y="750.579" className="object-label">
          7
        </text>
        <text x="637.349" y="771.776" className="object-label">
          9
        </text>
        <text x="641.218" y="733.867" className="object-label">
          6
        </text>
        <text x="638.438" y="761.048" className="object-label">
          8
        </text>
        <text x="635.015" y="798.41" className="object-label">
          11
        </text>
        <text x="635.957" y="788.692" className="object-label">
          10
        </text>
        <text x="631.276" y="834.668" className="object-label">
          14
        </text>
        <text x="632.623" y="822.213" className="object-label">
          13
        </text>
        <text x="645.593" y="963.972" className="object-label">
          39
        </text>
        <text x="645.259" y="980.665" className="object-label">
          40
        </text>
        <text x="665.575" y="769.24" className="object-label">
          30
        </text>
        <text x="668.367" y="758.381" className="object-label">
          29
        </text>
        <text x="677.328" y="698.503" className="object-label">
          26
        </text>
        <text x="677.662" y="684.701" className="object-label">
          25
        </text>
        <text x="677.366" y="668.493" className="object-label">
          24
        </text>
        <text x="677.757" y="655.217" className="object-label">
          23
        </text>
        <text x="703.424" y="639.954" className="object-label">
          55
        </text>
        <text x="704.225" y="625.532" className="object-label">
          54
        </text>
        <text x="701.483" y="696.477" className="object-label">
          58
        </text>
        <text x="681.742" y="806.78" className="object-label">
          43
        </text>
        <text x="682.858" y="790.781" className="object-label">
          42
        </text>
        <text x="698.41" y="856.299" className="object-label">
          69
        </text>
        <text x="699.139" y="846.34" className="object-label">
          68
        </text>
        <text x="733.195" y="822.651" className="object-label">
          88
        </text>
        <text x="734.746" y="806.834" className="object-label">
          87
        </text>
        <text x="724.499" y="737.983" className="object-label">
          82
        </text>
        <text x="725.176" y="724.495" className="object-label">
          81
        </text>
        <text x="727.285" y="671.386" className="object-label">
          78
        </text>
        <text x="727.954" y="658.192" className="object-label">
          77
        </text>
        <text x="730.285" y="627.279" className="object-label">
          75
        </text>
        <text x="754.986" y="642.617" className="object-label">
          97
        </text>
        <text x="755.713" y="628.194" className="object-label">
          96
        </text>
        <text x="747.448" y="865.642" className="object-label">
          109
        </text>
        <text x="749.266" y="849.973" className="object-label">
          108
        </text>
        <text x="768.926" y="924.018" className="object-label">
          133
        </text>
        <text x="767.721" y="936.575" className="object-label">
          134
        </text>
        <text x="771.044" y="876.455" className="object-label">
          130
        </text>
        <text x="772.864" y="861.33" className="object-label">
          129
        </text>
        <text x="793.743" y="805.405" className="object-label">
          152
        </text>
        <text x="794.061" y="789.934" className="object-label">
          151
        </text>
        <text x="800.203" y="772.105" className="object-label">
          150
        </text>
        <text x="800.594" y="756.659" className="object-label">
          149
        </text>
        <text x="777.486" y="642.409" className="object-label">
          117
        </text>
        <text x="778.286" y="629.959" className="object-label">
          116
        </text>
        <text x="807.07" y="698.964" className="object-label">
          144
        </text>
        <text x="807.33" y="685.065" className="object-label">
          143
        </text>
        <text x="807.057" y="662.975" className="object-label">
          142
        </text>
        <text x="808.024" y="633.215" className="object-label">
          140
        </text>
        <text x="807.548" y="648.018" className="object-label">
          141
        </text>
        <text x="828.982" y="694.903" className="object-label">
          166
        </text>
        <text x="829.629" y="679.191" className="object-label">
          165
        </text>
        <text x="790.674" y="934.821" className="object-label">
          155
        </text>
        <text x="791.511" y="921.745" className="object-label">
          154
        </text>
        <text x="860.334" y="767.022" className="object-label">
          206
        </text>
        <text x="860.887" y="757.673" className="object-label">
          205
        </text>
        <text x="852.718" y="708.353" className="object-label">
          187
        </text>
        <text x="854.334" y="692.007" className="object-label">
          186
        </text>
        <text x="932.671" y="410.586" className="object-label">
          226
        </text>
        <text x="934.642" y="396.787" className="object-label">
          225
        </text>
        <text x="929.988" y="429.145" className="object-label">
          227
        </text>
        <text x="920.28" y="466.199" className="object-label">
          229
        </text>
        <text x="923.63" y="451.055" className="object-label">
          228
        </text>
        <text x="908.228" y="517.905" className="object-label">
          232
        </text>
        <text x="916.549" y="484.776" className="object-label">
          230
        </text>
        <text x="912.427" y="501.19" className="object-label">
          231
        </text>
        <text x="876.36" y="674.642" className="object-label">
          241
        </text>
        <text x="879.974" y="659.157" className="object-label">
          240
        </text>
        <text x="859.326" y="880.76" className="object-label">
          211
        </text>
        <text x="858.92" y="867.136" className="object-label">
          210
        </text>
        <text x="847.896" y="900.887" className="object-label">
          199
        </text>
        <text x="847.001" y="915.097" className="object-label">
          200
        </text>
        <text x="841.391" y="945.045" className="object-label">
          202
        </text>
        <text x="841.99" y="931.011" className="object-label">
          201
        </text>
        <text x="841.195" y="980.376" className="object-label">
          204
        </text>
        <text x="841.016" y="964.1" className="object-label">
          203
        </text>
        <text x="866.191" y="926.875" className="object-label">
          214
        </text>
        <text x="865.621" y="940.396" className="object-label">
          215
        </text>
        <text x="865.061" y="953.567" className="object-label">
          216
        </text>
        <text x="864.499" y="966.628" className="object-label">
          217
        </text>
        <text x="863.955" y="981.748" className="object-label">
          218
        </text>
        <text x="912.462" y="603.913" className="object-label">
          262
        </text>
        <text x="910.075" y="618.919" className="object-label">
          263
        </text>
        <text x="933.522" y="513.713" className="object-label">
          257
        </text>
        <text x="938.727" y="494.38" className="object-label">
          256
        </text>
        <text x="944.671" y="473.033" className="object-label">
          255
        </text>
        <text x="948.032" y="458.1" className="object-label">
          254
        </text>
        <text x="951.465" y="442.849" className="object-label">
          253
        </text>
        <text x="957.944" y="416.318" className="object-label">
          252
        </text>
        <text x="960.614" y="395.735" className="object-label">
          251
        </text>
        <text x="956.145" y="580.601" className="object-label">
          311
        </text>
        <text x="956.949" y="560.048" className="object-label">
          309
        </text>
        <text x="956.547" y="570.266" className="object-label">
          310
        </text>
        <text x="948.657" y="673.733" className="object-label">
          316
        </text>
        <text x="948.917" y="661.794" className="object-label">
          315
        </text>
        <text x="923.874" y="765.935" className="object-label">
          290
        </text>
        <text x="925.82" y="750.133" className="object-label">
          289
        </text>
        <text x="912.429" y="898.374" className="object-label">
          297
        </text>
        <text x="914.745" y="867.933" className="object-label">
          295
        </text>
        <text x="913.571" y="883.358" className="object-label">
          296
        </text>
        <text x="935.734" y="817.426" className="object-label">
          320
        </text>
        <text x="936.66" y="807.174" className="object-label">
          319
        </text>
        <text x="933.821" y="876.929" className="object-label">
          322
        </text>
        <text x="933.815" y="885.82" className="object-label">
          323
        </text>
        <text x="932.826" y="898.87" className="object-label">
          324
        </text>
        <text x="927.671" y="927.469" className="object-label">
          326
        </text>
        <text x="928.701" y="914.201" className="object-label">
          325
        </text>
        <text x="926.931" y="962.951" className="object-label">
          328
        </text>
        <text x="928.077" y="944.203" className="object-label">
          327
        </text>
        <text x="950.335" y="968.947" className="object-label">
          360
        </text>
        <text x="953.066" y="944.439" className="object-label">
          358
        </text>
        <text x="952.079" y="953.271" className="object-label">
          359
        </text>
        <text x="948.487" y="925.771" className="object-label">
          356
        </text>
        <text x="949.158" y="916.917" className="object-label">
          355
        </text>
        <text x="1019.641" y="603.183" className="object-label">
          388
        </text>
        <text x="1020.368" y="587.437" className="object-label">
          387
        </text>
        <text x="1011.861" y="696.959" className="object-label">
          393
        </text>
        <text x="984.184" y="787.438" className="object-label">
          369
        </text>
        <text x="984.321" y="811.869" className="object-label">
          371
        </text>
        <text x="985.83" y="798.272" className="object-label">
          370
        </text>
        <text x="972.972" y="832.544" className="object-label">
          372
        </text>
        <text x="1002.654" y="905.931" className="object-label">
          402
        </text>
        <text x="1002.772" y="889.783" className="object-label">
          401
        </text>
        <text x="1069.837" y="676.218" className="object-label">
          444
        </text>
        <text x="1073.419" y="652.09" className="object-label">
          442
        </text>
        <text x="1071.255" y="667.196" className="object-label">
          443
        </text>
        <text x="1046.298" y="881.77" className="object-label">
          454
        </text>
        <text x="1047.021" y="867.061" className="object-label">
          453
        </text>
        <text x="1038.855" y="933.22" className="object-label">
          457
        </text>
        <text x="1040.637" y="905.804" className="object-label">
          455
        </text>
        <text x="1039.782" y="918.895" className="object-label">
          456
        </text>
        <text x="1036.287" y="980.973" className="object-label">
          459
        </text>
        <text x="1037.229" y="958.054" className="object-label">
          458
        </text>
        <text x="1066.096" y="891.085" className="object-label">
          481
        </text>
        <text x="1067.237" y="869.462" className="object-label">
          480
        </text>
        <text x="1070.859" y="830.805" className="object-label">
          478
        </text>
        <text x="1071.673" y="818.628" className="object-label">
          477
        </text>
        <text x="1072.366" y="809.276" className="object-label">
          476
        </text>
        <text x="1075.182" y="795.024" className="object-label">
          475
        </text>
        <text x="1077.924" y="780.104" className="object-label">
          474
        </text>
        <text x="1090.48" y="698.408" className="object-label">
          470
        </text>
        <text x="1105.157" y="626.365" className="object-label">
          466
        </text>
        <text x="1106.55" y="617.001" className="object-label">
          465
        </text>
        <text x="1089.674" y="851.594" className="object-label">
          501
        </text>
        <text x="1090.635" y="836.443" className="object-label">
          500
        </text>
        <text x="1085.678" y="924.513" className="object-label">
          506
        </text>
        <text x="1087.563" y="907.086" className="object-label">
          504
        </text>
        <text x="1086.432" y="917.535" className="object-label">
          505
        </text>
        <text x="1107.649" y="954.685" className="object-label">
          531
        </text>
        <text x="1108.103" y="946.203" className="object-label">
          530
        </text>
        <text x="1109.296" y="937.173" className="object-label">
          529
        </text>
        <text x="1110.167" y="926.48" className="object-label">
          528
        </text>
        <text x="1111.021" y="915.932" className="object-label">
          527
        </text>
        <text x="1121.915" y="852.766" className="object-label">
          524
        </text>
        <text x="1120.432" y="835.544" className="object-label">
          523
        </text>
        <text x="1129.137" y="799.146" className="object-label">
          522
        </text>
        <text x="1130.909" y="782.459" className="object-label">
          521
        </text>
        <text x="1165.481" y="922.584" className="object-label">
          559
        </text>
        <text x="1165.21" y="908.119" className="object-label">
          558
        </text>
        <text x="1164.977" y="895.708" className="object-label">
          557
        </text>
        <text x="1166.872" y="861.417" className="object-label">
          555
        </text>
        <text x="1167.14" y="846.149" className="object-label">
          554
        </text>
        <text x="1169.139" y="805.525" className="object-label">
          552
        </text>
        <text x="1167.622" y="826.774" className="object-label">
          553
        </text>
        <text x="1205.92" y="912.943" className="object-label">
          583
        </text>
        <text x="1206.717" y="897.047" className="object-label">
          582
        </text>
        <text x="1226.1" y="978.532" className="object-label">
          607
        </text>
        <text x="1225.5" y="964.162" className="object-label">
          606
        </text>
        <text x="1042.62" y="410.54" className="object-label">
          361
        </text>
        <text x="1127.392" y="634.397" className="object-label">
          490
        </text>
        <text x="1131.339" y="613.64" className="object-label">
          489
        </text>
        <text x="1110.208" y="592.216" className="object-label">
          463
        </text>
        <text x="1108.044" y="570.876" className="object-label">
          462
        </text>
        <text x="1110.503" y="550.004" className="object-label">
          461
        </text>
        <text x="1113.584" y="528.893" className="object-label">
          460
        </text>
        <text x="1087.193" y="525.496" className="object-label">
          436
        </text>
        <text x="1090.627" y="499.067" className="object-label">
          435
        </text>
        <text x="1069.362" y="466.234" className="object-label">
          407
        </text>
        <text x="1066.764" y="483.957" className="object-label">
          408
        </text>
        <text x="1056.069" y="441.05" className="object-label">
          380
        </text>
        <text x="1156.356" y="630.878" className="object-label">
          512
        </text>
        <text x="1151.894" y="641.451" className="object-label">
          513
        </text>
        <text x="1144.416" y="700.599" className="object-label">
          517
        </text>
        <text x="1171.48" y="780.087" className="object-label">
          551
        </text>
        <text x="1164.871" y="724.101" className="object-label">
          539
        </text>
        <text x="1168.015" y="696.057" className="object-label">
          538
        </text>
        <text x="1171.234" y="675.77" className="object-label">
          537
        </text>
        <text x="1177.853" y="655.239" className="object-label">
          536
        </text>
        <text x="1199.856" y="699.782" className="object-label">
          567
        </text>
        <text x="1198.849" y="715.074" className="object-label">
          568
        </text>
        <text x="1194.388" y="780.891" className="object-label">
          571
        </text>
        <text x="1192.268" y="804.462" className="object-label">
          572
        </text>
        <text x="1229.852" y="780.102" className="object-label">
          595
        </text>
        <text x="1139.05" y="571.162" className="object-label">
          486
        </text>
        <text x="1134.458" y="595.329" className="object-label">
          488
        </text>
        <text x="1141.701" y="556.758" className="object-label">
          485
        </text>
        <text x="1136.769" y="581.129" className="object-label">
          487
        </text>
        <text x="1147.969" y="678.641" className="object-label">
          516
        </text>
        <text x="1149.85" y="664.395" className="object-label">
          515
        </text>
        <text x="1150.848" y="651.609" className="object-label">
          514
        </text>
        <text x="1159.445" y="613.324" className="object-label">
          511
        </text>
        <text x="1162.888" y="594.832" className="object-label">
          510
        </text>
        <text x="1196.252" y="754.427" className="object-label">
          570
        </text>
        <text x="1197.307" y="732.375" className="object-label">
          569
        </text>
        <text x="1186.207" y="605.341" className="object-label">
          534
        </text>
        <text x="1182.414" y="630.188" className="object-label">
          535
        </text>
        <text x="1203.469" y="655.366" className="object-label">
          565
        </text>
        <text x="1201.676" y="677.317" className="object-label">
          566
        </text>
        <text x="1230.938" y="757.494" className="object-label">
          594
        </text>
        <text x="1232.388" y="735.83" className="object-label">
          593
        </text>
        <text x="1189.438" y="839.975" className="object-label">
          574
        </text>
        <text x="1209.042" y="858.744" className="object-label">
          581
        </text>
        <text x="1230.311" y="857.858" className="object-label">
          599
        </text>
        <text x="1229.067" y="804.082" className="object-label">
          596
        </text>
        <text x="1233.147" y="713.213" className="object-label">
          592
        </text>
        <text x="1234.907" y="689.422" className="object-label">
          591
        </text>
        <text x="1236.374" y="665.802" className="object-label">
          590
        </text>
        <text x="1237.774" y="642.95" className="object-label">
          589
        </text>
        <text x="1239.086" y="618.756" className="object-label">
          588
        </text>
        <text x="1205.48" y="631.302" className="object-label">
          564
        </text>
        <text x="1206.739" y="614.175" className="object-label">
          563
        </text>
        <text x="1227.511" y="948.372" className="object-label">
          605
        </text>
        <text x="1227.685" y="930.857" className="object-label">
          604
        </text>
        <text x="1227.999" y="903.821" className="object-label">
          602
        </text>
        <text x="1228.95" y="877.428" className="object-label">
          600
        </text>
        <text x="1228.434" y="891.841" className="object-label">
          601
        </text>
        <text x="1229.134" y="838.568" className="object-label">
          598
        </text>
        <text x="1230.032" y="826.049" className="object-label">
          597
        </text>
        <text x="1228.339" y="915.052" className="object-label">
          603
        </text>
        <text x="658.59" y="829.632" className="object-label">
          33
        </text>
        <text x="682.813" y="847.533" className="object-label">
          45
        </text>
        <text x="680.414" y="856.588" className="object-label">
          46
        </text>
        <text x="679.475" y="865.474" className="object-label">
          47
        </text>
        <text x="725.407" y="889.414" className="object-label">
          91
        </text>
        <text x="787.001" y="985.351" className="object-label">
          158
        </text>
        <text x="729.962" y="771.535" className="object-label">
          84
        </text>
        <text x="751.279" y="772.788" className="object-label">
          103
        </text>
        <text x="760.572" y="777.413" className="object-label">
          104
        </text>
        <text x="776.416" y="764.905" className="object-label">
          125
        </text>
        <text x="779.318" y="779.997" className="object-label">
          126
        </text>
        <text x="778.009" y="756.922" className="object-label">
          124
        </text>
        <text x="778.47" y="748.093" className="object-label">
          123
        </text>
        <text x="777.452" y="738.733" className="object-label">
          122
        </text>
        <text x="812.113" y="722.443" className="object-label">
          146
        </text>
        <text x="812.913" y="731.505" className="object-label">
          147
        </text>
        <text x="823.064" y="768.226" className="object-label">
          170
        </text>
        <text x="843.093" y="751.36" className="object-label">
          190
        </text>
        <text x="820.065" y="785.372" className="object-label">
          171
        </text>
        <text x="883.099" y="645.043" className="object-label">
          239
        </text>
        <text x="885.324" y="637.102" className="object-label">
          238
        </text>
        <text x="901.435" y="656.105" className="object-label">
          265
        </text>
        <text x="931.741" y="680.446" className="object-label">
          285
        </text>
        <text x="901.298" y="785.071" className="object-label">
          276
        </text>
        <text x="954.328" y="839.061" className="object-label">
          350
        </text>
        <text x="894.449" y="877.878" className="object-label">
          279
        </text>
        <text x="956.255" y="869.031" className="object-label">
          352
        </text>
        <text x="955.883" y="876.548" className="object-label">
          353
        </text>
        <text x="1028.209" y="870.861" className="object-label">
          430
        </text>
        <text x="1050.07" y="845.547" className="object-label">
          451
        </text>
        <text x="1034.856" y="784.099" className="object-label">
          425
        </text>
        <text x="1009.141" y="752.383" className="object-label">
          367
        </text>
        <text x="1080.333" y="742.054" className="object-label">
          472
        </text>
        <text x="1108.308" y="744.264" className="object-label">
          495
        </text>
        <text x="1105.767" y="762.613" className="object-label">
          496
        </text>
        <text x="1205.831" y="958.97" className="object-label">
          585
        </text>
        <text x="1190.168" y="823.234" className="object-label">
          573
        </text>
        <text x="987.294" y="509.5" className="object-label">
          334
        </text>
        <text x="1034.081" y="499.883" className="object-label">
          383
        </text>
        <text x="1038.35" y="483.36" className="object-label">
          382
        </text>
        <text x="882.303" y="434.958" className="object-label">
          180
        </text>
        <text x="709.293" y="775.992" className="object-label">
          62
        </text>
        <text x="709.428" y="782.912" className="object-label">
          63
        </text>
        <text x="710.884" y="789.978" className="object-label">
          64
        </text>
        <text x="712.662" y="804.641" className="object-label">
          65
        </text>
        <text x="733.139" y="780.897" className="object-label">
          85
        </text>
        <text x="909.515" y="404.991" className="object-label">
          219
        </text>
        <text x="906.897" y="420.2" className="object-label">
          220
        </text>
        <text x="902.696" y="445.667" className="object-label">
          221
        </text>
        <text x="899.904" y="462.03" className="object-label">
          222
        </text>
        <text x="894.944" y="481.073" className="object-label">
          223
        </text>
        <text x="892.427" y="497.683" className="object-label">
          224
        </text>
        <g>
          <path
            id="3057"
            d="M710.495 689.663l-.238-12.816-18.27.342.24 12.815z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3001"
            d="M661.265 627.629l.74-16.918-19.505-.967-.74 16.917z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3002"
            d="M659.429 644.962l1.479-15.051-19.565-1.952-1.479 15.052z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3003"
            d="M657.996 661.963l.884-14.133-19.654-1.107-.884 14.133z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3004"
            d="M655.272 690.144l1.835-16.723-20.057-2.198-1.821 16.73z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3005"
            d="M652.392 718.944l1.654-13.51-19.896-2.287-1.655 13.509z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3012"
            d="M642.385 815.894l.969-9.317-18.192-1.933-.968 9.317z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3015"
            d="M638.188 858.525l1.401-14.041-19.743-1.913-1.395 14.029z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3016"
            d="M636.689 877.865l1.669-17.49-20.012-1.84-1.67 17.489z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3017"
            d="M634.343 903.53l.826-16.958-20.541-1.025-.836 16.963z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3018"
            d="M632.166 916.838l.708-10.356-19.303-1.331-.702 10.342z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3019"
            d="M630.715 939.56l1.116-16.744-19.938-1.37-1.12 16.734z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3020"
            d="M629.25 961.237l1.411-17.615-20.415-1.768-1.408 17.624z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3021"
            d="M625.99 980.58l1.387-15.382-18.279-1.405-1.387 15.38z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3038"
            d="M655.466 953.452l1.207-16.708-19.361-1.334-1.207 16.708z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3037"
            d="M657.135 932.46l1.057-16.328-19.536-1.351-1.057 16.328z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3036"
            d="M664.342 911.608l1.084-21.375-20.403-1.377-1.07 21.38z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3035"
            d="M666.392 876.625l.579-16.24-19.547-.603-.569 16.237z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3034"
            d="M668.562 860.056l.434-21.035-22.489-.425-.434 21.035z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3032"
            d="M669.319 822.983l.87-19.46-20.167-.793-.86 19.456z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3031"
            d="M671.317 803.616l2.039-28.461-20.136-1.223-2.048 28.466z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3028"
            d="M679.787 752.787l3.913-17.954-20.529-4.395-3.923 17.958z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3027"
            d="M685.976 727.681l1.323-17.607-19.798-1.452-1.32 17.616z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3022"
            d="M687.464 645.094l1.393-27.266-20.88-.962-1.388 27.252z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3056"
            d="M710.602 674.66l1.347-23.67-18.827-1-1.347 23.67z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3059"
            d="M712.1 724.988l.54-19.209-20.114-.608-.55 19.212z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3060"
            d="M711.725 742.072l.269-16.742-20.224-.277-.27 16.743z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3061"
            d="M710.351 763.751l.371-16.676-19.36-.487-.38 16.68z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3041"
            d="M691.18 782.75l.62-5.457-14.486-1.02-.619 5.456z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3044"
            d="M687.225 837.654l.747-15.012-18.24-.842-.752 15.001z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3048"
            d="M690.185 897.175l1.853-22.704-20.474-1.545-1.852 22.704z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3049"
            d="M685.283 916.084l1.603-15.67-18.147-1.87-1.602 15.67z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3050"
            d="M682.405 937.756l1.844-16.274-19.163-2.193-1.84 16.284z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3066"
            d="M717.091 825.66l1.556-14.118-18.553-1.93-1.565 14.12z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3067"
            d="M709.318 837.426l.818-9.163-18.155-1.99-.819 9.163z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3070"
            d="M713.397 898.862l1.674-21.14-15.623-1.596-1.665 21.136z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3071"
            d="M710.303 926.663l2.873-16.824-19.615-3.425-2.862 16.82z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3072"
            d="M707.895 943.066l2.874-15.876-19.367-3.364-2.875 15.876z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3073"
            d="M702.625 975.093l.395-15.34-18.023-.445-.396 15.34z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3051"
            d="M678.86 956.216l.097-7.15-17.733-.161-.1 7.14z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3052"
            d="M679.547 973.822l.068-17.124-19.948-.101-.068 17.124z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3053"
            d="M678.84 990.277l.126-15.53-19.645-.364-.117 15.525z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3074"
            d="M702.94 990.627l-.033-12.549-18.321-.295.029 12.538z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3076"
            d="M719.747 634.01l-.513 14.127 20.487.739.513-14.128z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3079"
            d="M737.513 683.338l-.868 17.617-20.911-1.212.868-17.617z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3080"
            d="M714.955 717.488l.465-14.981 20.365.78-.47 14.995z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3083"
            d="M719.117 764.143l.137-18.515 19.509.266-.137 18.515z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3086"
            d="M724.35 798.5l.203-9.763 19.142.122-.197 9.749z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3089"
            d="M714.841 855.461l2.586-23.615 19.534 2.415-2.586 23.614z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3090"
            d="M713.368 874.712l1.524-15.18 18.085 1.756-1.525 15.18z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3092"
            d="M718.421 914.88l1.808-16.217 17.596 1.587-1.807 16.216z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3093"
            d="M712.335 932.79l1.72-16.921 19.663 2.166-1.714 16.907z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3094"
            d="M707.03 962.151l.509-17.933 20.644.187-.52 17.936z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3095"
            d="M726.187 987.422l.746-16.897-19.62-1.04-.752 16.91z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3115"
            d="M732.074 987.947l.733-10.511 18.435 1.17-.734 10.512z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3114"
            d="M732.347 975.79l1.709-18.284 19.65 1.708-1.713 18.273z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3113"
            d="M734.162 954.566l.785-16.233 19.306 1.567-.781 16.244z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3112"
            d="M738.292 925.365l1.222-16.114 19.502 1.285-1.222 16.114z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3111"
            d="M742.014 907.025l1.155-19.096 16.039.616-1.165 19.099z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3110"
            d="M736.148 885.574l.783-8.812 18.028 1.82-.773 8.81z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3107"
            d="M752.653 828.627l.828-11.764 17.378 1.64-.842 11.757z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3106"
            d="M754.328 813.586l.519-14.92 18.218.127-.526 14.934z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3105"
            d="M757.441 794.633l.178-12.723 15.678.131-.181 12.713z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3163"
            d="M822.605 645.8l.61-19.686 19.5.404-.61 19.685z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3164"
            d="M822.656 664.824l.534-18.901 18.267.528-.53 18.912z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3169"
            d="M812.618 760.159l.673-16.07 18.821 1.341-.673 16.07z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3168"
            d="M816.619 738.141l.046-6.126 12.88.857-.049 6.116z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3167"
            d="M816.751 720.78l.154-9.417 18.055.309-.144 9.413z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3102"
            d="M742.534 764.833l.769-15.47 19.695 1.16-.758 15.467z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3101"
            d="M744.24 749.555l.441-8.105 17.954.796-.432 8.102z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3182"
            d="M859.548 598.18l1.281-12.702 16.533 1.71-1.292 12.704z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3183"
            d="M851.926 626.857l3.09-26.478 21.11 2.103-2.764 26.511z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3184"
            d="M849.979 643.19l1.796-15.015 18.511 2.104-1.796 15.015z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3261"
            d="M902.12 594.808l.822-10.159 19.027 2.354-.823 10.158z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3260"
            d="M903.012 582.807l1.992-16.53 19.133 1.944-1.992 16.53z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3259"
            d="M908.811 563.133l1.718-16.084 17.224 1.977-1.715 16.093z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3258"
            d="M921.12 543.08l1.744-14.84 17.974 2.02-1.745 14.84z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3139"
            d="M823.806 441.733l2.683-21.943 19.604 2.616-2.683 21.943z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3162"
            d="M843.92 457.522l2.924-17.78 19.779 3.12-2.92 17.79z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3181"
            d="M866.788 460.56l3.363-16.973 19.384 3.8-3.36 16.982z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3179"
            d="M872.79 423.952l2.575-15.343 18.957 2.932-2.561 15.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3178"
            d="M874.98 407.309l2.561-15.35 21.344 3.298-2.572 15.353z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3264"
            d="M899.381 646.396l2.051-18.921 19.986 2.155-2.061 18.925z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3266"
            d="M884.703 683.032l4.445-17.756 18.996 4.826-4.445 17.757z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3270"
            d="M906.637 677.743l5.058-25.662 19.259 3.764-5.072 25.655z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3271"
            d="M911.458 687.37l.856-4.16 11.47 2.839-.855 4.16z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3272"
            d="M900.29 706.417l4.255-18.66 20.2 4.361-4.254 18.661z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3287"
            d="M942.394 712.47l.533-4.5-10.186-.87-.533 4.501z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3286"
            d="M924.446 691.906l1.206-7.4 15.197 2.479-1.197 7.397z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3269"
            d="M921.856 637.926l.751-15.261 16.536 1.233-.75 15.261z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3268"
            d="M921.094 619.52l2.087-17.488 19.796 2.323-2.097 17.492z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3267"
            d="M923.291 590.055l1.827-24.886 19.145 1.07-1.827 24.886z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3362"
            d="M1025.092 435.048l3.887-16.636 18.282 3.946-3.887 16.635z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3363"
            d="M1018.814 437.358l-5.753 17.015 18.54 5.854 5.754-17.014z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3364"
            d="M1005.629 474.58l6.792-19.872 20.2 6.859-6.792 19.872z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3365"
            d="M999.136 498.392l4.772-18.796 19.76 4.46-4.772 18.795z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3330"
            d="M1010.597 415.608l1.767-17.174 19.906 2.443-1.758 17.17z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3331"
            d="M1003.432 430.29l6.238-14.066 16.371 7.311-6.228 14.063z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3332"
            d="M987.421 459.789l3.656-15.968 18.64 4.261-3.669 15.961z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3333"
            d="M982.613 477.378l4.133-16.835 19.238 4.776-4.133 16.835z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3335"
            d="M973.72 533.481l1.023-16.428 20.196 1.268-1.012 16.425z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3336"
            d="M972.661 549.866l.689-16.38 20.716 1.268-.679 16.377z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3337"
            d="M973.742 575.287l.07-14.945 20.019.043-.057 14.952z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3338"
            d="M972.568 592.673l.744-16.773 20.696.79-.757 16.766z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3339"
            d="M972.493 604.265l.636-11.28 19.504 1.228-.629 11.265z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3341"
            d="M967.934 652.602l1.345-18.258 20.61 1.486-1.354 18.261z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3340"
            d="M970.881 628.308l1.58-22.869 19.653 1.198-1.59 22.873z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3342"
            d="M972.552 667.778l.516-10.356 19.75 1.345-.52 10.347z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3343"
            d="M971.831 677.45l.618-9.546 20.068 1.223-.625 9.525z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3344"
            d="M972.067 689.057l.548-11.011 18.69.8-.545 11.021z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3345"
            d="M970.813 706.052l1.254-16.995 18.65 1.074-1.371 17.374z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3346"
            d="M969.482 725.39l1.308-16.777 18.825 1.351-1.308 16.777z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3318"
            d="M943.483 714.756l.685-6.337 16.847 2.322-.68 6.347z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3317"
            d="M942.728 706.458l4.536-26.383 20.037 3.21-4.532 26.393z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3314"
            d="M939.86 651.807l.407-17.48 21.179.78-.404 17.49z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3313"
            d="M943.005 632.165l.585-13.272 19.616 1.482-.589 13.262z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3312"
            d="M943.461 617.842l1.77-29.328 20.746 1.157-1.771 29.328z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3308"
            d="M946.867 550.784l.742-17.2 20.286 1.203-.742 17.2z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3307"
            d="M947.458 531.92l1.583-17.382 20.346 1.86-1.576 17.368z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3306"
            d="M949.295 510.339l1.746-13.733 20.05 3.929-1.746 13.732z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3305"
            d="M952.328 495.728l4.328-17.478 20.322 4.84-4.328 17.478z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3304"
            d="M956.849 478.059l4.055-16.638 19.237 4.709-4.055 16.638z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3303"
            d="M961.472 459.744l6.097-19.37 20.511 6.388-6.107 19.374z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3302"
            d="M978.141 439.888l1.714-15.19 18.341 2.04-1.707 15.175z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3301"
            d="M982.068 422.166l2.28-26.05 19.174 1.738-2.29 26.053z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3494"
            d="M1100.014 730.501l4.725-31.385 21.206 3.323-4.716 31.382z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3493"
            d="M1106.802 698.262l2.42-15.887 19.545 3.031-2.42 15.888z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3492"
            d="M1109.768 680.863l3.127-16.156 18.965 3.73-3.128 16.157z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3491"
            d="M1113.284 662.482l3.284-16.742 19.453 3.673-3.295 16.746z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3473"
            d="M1067.893 760.9l3.397-16.714 18.82 3.611-3.39 16.7z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3471"
            d="M1074.937 727.803l4.503-20.961 18.601 4.05-4.517 20.954z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3469"
            d="M1088.277 665.08l-5.638 24.383 18.77 4.894 6.133-24.816z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3468"
            d="M1088.801 663.892l3.235-15.234 21.963 4.72-3.234 15.233z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3467"
            d="M1095.979 642.597l1.301-5.863 13.225 2.85-1.308 5.876z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3464"
            d="M1098.441 608.702l1.265-10.086 19.61 2.5-1.262 10.097z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3447"
            d="M1043.533 754.033l5.766-27.523 19.16 3.967-5.77 27.513z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3446"
            d="M1050.368 723.45l3.005-15.403 19.297 3.84-3.016 15.407z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3445"
            d="M1052.058 696.193l4.66-18.531 19.369 4.889-4.658 18.542z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3441"
            d="M1065.837 638.004l2.315-18.912 20.431 2.463-2.3 18.918z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3440"
            d="M1069.723 618.025l1.663-10.372 18.03 2.509-1.662 10.372z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3439"
            d="M1071.45 606.377l2.389-15.876 18.275 2.92-2.57 15.68z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3438"
            d="M1073.735 587.284l3.353-23.78 19.549 2.782-3.347 23.766z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3437"
            d="M1071.813 554.486l2.954-19.507 21.953 3.424-2.955 19.508z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3409"
            d="M1048.421 506.97l2.868-14.405 18.636 3.179-2.867 14.405z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3410"
            d="M1044.581 528.605l2.794-17.927 20.552 2.94-2.793 17.927z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3411"
            d="M1033.677 563.588l2.041-20.41 20.327 1.935-2.042 20.41z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3412"
            d="M1029.689 576.43l.988-10.33 19.551 1.652-.992 10.319z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3413"
            d="M1052.863 577.655l3.651-18.383 19.347 4.05-3.651 18.382z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3414"
            d="M1046.106 608.72l3.47-17.349 19.45 4.025-3.469 17.348z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3415"
            d="M1041.08 635.997l4.528-22.676 19.1 3.729-4.519 22.672z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3416"
            d="M1038.004 660.572l2.037-19.03 19.44 1.985-2.036 19.029z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3421"
            d="M1022.728 739.795L1026 722.56l19.683 3.978-3.268 17.244z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3420"
            d="M1023.78 718.714l1.863-16.575 18.438 1.508-1.863 16.575z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3419"
            d="M1026.807 701.395l1.672-11.155 20.136 2.295-1.669 11.165z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3418"
            d="M1028.73 688.594l2.037-16.725 19.697 2.493-2.026 16.722z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3417"
            d="M1036.886 672.313l1.046-9.321 18.563 2.221-1.036 9.318z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3394"
            d="M1000.91 705.489l-2.722 20.792 19.823 2.303 2.567-20.717z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3392"
            d="M1002.29 682.045l1.448-15.888 18.596 1.442-1.444 15.898z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3391"
            d="M1004.615 662.418l1.286-16.418 18.822 1.927-1.285 16.419z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3390"
            d="M1006.867 642.84l.75-9.784 18.174 1.623-.75 9.783z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3389"
            d="M1008.264 631.702l.814-16.797 19.634 1.08-.81 16.807z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3386"
            d="M1008.051 574.883l.827-13.39 18.051 1.53-.83 13.38z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3385"
            d="M1008.778 558.06l3.208-17.935 19.482 3.562-3.198 17.932z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3384"
            d="M1011.68 539.148l4.157-33.47 22.35 2.914-4.143 33.475z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3381"
            d="M1036.414 472.23l2.759-18.446 19.238 2.766-2.759 18.445z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3236"
            d="M880.312 598.934l1.141-14.041 17.373 1.495-1.128 14.048z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3235"
            d="M882.94 580.5l1.676-16.656 19.484 1.912-1.677 16.657z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3234"
            d="M889.633 560.866l1.915-16.04 18.507 2.32-1.925 16.043z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3233"
            d="M893.565 543.548l2.518-17.582 19.791 2.765-2.518 17.582z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3237"
            d="M877.202 630.288l2.52-27.274 20.115 1.782-2.506 27.28z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3242"
            d="M863.562 705.744l1.1-6.731 14.893 2.156-1.115 6.724z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3243"
            d="M866.884 726.183l1.356-10.898 19.826 2.539-1.356 10.897z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3244"
            d="M864.938 745.599l1.886-15.34 18.757 2.063-1.877 15.337z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3245"
            d="M868.884 776.652l1.751-17.416 20.048 2.01-1.754 17.406z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3246"
            d="M872.296 799.715l1.586-15.846 18.881 1.805-1.58 15.833z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3247"
            d="M876.561 807.683l1.028-7.202 18.315 2.612-1.037 7.206z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3248"
            d="M872.932 824.116l2.954-16.265 19.152 3.687-2.953 16.266z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3249"
            d="M868.508 854.876l3.94-29.846 18.538 2.829-3.93 29.843z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3250"
            d="M866.953 872.01l1.07-15.643 18.056 1.45-1.07 15.642z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3212"
            d="M857.701 903.47l.345-12.308 18.69.381-.344 12.308z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3213"
            d="M857.165 919.898l.598-15.603 18.606.366-.598 15.603z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3177"
            d="M803.354 976.622l.647-17.766 19.28.65-.636 17.762z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3176"
            d="M803.615 955.444l2.01-29.096 19.835 1.237-2.01 29.095z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3198"
            d="M816.738 917.588l.999-16.624 20.38.82-1.003 16.614z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3197"
            d="M818.17 898.576l.421-11.181 18.336 1.86-.42 11.181z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3196"
            d="M817.905 885.747l2.07-18.803 19.539 2.073-2.07 18.804z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3195"
            d="M819.134 850.972l1.988-16.833 20.064 2.184-1.988 16.833z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3194"
            d="M832.05 818.327l2.164-16.296 17.799 2.33-2.164 16.295z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3193"
            d="M828.8 798.744l.98-10.157 18.407 2.095-.981 10.157z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3192"
            d="M829.267 786.789l1.814-19.573 20.69 1.876-1.823 19.576z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3191"
            d="M834.112 766.612l.624-8.067 17.963 1.696-.621 8.078z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3189"
            d="M835.995 742.892l1.456-14.468 18.5 1.848-1.456 14.468z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3188"
            d="M843.323 726.798l1.008-9.365 18.294 2.519-1.008 9.364z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3185"
            d="M849.126 658.16l.704-14.229 18.35 1.482-.703 14.228z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3100"
            d="M746.213 728.074l-.42-15.542 18.932-.189.424 15.553z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3099"
            d="M747.002 702.544l-.713-24.883 18.864-.447.724 24.879z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3098"
            d="M744.742 671.761l-.135-18.747 20.623.092.135 18.748z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3118"
            d="M770.199 667.539l.202-12.653 22.074.92-.202 12.652z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3119"
            d="M776.127 682.518l-.146-10.668 18.964.128.15 10.678z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3120"
            d="M774.494 702.48l.476-16.927 20.58.39-.473 16.937z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3121"
            d="M769.204 730.945l-.329-16.512 19.361-.19.329 16.51z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3127"
            d="M775.56 832.102l.666-15.637 18.338.83-.664 15.639z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3128"
            d="M763.884 851.959l2.237-17.936 20.38 2.64-2.237 17.935z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3131"
            d="M771.483 899.338l1.043-14.617 19.634 1.374-1.046 14.607z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3132"
            d="M760.624 916.03l1.584-16.76 18.987 1.848-1.588 16.75z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3135"
            d="M756.059 959.128l1.448-16.566 19.193 1.37-1.442 16.552z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3136"
            d="M755.045 976.977l1.049-17.228 19.347 1.1-1.038 17.226z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3157"
            d="M777.225 975.702l1.686-17.992 19.926 2.176-1.683 18.003z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3156"
            d="M778.3 955.596l.871-15.043 21.622 1.404-.882 15.047z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3153"
            d="M785.384 913.698l1.007-9.951 14.993 1.082-.998 9.948z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3175"
            d="M794.263 893.461l1.611-16.713 19.288 1.935-1.608 16.723z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3174"
            d="M793.234 869.976l1.76-16.415 19.51 1.891-1.76 16.415z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3173"
            d="M798.812 847.364l1.737-17.65 20.385 1.486-1.737 17.649z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3172"
            d="M804.251 825.263l.356-9.974 19.774.705-.356 9.973z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3148"
            d="M790.692 748.604l-.511-17.329 20.013-.587.501 17.332z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3145"
            d="M790.048 727.684l.547-18.928 21.384.234-.547 18.928z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3497"
            d="M1088.85 796.85l1.306-16.392 19.483 1.653-1.316 16.395z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3498"
            d="M1084.64 816.772l-.103-16.511 18.381-.28.103 16.512z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3499"
            d="M1081.599 826.562l-.162-8.833 18.173-.489.162 8.833z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3502"
            d="M1077.726 880.116l1.296-17.394 18.894 1.191-1.296 17.394z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3503"
            d="M1075.966 895.107l1.669-12.757 18.541 2.647-1.678 12.76z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3507"
            d="M1075.195 949.23l.242-19.218 19.398.01-.243 19.219z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3508"
            d="M1076.96 975.384l.532-16.28 19.226.782-.542 16.284z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3509"
            d="M1076.513 992.392l.504-15.582 18.319.578-.504 15.582z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3484"
            d="M1055.163 957.81l-.565 17.771 18.904.702.562-17.781z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3483"
            d="M1051.465 944.56l.283-8.851 18.557.258-.287 8.842z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3482"
            d="M1049.896 933.18l1.098-15.823 18.592 1.658-1.097 15.822z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3479"
            d="M1058.632 856.81l1.239-16.876 18.897 1.461-1.242 16.867z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3347"
            d="M952.467 761.506l7.755-26.544 18.459 5.262-7.759 26.535z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3348"
            d="M946.324 799.428l4.305-33.306 20.635 2.72-4.299 33.292z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3349"
            d="M945.097 821.722l.876-17.044 19.766 1.102-.876 17.044z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3351"
            d="M943.037 861.475l1.495-16.435 18.733 2.128-1.494 16.435z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3354"
            d="M946.266 900.91l.634-15.175 18.336.889-.63 15.185z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3357"
            d="M943.335 937.352l.58-6.933 20.745 3.008-.579 6.934z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3329"
            d="M916.114 988.046l1.035-15.258 18.922 1.114-1.034 15.258z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3448"
            d="M1044.956 793.408l3.835-24.862 20.258 2.84-3.824 24.858z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3449"
            d="M1041.335 814.277l1.72-15.756 18.344 2.049-1.715 15.766z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3450"
            d="M1039.93 835.832l.912-17.102 19.72 1.197-.909 17.112z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3452"
            d="M1039.732 857.87l.676-10.447 18.181 1.124-.68 10.436z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3434"
            d="M1000.607 989.232l.52-10.346 19.588.95-.516 10.356z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3433"
            d="M1005.061 977.21l1.147-17.205 19.327 1.108-1.153 17.22z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3432"
            d="M1007.263 954.114l.854-15.873 16.391 1.272-.854 15.873z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3431"
            d="M1015.163 896.3l.427-19.372 19.297.406-.426 19.373z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3429"
            d="M1019.962 857.729l.519-19.462 19.32.761-.52 19.461z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3428"
            d="M1021.537 837.278l.4-5.855 15.992.61-.404 5.845z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3427"
            d="M1023.262 826.727l.553-6.326 13.093 1.11-.553 6.326z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3426"
            d="M1020.402 811.672l1.614-15.346 18.194 1.909-1.613 15.347z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3424"
            d="M1027.66 776.92l.843-9.905 19.3 2.586-.853 9.91z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3423"
            d="M1030.486 764.958l1.48-7.428 17.88 3.928-1.48 7.427z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3422"
            d="M1015.379 765.882l1.751-8.528 12.37 3.215-1.742 8.524z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3395"
            d="M990.584 781.801l3.413-18.221 18.809 3.378-3.417 18.212z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3396"
            d="M995.007 806.827l1.19-18.023 19.488 1.537-1.196 18.037z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3397"
            d="M993.35 825.42l1.716-17.97 19.822 1.523-1.717 17.97z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3398"
            d="M998.686 844.637l1.606-18.45 19.323 1.55-1.606 18.45z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3399"
            d="M993.806 860.365l.14-13.964 18.214.276-.141 13.964z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3400"
            d="M992.802 879.927l.187-17.527 19.968.287-.194 17.54z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3403"
            d="M992.806 934.074l.478-19.549 18.7.536-.479 19.549z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3404"
            d="M987.877 952.744l1.388-16.613 18.717 1.626-1.387 16.612z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3405"
            d="M983.3 970.637l1.963-17.616 21.26 2.243-1.965 17.615z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3406"
            d="M975.177 986.624l1.826-16.585 19.295 1.922-1.836 16.621z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3379"
            d="M964.344 968.586l2.367-19.507 18.215 1.936-2.377 19.51z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3378"
            d="M970.14 933.53l.206-5.505 16.445.937-.2 5.491z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3377"
            d="M960.517 924.287l.678-17.71 17.37.615-.677 17.71z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3376"
            d="M964.681 902.415l1.04-22.67 19.107.994-1.04 22.67z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3375"
            d="M966.494 875.964l.62-18.231 19.616.51-.62 18.232z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3374"
            d="M967.108 854.538l.557-11.602 19.817 1.085-.557 11.602z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3373"
            d="M980.607 841.536l1-16.33 18.249 1.19-1 16.33z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3368"
            d="M976.485 757.66l1.608-5.145 12.764 3.732-1.608 5.146z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3366"
            d="M977.885 751.627l5.504-16.239 19.022 6.23-5.504 16.239z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3321"
            d="M922.413 838.318l2.554-17.933 19.478 2.739-2.55 17.943z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3288"
            d="M917.847 738.638l1.766-10.531 19.155 3.11-1.762 10.542z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3291"
            d="M908.244 789.715l2.34-16.436 18.99 2.536-2.341 16.436z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3292"
            d="M901.913 809.517l1.655-12.278 18.967 2.702-1.654 12.278z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3293"
            d="M899.864 829.093l2.891-14.143 19.378 3.914-2.9 14.147z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3294"
            d="M906.23 858.886l1.587-15.97 18.755 1.669-1.588 15.97z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3298"
            d="M897.986 932.972l2.072-21.652 18.729 1.758-1.883 21.675z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3299"
            d="M896.18 950.622l1.406-16.009 18.934 1.437-1.406 16.009z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3300"
            d="M894.394 982.305l.635-29.475 19.454.691-.646 29.479z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3284"
            d="M874.287 986.71l.767-15.02 18.006.428-.77 15.009z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3283"
            d="M875.426 946.193l-1.042 22.275 19.214.685 1.038-22.285z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3282"
            d="M876.624 944.963l1.482-17.346 19.082 1.735-1.482 17.346z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3281"
            d="M878.899 919.807l3.732-23.144 19.187 3.01-3.728 23.153z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3280"
            d="M883.839 896.175l1.878-16.727 17.848 2.244-1.878 16.727z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3278"
            d="M886.709 863.775l1.597-15.522 18.293 1.672-1.47 15.534z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3277"
            d="M890.924 828.558l-2.125 16.7 18.29 2.181 2.094-16.463z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3275"
            d="M892.589 769.832l1.368-10.992 17.863 1.867-1.364 11.002z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3274"
            d="M892.213 757.855l1.907-16.613 18.854 2.279-1.9 16.598z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3273"
            d="M896.61 738.24l1.862-12.395 19.781 2.995-1.862 12.395z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3518"
            d="M1130.197 730.088l3.106-20.464 19.625 3.128-3.097 20.46z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3519"
            d="M1127.403 749.54l2.603-17.533 18.842 3.118-2.603 17.533z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3520"
            d="M1120.259 774.594l2.12-18.528 20.957 2.348-2.13 18.532z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3525"
            d="M1105.778 882.534l1.367-17.904 20.913 1.607-1.353 17.91z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3526"
            d="M1102.968 907.289l2.176-21.97 21.169 1.822-2.176 21.97z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3532"
            d="M1096.765 975.818l.923-16.519 19.191.975-.923 16.519z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3533"
            d="M1098.445 989.464l.183-11.054 18.22.523-.183 11.054z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3550"
            d="M1120.485 992.068l.506-12.59 18.234.789-.493 12.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3549"
            d="M1118.211 976.911l.6-15.92 19.235.711-.594 15.907z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3548"
            d="M1118.753 960.175l1.316-21.715 21.831 1.162-1.326 21.719z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3547"
            d="M1124.228 934.12l1.05-20.403 18.893.966-1.053 20.392z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3546"
            d="M1128.97 909.11l2.686-21.446 20.124 1.644-2.695 21.45z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3545"
            d="M1128.498 882.777l1.158-16.329 18.963 1.133-1.158 16.33z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3544"
            d="M1134.12 864.317l-.41-16.81 19.94-.54.41 16.81z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3543"
            d="M1135.176 844.579l-.536-15.39 17.933-.495.536 15.389z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3542"
            d="M1139.102 814.952l2.28-25.338 17.47 1.551-2.279 25.338z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3541"
            d="M1141.53 787.8l2.135-18.905 17.432 1.599-2.136 18.906z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3556"
            d="M1155.3 887.608l.111-17.682 20.69-.202-.108 17.692z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3560"
            d="M1144.759 952.858l-.55-17.18 19.81-.426.55 17.18z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3561"
            d="M1143.747 972.107l.453-16.863 19.617.544-.456 16.853z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3562"
            d="M1144.087 991.472l.44-15.503 18.409.706-.431 15.5z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3207"
            d="M850.86 800.595l.707-15.71 18.843.69-.708 15.71z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3208"
            d="M854.982 813.244l.86-8.783 18.519 1.865-.851 8.779z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3209"
            d="M853.582 829.691l1.368-14.527 17.322 1.738-1.371 14.518z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3540"
            d="M1147.321 759.738l2.025-16.078 18.909 2.304-2.026 16.078z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3575"
            d="M1177.174 879.132l.083-17.017 19.782-.02-.08 17.026z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3576"
            d="M1175.368 901.481l1.138-20.603 18.963.873-1.134 20.613z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3577"
            d="M1176.16 922.891l.63-16.224 19.01.654-.63 16.224z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3578"
            d="M1171.432 945.479l-.41-13.05 19.04-.622.421 13.046z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3579"
            d="M1173.7 964.286l-1.002-16.436 19.266-.203.999 16.425z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3580"
            d="M1168.711 986.32l.026-16.952 19.538-.106-.04 16.945z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3587"
            d="M1195.241 992.476l.27-10.316 18.424.587-.27 10.316z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3586"
            d="M1194.349 979.956l.456-18.897 18.887.493-.45 18.884z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3584"
            d="M1193.783 929.518l-.09 17.188 19.604-.332.098-17.203z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3138"
            d="M846.208 417.645l1.576-15.323-19.241-1.997-1.587 15.327z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3137"
            d="M828.543 400.325l1.604-15.502 19.242 1.997-1.605 15.502z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3161"
            d="M847.797 438.36l2.629-26.928 19.412 1.903-2.87 27.305z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3159"
            d="M852.07 394.617l.993-11.776 19.565 1.918-1.145 11.761z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3160"
            d="M869.838 413.335l1.645-16.815-19.413-1.903-1.644 16.815z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3007"
            d="M648.852 757.01l1.152-10.997-20.01-1.864-1.151 10.995z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3009"
            d="M648.033 766.951l-1.118 11.515-20.25-1.713 1.36-11.666z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3006"
            d="M629.995 744.149l2.197-22.43 20.25 1.714-2.438 22.58z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3008"
            d="M628.024 765.087l.819-9.943 20.009 1.865-.819 9.942z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3011"
            d="M625.042 802.224l.92-9.458 19.027 1.834-.91 9.454z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3010"
            d="M625.962 792.766l.963-9.981 19.027 1.834-.963 9.98z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3014"
            d="M620.611 840.712l1.54-14.259 19.79 2.178-1.553 14.253z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3013"
            d="M622.15 826.453l1.157-10.659 19.787 2.168-1.153 10.669z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3039"
            d="M655.2 955.736l-.228 16.863-18.985-.256-.001-16.999z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3040"
            d="M635.987 972.343l-.44 16.249 19.202.394.223-16.387z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3030"
            d="M654.514 771.81l2.61-10.148 19.512 5.009-2.61 10.148z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3029"
            d="M676.636 766.67l2.972-11.573-19.52-5.005-2.963 11.57z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3026"
            d="M666.95 705.448l.261-14.266 20.495.374-.43 14.268z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3025"
            d="M667.211 691.182l.247-13.335 20.654.375-.406 13.334z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3024"
            d="M666.592 674.84l.392-13.307 21.156.618-.382 13.303z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3023"
            d="M688.14 662.15l.39-13.248-21.156-.619-.39 13.25z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3055"
            d="M692.223 646.565l.806-14.422 21.595 1.2-.805 14.421z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3054"
            d="M693.029 632.143l.806-14.422 21.585 1.203-.796 14.419z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3058"
            d="M692.471 703.292l-.245-13.288 18.27-.341.244 13.288z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3043"
            d="M671.499 814.193l1.123-16.17 19.364 1.343-1.123 16.17z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3042"
            d="M672.622 798.023l1.108-15.826 19.364 1.343-1.108 15.826z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3069"
            d="M689.34 858.548l.417-5.805 17.725 1.305-.429 5.808z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3068"
            d="M689.757 852.743l1.05-14.111 17.714 1.308-1.039 14.108z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3088"
            d="M722.704 830.133l1.654-16.852 19.327 1.888-1.654 16.851z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3087"
            d="M724.358 813.281l1.448-14.781 19.328 1.887-1.449 14.781z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3082"
            d="M713.139 744.381l.491-13.703 22.23.911-.482 13.7z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3081"
            d="M713.63 730.678l.47-13.277 22.622.933-.862 13.255z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3078"
            d="M737.033 678.49l.67-13.189-20.166-1.02-.67 13.19z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3077"
            d="M717.537 664.282l.667-13.2 20.167 1.02-.667 13.199z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3075"
            d="M719.747 634.01l.59-14.2 20.486.738-.59 14.2z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3097"
            d="M765.81 650.396l.726-14.427-22.374-1.132-.725 14.428z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3096"
            d="M766.536 635.969l.728-14.418-22.374-1.131-.728 14.417z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3109"
            d="M756.252 874.609l1.825-15.68-19.444-2.254-1.815 15.677z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3108"
            d="M758.077 858.928l1.822-15.656-19.444-2.254-1.822 15.657z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3133"
            d="M777.852 931.186l1.082-12.982-18.589-1.354-1.426 12.966z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3134"
            d="M757.59 941.958l1.33-12.142 18.932 1.37-1.022 12.147z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3130"
            d="M781.873 870.046l-1.835 15.198-19.822-2.336 1.83-15.242z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3129"
            d="M781.873 870.046l1.81-15.042-19.83-2.39-1.807 15.052z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3152"
            d="M803.346 813.323l.317-15.438-19.52-.397-.32 15.428z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3151"
            d="M803.663 797.885l.316-15.505-19.52-.397-.316 15.505z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3150"
            d="M790.247 779.47l.39-15.226 19.523.499-.38 15.222z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3149"
            d="M810.16 764.743l.39-15.678-19.518-.489-.394 15.668z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3117"
            d="M767.034 648.265l.798-12.691 20.106 1.266-.786 12.404z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3116"
            d="M787.938 636.84l.8-12.782-20.118-.98-.788 12.496z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3144"
            d="M816.922 706.06l.258-13.824-19.962-.368-.258 13.824z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3143"
            d="M817.18 692.235l.262-13.972-19.962-.368-.262 13.973z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3142"
            d="M817.019 671.34l.514-16.072-20.425-.658-.528 16.065z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3140"
            d="M817.989 641.431l.508-15.763-20.428-.669-.518 15.768z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3141"
            d="M817.533 655.268l.456-13.837-20.438-.664-.443 13.843z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3166"
            d="M838.377 702.768l.62-14.923-19.414-.806-.617 14.932z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3165"
            d="M838.997 687.845l.677-16.511-19.41-.797-.681 16.502z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3155"
            d="M800.335 941.518l.79-12.1L781 928.124l-.776 12.108z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3154"
            d="M801.125 929.417l.899-14.058-20.113-1.287-.912 14.052z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3206"
            d="M853.223 760.838l-1.302 10.664 15.537 1.705 1.288-10.67z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3205"
            d="M852.057 760.182l.674-7.373 16.987 2.138-.972 7.59z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3187"
            d="M842.794 715.484l1.47-16.212 18.377 1.947-1.48 16.215z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3186"
            d="M844.264 699.272l1.774-16.476 18.367 1.95-1.764 16.473z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3226"
            d="M920.844 417.124l2.475-16.732 21.18 3.637-2.334 16.75z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3225"
            d="M923.32 400.392l1.588-10.65 21.057 3.611-2.066 10.479z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3227"
            d="M920.844 417.124l-3.033 20.416 21.176 3.626 3.178-20.387z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3229"
            d="M927.594 475.72l3.366-15.211-17.994-3.832-3.366 15.212z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3228"
            d="M930.96 460.509l3.334-15.077-17.994-3.831-3.334 15.076z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3232"
            d="M915.874 528.731l4.314-16.739-19.693-4.945-4.227 16.856z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3230"
            d="M924.357 495.326l4.062-16.166-19.689-4.935-4.051 16.162z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3231"
            d="M920.188 511.992l4.17-16.666-19.68-4.939-4.183 16.66z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3241"
            d="M883.376 684.929l3.832-16.402-17.863-4.17-3.833 16.401z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3240"
            d="M887.208 668.527l3.395-14.578-17.86-4.16-3.398 14.567z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3211"
            d="M869.435 872.456l-1.079 17.759-19.139-1.151 1.079-17.759z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3210"
            d="M867.544 863.265l-.591 8.745-16.657-.705.543-9.044z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3199"
            d="M856.87 907.6l.774-12.243-18.722-1.183-.774 12.242z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3200"
            d="M855.85 923.778l1.02-16.179-18.722-1.183-1.015 16.189z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3202"
            d="M850.625 952.593l.61-14.274-19.081-.822-.606 14.285z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3201"
            d="M851.234 938.319l.592-13.805-19.077-.812-.595 13.795z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3204"
            d="M850.72 987.992l-.169-15.438-18.881.205.169 15.438z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3203"
            d="M850.551 972.554l-.188-17.114-18.881.205.188 17.114z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3214"
            d="M875.86 933.787l.612-13.067-20.075-.757-.487 13.068z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3215"
            d="M875.86 933.787l-.656 13.974-19.822-.744.528-13.986z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3216"
            d="M854.919 959.377l.463-12.36 19.822.744-.611 12.355z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3217"
            d="M874.593 960.116l-.471 13.763-19.717-.735.514-13.767z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3218"
            d="M874.122 973.879l-.566 16.473-19.768-.751.617-16.457z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3262"
            d="M901.773 609.318l2.2-13.857 19.178 3.046-2.2 13.857z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3263"
            d="M901.773 609.318l-2.574 16.156 19.178 3.046 2.574-16.156z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3257"
            d="M940.767 523.993l4.182-15.53-18.672-5.03-4.181 15.53z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3256"
            d="M926.277 503.434l6.242-23.137 18.658 5.023-6.228 23.144z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3255"
            d="M953.176 482.885l3.38-15.104-20.362-4.6-3.408 15.091z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3254"
            d="M956.556 467.78l3.315-14.775-20.335-4.586-3.342 14.762z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3253"
            d="M959.837 453.005l3.558-15.73-20.312-4.583-3.548 15.727z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3252"
            d="M946.129 431.157l4.206-32.164 19.423 2.452-4.013 32.199z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3251"
            d="M950.335 398.993l1.169-8.97 19.39 2.454-1.136 8.968z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3311"
            d="M966.445 586.571l.425-11.104-21.017-.836-.432 11.118z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3309"
            d="M967.241 565.895l.419-10.865-21.004-.829-.418 10.865z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3310"
            d="M966.87 575.467l.371-9.572-21.003-.83-.385 9.566z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3316"
            d="M958.323 679.104l.223-10.322-19.551-.42-.227 10.311z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3315"
            d="M958.546 668.782l.294-13.555-19.55-.42-.295 13.554z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3290"
            d="M933.184 775.123l1.951-15.838-20.571-2.538-1.95 15.837z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3289"
            d="M914.564 756.747l1.942-15.767 20.57 2.54-1.94 15.765z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3297"
            d="M921.554 906.59l1.15-14.959-19.41-1.475-1.14 14.956z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3295"
            d="M904.439 875.086l1.202-15.78 19.41 1.474-1.202 15.78z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3296"
            d="M903.294 890.156l1.145-15.07 19.41 1.474-1.145 15.071z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3320"
            d="M944.375 821.917l.667-7.36-17.948-1.622-.667 7.36z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3319"
            d="M945.042 814.558l1.184-13.142-17.938-1.626-1.194 13.145z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3322"
            d="M925.315 871.204l-.748 9.432 17.59 2.019.918-10.011z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3323"
            d="M943.121 891.004l.633-8.172-19.187-2.196-.691 8.814z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3324"
            d="M941.777 908.29l1.344-17.286-19.245-1.554-1.345 17.286z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3326"
            d="M917.297 933.385l.97-13.27 19.777 1.46-1.101 13.248z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3325"
            d="M938.044 921.574l1.092-13.245-19.883-1.502-.986 13.288z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3328"
            d="M936.44 973.016l1.138-18.92-20.165-1.21-1.13 18.78z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3327"
            d="M937.578 954.097l1.164-19.167-20.208-.62-1.122 18.575z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3360"
            d="M938.018 979.459l2.611-23.477 22.024 2.462-2.615 23.467z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3358"
            d="M941.509 948.097l1.094-9.767 22.02 2.452-1.094 9.767z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3359"
            d="M940.629 955.982l.88-7.885 22.02 2.452-.876 7.895z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3356"
            d="M938.982 929.618l.688-9.084 18.323 1.401-.692 9.074z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3355"
            d="M939.67 920.534l.664-8.635 18.313 1.405-.654 8.631z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3388"
            d="M1029.26 611.073l.676-14.862-19.905-.918-.686 14.865z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3387"
            d="M1029.936 596.211l.77-16.634-19.916-.915-.76 16.63z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3393"
            d="M1000.91 705.489l2.233-19.437 19.668 2.378-2.233 19.437z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3369"
            d="M974.482 789.826l1.902-15.979 15.346 1.84-1.146 6.114 3.879.694-1.144 9.592z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3371"
            d="M992.792 821.84l2.033-17.774-18.974-2.168-2.033 17.774z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3370"
            d="M994.825 804.066l.984-9.435-18.89-2.153-1.068 9.42z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3372"
            d="M981.607 825.205l-.954 15.49-16.317-.993 1.604-15.31z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3402"
            d="M991.47 914.016l.115-16.339 22.253.169-.116 16.339z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3401"
            d="M991.585 897.677l.124-15.957 22.25.158-.12 15.968z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3444"
            d="M1059.444 677.865l.908-5.987 19.878 2.916-.59 5.763z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3442"
            d="M1082.158 662.003l2.47-16.842-19.778-2.985-2.641 17.422z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3443"
            d="M1060.352 671.878l1.857-12.28 19.949 2.405-1.928 12.791z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3454"
            d="M1055.765 889.706l.729-14.903-19.663-.969-.729 14.903z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3453"
            d="M1036.831 873.834l.717-14.515 19.663.968-.717 14.516z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3457"
            d="M1048.485 940.934l.531-14.27-19.48-1.157-.842 14.254z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3455"
            d="M1030.39 911.125l.703-11.8 19.79 1.173-.855 11.785z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3456"
            d="M1029.536 925.507l.854-14.382 19.638 1.158-1.012 14.381z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3459"
            d="M1045.884 989.707l.672-16.656-19.857-.811-.681 16.66z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3458"
            d="M1026.7 972.24l1.188-29.183 19.87.818-1.202 29.176z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3481"
            d="M1055.625 905.195l1.447-29.024 19.495.971-1.551 28.857z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3480"
            d="M1076.567 877.142l.836-14.658-19.616-.703-.715 14.39z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3478"
            d="M1061.288 836.967l1.108-13.522 18.034 1.48-.98 13.24z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3477"
            d="M1080.43 824.924l.519-11.159-17.645-1.434-.907 11.114z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3476"
            d="M1080.949 813.765l.478-8.163-17.509-.816-.614 7.545z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3475"
            d="M1083.26 804.15l2.714-14.78-18.864-3.473-2.72 14.795z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3474"
            d="M1085.974 789.37l2.764-15.06-18.863-3.472-2.765 15.059z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3470"
            d="M1082.639 689.463l-3.089 12.992 18.761 4.897 3.099-12.995z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3466"
            d="M1114.366 632.636l1.42-9.61-19.828-2.932-1.43 9.613z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3465"
            d="M1115.786 623.027l1.356-9.113-19.841-2.94-1.342 9.12z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3501"
            d="M1098.796 859.89l.986-15.365-19.245-1.227-.972 15.372z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3500"
            d="M1099.782 844.525l.95-14.947-19.24-1.217-.955 14.937z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3506"
            d="M1075.898 928.09l.96-9.111 18.601 1.971-1.022 9.098z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3504"
            d="M1096.005 916.095l1.74-16.215-18.666-1.802-1.698 16.043z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3505"
            d="M1095.459 920.95l.546-4.855-18.624-1.974-.522 4.858z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3531"
            d="M1117.134 959.644l.489-8.845-19.462-1.073-.486 8.855z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3530"
            d="M1098.16 949.726l.449-8.119 19.437 1.454-.423 7.738z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3529"
            d="M1118.58 943.101l.833-10.286-19.397-1.57-.838 10.277z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3528"
            d="M1100.016 931.245l.9-11.1 19.402 1.58-.905 11.09z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3527"
            d="M1100.917 920.145l.807-10.006 19.401 1.58-.807 10.005z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3524"
            d="M1132.607 861.072l-1.577-18.313-19.806 1.701 1.577 18.313z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3523"
            d="M1111.224 844.46l-1.39-16.12 19.803-1.711 1.393 16.13z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3522"
            d="M1137.76 811.522l2.397-22.667-19.634-2.086-2.406 22.671z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3521"
            d="M1120.523 786.769l1.129-10.705 19.644 2.082-1.14 10.709z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3559"
            d="M1175.382 929.804l-.279-14.812-19.524.372.28 14.812z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3557"
            d="M1155.317 901.246l-.204-10.704 19.524-.372.203 10.704z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3555"
            d="M1176.508 869.142l.264-15.103-19.537-.346-.264 15.102z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3554"
            d="M1157.235 853.693l.273-15.434 19.537.346-.273 15.434z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3552"
            d="M1177.466 822.917l2.39-33.419-19.043-1.364-2.391 33.418z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3553"
            d="M1158.422 821.552l-.645 9.08 19.045 1.365.644-9.08z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3583"
            d="M1215.334 921.053l.72-15.578-19.403-.642-.865 15.256z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3582"
            d="M1216.054 905.475l.728-15.909-19.203-.948-.927 16.215z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3607"
            d="M1236.147 985.392l-.603-14.541-19.49.823.612 14.538z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3606"
            d="M1235.544 970.85l-.608-14.2-19.48.82.598 14.204z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3361"
            d="M1031.082 417.51l3.077-16.624 20 2.68-3.088 16.63z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3490"
            d="M1115.722 642.759l3.801-20.288 19.54 3.564-3.802 20.288z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3489"
            d="M1120.274 620.12l2.789-16.513 19.34 3.543-2.785 16.523z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3463"
            d="M1099.523 597.539l1.727-13.433 19.643 2.794-1.74 13.426z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3462"
            d="M1096.838 577.827l2.686-16.84 19.727 2.935-2.697 16.843z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3461"
            d="M1098.707 557.15l2.442-17.51 21.15 3.229-2.445 17.5z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3460"
            d="M1102.144 536.853l2.535-18.537 20.346 2.606-2.532 18.547z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3436"
            d="M1075.567 533.514l2.366-18.862 20.885 2.825-2.365 18.862z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3435"
            d="M1077.902 513.816l3.627-32.041 21.822 2.532-3.623 32.051z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3407"
            d="M1058.795 473.156l1.89-16.144 19.245 2.3-1.89 16.144z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3408"
            d="M1056.203 491.498l1.479-16.837 19.643 1.755-1.479 16.837z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3380"
            d="M1044.347 448.662l3.745-19.444 19.7 4.22-3.745 19.444z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3512"
            d="M1145.831 636.78l1.97-14.353 19.08 2.539-1.966 14.363z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3513"
            d="M1160.44 645.585l.76-6.058-17.588-2.211-1.024 6.207z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3517"
            d="M1133.874 707.37l2.579-17.05 18.506 3.518-2.583 17.04z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3551"
            d="M1161.528 787.173l1.572-15.92 18.331 1.749-1.572 15.92z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3539"
            d="M1153.759 738.882l3.283-31.278 18.94 1.717-3.282 31.278z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3538"
            d="M1157.806 702.435l2.389-15.39 18.029 2.633-2.389 15.39z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3537"
            d="M1159.786 683.177l2.23-17.629 20.666 2.811-2.24 17.632z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3536"
            d="M1166.888 662.282l2.052-16.81 19.879 2.723-2.053 16.81z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3567"
            d="M1189.389 708.052l.905-17.574 20.029 1.045-.91 17.564z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3568"
            d="M1189.156 719.383l.301-9.74 19.085 1.125-.292 9.736z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3571"
            d="M1182.961 789.332l1.755-18.897 21.097 2.005-1.751 18.908z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3572"
            d="M1180.7 816.211l1.992-25.09 21.145 1.593-1.992 25.09z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3595"
            d="M1219.57 788.59l.565-17.805 19.998.829-.565 17.806z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3486"
            d="M1129.588 564.807l-1.642 8.907 20.639 3.803 1.568-8.927z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3488"
            d="M1142.421 605.743l3.17-17.199-19.708-3.63-2.56 16.49z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3485"
            d="M1150.153 568.59l3.66-19.878-20.553-3.787-3.672 19.882z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3487"
            d="M1125.883 584.914l2.063-11.2 19.709 3.63-2.063 11.2z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3516"
            d="M1156.691 689.146l2.433-18.377-19.88-2.633-2.43 18.388z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3515"
            d="M1139.243 668.136l1.346-10.114 19.867 2.625-1.332 10.122z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3514"
            d="M1142.588 643.523l-1.333 14.109 17.853 2.062 1.333-14.109z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3511"
            d="M1146.525 620.285l3.374-18.106 22.466 4.183-3.375 18.107z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3510"
            d="M1149.899 602.179l3.513-18.877 22.465 4.183-3.512 18.877z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3570"
            d="M1205.65 767.008l1.157-24.213-19.95-.948-1.16 24.203z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3569"
            d="M1186.858 741.847l.945-19.892 19.953.958-.949 19.882z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3534"
            d="M1176.368 613.09l1.383-16.883 18.296 1.389-1.374 16.878z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3535"
            d="M1170.467 643.37l3.403-28.857 20.49 2.499-3.417 28.85z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3565"
            d="M1193.172 663.486l1.382-17.762 19.212 1.52-1.382 17.763z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3566"
            d="M1190.974 686.073l1.392-19.03 20.011 1.513-1.402 19.035z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3594"
            d="M1220.262 766.121l.469-17.66 20.883.42-.462 17.646z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3593"
            d="M1222.17 744.357l.265-17.305 20.17.25-.265 17.306z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3574"
            d="M1178.487 853.611l2.655-28.766 19.248 1.497-2.645 28.763z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3581"
            d="M1199.425 863.725l.088-10.094 19.146.132-.088 10.094z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3599"
            d="M1219.506 866.412l.615-18.117 20.982.995-.621 18.13z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3596"
            d="M1218.122 817.354l1.056-27.068 20.834.538-1.049 27.055z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3592"
            d="M1222.283 722.236l1.079-19.283 20.648 1.236-1.079 19.283z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3591"
            d="M1224.176 696.988l1.395-16.75 20.067 1.607-1.392 16.761z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3590"
            d="M1225.205 674.255l.845-17.78 21.494.874-.846 17.78z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3589"
            d="M1227.1 651.412l.77-17.832 20.58.91-.771 17.831z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3588"
            d="M1228.329 627.016l1.378-17.773 20.136 1.256-1.369 17.77z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3564"
            d="M1215.107 640.328l1.216-16.552-20.47-1.501-1.215 16.552z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3563"
            d="M1195.854 622.275l1.302-17.701 20.47 1.501-1.303 17.7z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3605"
            d="M1237.514 956.69l.328-16.379-20.443-.257-.22 16.364z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3604"
            d="M1237.842 940.311l.129-18.636-20.335-.272-.237 18.651z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3602"
            d="M1239.054 908.76l.32-9.068-22.42-.81-.33 9.072z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3600"
            d="M1239.914 884.798l.502-13.932-22.43-.807-.502 13.932z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3601"
            d="M1239.374 899.692l.54-14.894-22.43-.807-.53 14.89z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3598"
            d="M1238.625 844.348l.728-10.137-19.72-1.423-.717 10.133z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3597"
            d="M1239.353 834.211l1.076-14.911-19.716-1.413-1.08 14.9z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3603"
            d="M1218.114 920.537l.439-11.584 20.012.61-.45 11.587z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3558"
            d="M1155.579 915.364l-.262-14.118 19.523-.372.263 14.118z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3219"
            d="M898.853 409.704l2.575-15.343 18.957 2.931-2.56 15.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3220"
            d="M896.278 425.05l2.575-15.343 18.957 2.931-2.561 15.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3221"
            d="M891.02 450.01l2.7-16.114 19.874 3.078-2.685 16.122z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3222"
            d="M888.344 465.978l2.664-15.958 19.614 3.049-2.65 15.964z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3223"
            d="M884.781 485.015l2.575-15.343 18.957 2.931-2.56 15.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3224"
            d="M881.59 500.963l2.575-15.343 18.957 2.932-2.561 15.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
        <g>
          <path
            id="3033"
            d="M664.487 827.221l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3045"
            d="M673.294 843.052l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3046"
            d="M669.937 853.63l3.957-.013m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3047"
            d="M668.754 863.56l3.957-.014m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3091"
            d="M715 886.8l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3158"
            d="M775.868 979.49l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3084"
            d="M720.122 771.826l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3103"
            d="M744.668 765.923l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3104"
            d="M758.515 767.01l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3125"
            d="M763.23 763.528l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3126"
            d="M773.257 773.424l3.957-.014m-1.974-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3124"
            d="M763.55 755.65l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3123"
            d="M765.393 745.504l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3122"
            d="M765.186 736.375l3.956-.013m-1.973-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3146"
            d="M810.52 713.505l3.956-.014m-1.973-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3147"
            d="M811.356 725.008l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3170"
            d="M811.126 764.486l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3190"
            d="M832.096 751.56l3.957-.013m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3171"
            d="M812 777.278l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3239"
            d="M870.826 641.804l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3238"
            d="M872.247 635.074l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3265"
            d="M894.506 647.39l3.957-.014m-1.974-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3285"
            d="M927.039 671.09l3.956-.013m-1.973-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3276"
            d="M899.633 788.541l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3350"
            d="M942.75 832.17l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3279"
            d="M888.556 871.002l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3352"
            d="M944.469 867.362l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3353"
            d="M943.23 873.988l3.956-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3430"
            d="M1018.809 864.258l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3451"
            d="M1040.157 840.201l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3425"
            d="M1029.82 787.553l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3367"
            d="M999.94 746.647l3.958-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3472"
            d="M1068.861 735.675l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3495"
            d="M1095.336 738.81l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3496"
            d="M1092.673 753.739l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3585"
            d="M1193.91 953.37l3.956-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3573"
            d="M1178.761 816.876l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3334"
            d="M975.372 507.746l3.957-.014m-1.974-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3383"
            d="M1022.946 496.58l3.957-.015m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3382"
            d="M1026.12 480.914l3.958-.014m-1.974-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3180"
            d="M871.618 430.336l3.957-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3062"
            d="M698.556 774.237l3.957-.014m-1.974-2.124l.018 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3063"
            d="M699.091 781.082l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3064"
            d="M701.337 788.676l3.957-.014m-1.974-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3065"
            d="M702.193 801.83l3.956-.013m-1.973-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="3085"
            d="M721.444 782.365l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
      </g>
      <g>
        <text x="463.088" y="814.866" className="field-label">
          B
        </text>
        <text x="585.898" y="958.913" className="object-label">
          193
        </text>
        <text x="593.797" y="944.941" className="object-label">
          192
        </text>
        <text x="550.749" y="960.382" className="object-label">
          171
        </text>
        <text x="554.272" y="946.858" className="object-label">
          170
        </text>
        <text x="555.672" y="933.479" className="object-label">
          169
        </text>
        <text x="557.04" y="907.584" className="object-label">
          168
        </text>
        <text x="537.508" y="820.033" className="object-label">
          144
        </text>
        <text x="544.437" y="846.677" className="object-label">
          145
        </text>
        <text x="542.098" y="862.681" className="object-label">
          146
        </text>
        <text x="539.362" y="881.634" className="object-label">
          147
        </text>
        <text x="532.57" y="900.71" className="object-label">
          148
        </text>
        <text x="530.229" y="919.303" className="object-label">
          149
        </text>
        <text x="529.518" y="939.916" className="object-label">
          150
        </text>
        <text x="527.564" y="968.896" className="object-label">
          151
        </text>
        <text x="524.833" y="561.06" className="object-label">
          96
        </text>
        <text x="521.712" y="581.313" className="object-label">
          97
        </text>
        <text x="519.287" y="601.969" className="object-label">
          98
        </text>
        <text x="511.987" y="631.508" className="object-label">
          99
        </text>
        <text x="510.423" y="652.914" className="object-label">
          100
        </text>
        <text x="509.403" y="672.025" className="object-label">
          101
        </text>
        <text x="508.258" y="689.14" className="object-label">
          102
        </text>
        <text x="506.461" y="717.404" className="object-label">
          104
        </text>
        <text x="494.212" y="733.558" className="object-label">
          105
        </text>
        <text x="491.76" y="749.09" className="object-label">
          106
        </text>
        <text x="510.917" y="753.067" className="object-label">
          107
        </text>
        <text x="518.119" y="850.314" className="object-label">
          124
        </text>
        <text x="513.503" y="872.454" className="object-label">
          125
        </text>
        <text x="505.596" y="892.168" className="object-label">
          126
        </text>
        <text x="506.545" y="908.294" className="object-label">
          127
        </text>
        <text x="502.28" y="927.85" className="object-label">
          128
        </text>
        <text x="501.674" y="944.614" className="object-label">
          129
        </text>
        <text x="490.094" y="968.3" className="object-label">
          130
        </text>
        <text x="466.558" y="959.965" className="object-label">
          120
        </text>
        <text x="471.095" y="942.15" className="object-label">
          119
        </text>
        <text x="472.983" y="866.137" className="object-label">
          115
        </text>
        <text x="473.524" y="847.915" className="object-label">
          114
        </text>
        <text x="482.656" y="821.921" className="object-label">
          111
        </text>
        <text x="460.601" y="817.868" className="object-label">
          87
        </text>
        <text x="446.255" y="850.828" className="object-label">
          89
        </text>
        <text x="448.025" y="833.936" className="object-label">
          88
        </text>
        <text x="444.638" y="867.356" className="object-label">
          90
        </text>
        <text x="443.485" y="881.341" className="object-label">
          91
        </text>
        <text x="441.255" y="898.731" className="object-label">
          92
        </text>
        <text x="439.608" y="907.912" className="object-label">
          93
        </text>
        <text x="437.219" y="916.199" className="object-label">
          94
        </text>
        <text x="445.347" y="931.198" className="object-label">
          95
        </text>
        <text x="420.632" y="932.287" className="object-label">
          37
        </text>
        <text x="420.874" y="955.459" className="object-label">
          38
        </text>
        <text x="413.289" y="909.368" className="object-label">
          36
        </text>
        <text x="402.754" y="883.327" className="object-label">
          35
        </text>
        <text x="422.187" y="864.518" className="object-label">
          71
        </text>
        <text x="424.293" y="844.516" className="object-label">
          70
        </text>
        <text x="426.666" y="825.211" className="object-label">
          69
        </text>
        <text x="449.719" y="790.375" className="object-label">
          66
        </text>
        <text x="473.299" y="799.998" className="object-label">
          86
        </text>
        <text x="474.847" y="783.827" className="object-label">
          85
        </text>
        <text x="469.929" y="756.297" className="object-label">
          83
        </text>
        <text x="474.657" y="717.556" className="object-label">
          81
        </text>
        <text x="480.288" y="675.524" className="object-label">
          79
        </text>
        <text x="481.966" y="651.655" className="object-label">
          78
        </text>
        <text x="484.141" y="632.733" className="object-label">
          77
        </text>
        <text x="485.936" y="616.363" className="object-label">
          76
        </text>
        <text x="488.195" y="595.331" className="object-label">
          75
        </text>
        <text x="491.917" y="578.183" className="object-label">
          74
        </text>
        <text x="491.55" y="562.972" className="object-label">
          73
        </text>
        <text x="389.99" y="913.201" className="object-label">
          17
        </text>
        <text x="391.037" y="931.321" className="object-label">
          18
        </text>
        <text x="378.432" y="867.559" className="object-label">
          15
        </text>
        <text x="370.159" y="828.005" className="object-label">
          13
        </text>
        <text x="372.092" y="804.817" className="object-label">
          12
        </text>
        <text x="381.108" y="847.053" className="object-label">
          14
        </text>
        <text x="398.026" y="829.464" className="object-label">
          32
        </text>
        <text x="417.965" y="767.504" className="object-label">
          50
        </text>
        <text x="419.094" y="760.334" className="object-label">
          49
        </text>
        <text x="442.885" y="733.078" className="object-label">
          62
        </text>
        <text x="447.521" y="708.744" className="object-label">
          61
        </text>
        <text x="420.637" y="750.245" className="object-label">
          48
        </text>
        <text x="452.809" y="681.737" className="object-label">
          60
        </text>
        <text x="455.19" y="657.24" className="object-label">
          59
        </text>
        <text x="456.592" y="639.052" className="object-label">
          58
        </text>
        <text x="458.749" y="615.795" className="object-label">
          57
        </text>
        <text x="461.54" y="576.718" className="object-label">
          56
        </text>
        <text x="463.669" y="556.206" className="object-label">
          55
        </text>
        <text x="440.411" y="545.636" className="object-label">
          39
        </text>
        <text x="436.056" y="572.101" className="object-label">
          40
        </text>
        <text x="433.102" y="591.203" className="object-label">
          41
        </text>
        <text x="430.996" y="609.839" className="object-label">
          42
        </text>
        <text x="427.692" y="645.265" className="object-label">
          43
        </text>
        <text x="425.426" y="668.801" className="object-label">
          44
        </text>
        <text x="422.529" y="701.088" className="object-label">
          45
        </text>
        <text x="422.035" y="734.409" className="object-label">
          47
        </text>
        <text x="396.29" y="761.417" className="object-label">
          30
        </text>
        <text x="396.814" y="755.509" className="object-label">
          29
        </text>
        <text x="401.214" y="730.063" className="object-label">
          28
        </text>
        <text x="390.943" y="703.427" className="object-label">
          27
        </text>
        <text x="393.695" y="682.719" className="object-label">
          26
        </text>
        <text x="394.383" y="662.415" className="object-label">
          25
        </text>
        <text x="396.418" y="648.559" className="object-label">
          24
        </text>
        <text x="398.944" y="629.828" className="object-label">
          23
        </text>
        <text x="400.779" y="600.522" className="object-label">
          22
        </text>
        <text x="378.611" y="598.885" className="object-label">
          2
        </text>
        <text x="379.898" y="545.019" className="object-label">
          1
        </text>
        <text x="401.104" y="579.53" className="object-label">
          21
        </text>
        <text x="377.175" y="615.657" className="object-label">
          3
        </text>
        <text x="368.231" y="645.521" className="object-label">
          5
        </text>
        <text x="376.692" y="627.62" className="object-label">
          4
        </text>
        <text x="366.611" y="669.415" className="object-label">
          6
        </text>
        <text x="364.908" y="688.91" className="object-label">
          7
        </text>
        <text x="362.071" y="708.998" className="object-label">
          8
        </text>
        <text x="376.159" y="733.803" className="object-label">
          9
        </text>
        <text x="381.575" y="753.907" className="object-label">
          10
        </text>
        <text x="372.597" y="777.071" className="object-label">
          11
        </text>
        <text x="401.348" y="862.808" className="object-label">
          34
        </text>
        <text x="402.929" y="847.801" className="object-label">
          33
        </text>
        <text x="403.033" y="561.759" className="object-label">
          20
        </text>
        <text x="404.544" y="545.548" className="object-label">
          19
        </text>
        <text x="423.737" y="718.91" className="object-label">
          46
        </text>
        <text x="430.342" y="799.659" className="object-label">
          67
        </text>
        <text x="433.277" y="777.852" className="object-label">
          64
        </text>
        <text x="471.324" y="914.297" className="object-label">
          118
        </text>
        <text x="471.719" y="894.381" className="object-label">
          117
        </text>
        <text x="472.288" y="880.311" className="object-label">
          116
        </text>
        <text x="477.723" y="696.276" className="object-label">
          80
        </text>
        <text x="561.373" y="819.814" className="object-label">
          163
        </text>
        <text x="564.113" y="803.302" className="object-label">
          162
        </text>
        <text x="566.947" y="783.731" className="object-label">
          161
        </text>
        <text x="570.273" y="761.157" className="object-label">
          160
        </text>
        <text x="567.816" y="741.455" className="object-label">
          157
        </text>
        <text x="541.179" y="696.766" className="object-label">
          137
        </text>
        <text x="545.841" y="724.361" className="object-label">
          138
        </text>
        <text x="544.671" y="743.382" className="object-label">
          139
        </text>
        <text x="545.74" y="762.685" className="object-label">
          140
        </text>
        <text x="543.534" y="781.712" className="object-label">
          142
        </text>
        <text x="541.866" y="772.8" className="object-label">
          141
        </text>
        <text x="541.073" y="798.987" className="object-label">
          143
        </text>
        <text x="544.377" y="681.025" className="object-label">
          136
        </text>
        <text x="595.575" y="815.038" className="object-label">
          184
        </text>
        <text x="570.87" y="717.512" className="object-label">
          156
        </text>
        <text x="592.818" y="672.876" className="object-label">
          176
        </text>
        <text x="581.565" y="641.483" className="object-label">
          155
        </text>
        <text x="564.752" y="564.712" className="object-label">
          131
        </text>
        <text x="561.193" y="586.813" className="object-label">
          132
        </text>
        <text x="557.026" y="613.102" className="object-label">
          133
        </text>
        <text x="552.95" y="633.412" className="object-label">
          134
        </text>
        <text x="548.784" y="658.27" className="object-label">
          135
        </text>
        <text x="627.17" y="601.675" className="object-label">
          172
        </text>
        <text x="624.763" y="622.92" className="object-label">
          173
        </text>
        <text x="622.084" y="642.934" className="object-label">
          174
        </text>
        <text x="618.735" y="670.393" className="object-label">
          175
        </text>
        <text x="605.007" y="700.616" className="object-label">
          177
        </text>
        <text x="605.459" y="738.379" className="object-label">
          178
        </text>
        <text x="603.323" y="762.478" className="object-label">
          180
        </text>
        <text x="598.299" y="779.933" className="object-label">
          181
        </text>
        <text x="592.66" y="836.503" className="object-label">
          186
        </text>
        <text x="591.075" y="855.521" className="object-label">
          187
        </text>
        <text x="590.078" y="871.27" className="object-label">
          188
        </text>
        <text x="592.302" y="887.544" className="object-label">
          189
        </text>
        <text x="590.367" y="908.785" className="object-label">
          190
        </text>
        <text x="588.361" y="929.217" className="object-label">
          191
        </text>
        <text x="563.53" y="883.716" className="object-label">
          167
        </text>
        <text x="565.195" y="862.739" className="object-label">
          166
        </text>
        <text x="590.102" y="596.574" className="object-label">
          153
        </text>
        <text x="595.169" y="575.35" className="object-label">
          152
        </text>
        <text x="597.01" y="802.293" className="object-label">
          182
        </text>
        <text x="586.059" y="618.175" className="object-label">
          154
        </text>
        <text x="399.176" y="793.113" className="object-label">
          54
        </text>
        <text x="400.151" y="784.421" className="object-label">
          53
        </text>
        <text x="401.427" y="777.985" className="object-label">
          52
        </text>
        <text x="402.904" y="772.063" className="object-label">
          51
        </text>
        <text x="445.3" y="757.698" className="object-label">
          63
        </text>
        <text x="460.429" y="769.646" className="object-label">
          84
        </text>
        <text x="453.864" y="780.434" className="object-label">
          65
        </text>
        <text x="450.421" y="801.518" className="object-label">
          68
        </text>
        <text x="491.735" y="837.612" className="object-label">
          113
        </text>
        <text x="507.568" y="822.139" className="object-label">
          112
        </text>
        <text x="468.947" y="742.376" className="object-label">
          82
        </text>
        <text x="506.688" y="704.176" className="object-label">
          103
        </text>
        <text x="522.012" y="799.991" className="object-label">
          122
        </text>
        <text x="529.257" y="834.407" className="object-label">
          123
        </text>
        <text x="569.68" y="832.155" className="object-label">
          164
        </text>
        <text x="566.515" y="842.201" className="object-label">
          165
        </text>
        <text x="560.001" y="756.527" className="object-label">
          159
        </text>
        <text x="586.099" y="755.356" className="object-label">
          158
        </text>
        <text x="589.244" y="740.852" className="object-label">
          179
        </text>
        <text x="616.426" y="812.508" className="object-label">
          183
        </text>
        <text x="612.5" y="833.486" className="object-label">
          185
        </text>
        <text x="499.932" y="780.486" className="object-label">
          108
        </text>
        <text x="498.811" y="791.701" className="object-label">
          109
        </text>
        <text x="497.69" y="802.916" className="object-label">
          110
        </text>
        <text x="379.677" y="885.33" className="object-label">
          16
        </text>
        <text x="399.299" y="816.184" className="object-label">
          31{" "}
        </text>
        <text x="425.422" y="896.776" className="object-label">
          72
        </text>
        <text x="465.643" y="972.569" className="object-label">
          121
        </text>
        <g>
          <path
            id="2193"
            d="M576.128 952.052l-.277 13.086 19.807.636.287-13.09z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2192"
            d="M586.154 939.197l-.393 7.14 1.414.071.397-7.13z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2171"
            d="M541.178 950.872l-.626 18.606 19.764.414.629-18.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2170"
            d="M548.167 944.801l-.06 3.85 12.28.265.05-3.847z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2169"
            d="M546.926 925.343l-.733 15.38 18.225.893.733-15.38z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2168"
            d="M546.778 897.383l-.757 19.59 21.28.812.757-19.59z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2144"
            d="M528.93 810.223l-2.428 16.772 19.584 2.848 2.427-16.77z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2145"
            d="M536.203 840.028l-1.604 10.51 18.071 2.787 1.604-10.509z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2146"
            d="M534.205 853.623l-2.335 15.35 18.132 2.766 2.325-15.346z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2147"
            d="M531.433 872.615l-2.352 15.4 18.211 2.638 2.352-15.4z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2148"
            d="M524.34 891.88l-1.81 15.596 18.271 2.064 1.81-15.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2149"
            d="M522.054 910.455l-1.73 15.466 18.08 2.231 1.73-15.466z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2150"
            d="M520.206 929.994l-1.214 18.472 19.837 1.372 1.214-18.472z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2151"
            d="M518.253 959.77l-1.254 17.481 19.876.77 1.254-17.48z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2096"
            d="M516.155 551.85l-2.02 15.703 19.38 2.717 2.016-15.713z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2097"
            d="M513.615 572.027l-2.039 16.104 18.243 2.47 2.028-16.102z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2098"
            d="M510.356 592.77l-2.193 15.367 20.065 3.032 2.183-15.365z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2099"
            d="M502.497 620.863l-1.55 19.583 20.53 1.706 1.55-19.583z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2100"
            d="M500.735 643.536l-1.661 16.798 21.036 1.959 1.661-16.798z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2101"
            d="M518.565 681.016l1.174-16.64-19.499-1.342-1.174 16.64z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2102"
            d="M517.608 697.987l1.012-16.392-19.711-1.302-1.013 16.392z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2104"
            d="M514.36 727.58l3.248-16.164-19.045-4.188-3.248 16.164z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2105"
            d="M502.518 739.893l1.486-10.197-18.097-2.474-1.487 10.197z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2106"
            d="M498.852 757.164l2.356-13.053-16.54-3.095-2.356 13.052z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2107"
            d="M518.766 761.738l2.464-14.558-18.15-2.784-2.477 14.552z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2124"
            d="M525.717 861.198l3.781-17.75-18.985-4.018-3.774 17.737z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2125"
            d="M521.278 882.668l3.513-16.313-19.064-4.114-3.513 16.313z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2126"
            d="M514.419 895.73l.348-6.265-17.998-.86-.345 6.276z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2127"
            d="M515.96 917.151l.904-16.896-19.735-.819-.904 16.896z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2128"
            d="M511.192 935.991l.441-15.436-18.264-.845-.442 15.435z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2129"
            d="M510.47 950.621l.506-10.613-18.097-1.4-.506 10.612z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2130"
            d="M499.64 984.358l1.444-31.304-20.535-.812-1.444 31.304z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2120"
            d="M475.496 965.692l.405-10.646-18.275-.808-.41 10.659z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2119"
            d="M480.887 950.487l.396-16.02-19.982-.653-.394 16.028z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2115"
            d="M482.936 859.684l-.476 13.585-19.43-.689.48-13.574z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2114"
            d="M482.31 856.04l.56-15.421-18.122-.827-.57 15.424z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2111"
            d="M493.858 815.151l-1.783 16.028-20.62-2.488 1.782-16.027z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2087"
            d="M469.441 828.263l2.04-18.568-19.728-2.223-2.032 18.554z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2089"
            d="M455.178 860.055l1.576-16.588-19.421-1.866-1.577 16.588z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2088"
            d="M456.408 840.267l1.204-10.618-17.97-2.044-1.204 10.618z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2090"
            d="M453.414 872.732l.947-8.959-18.494-1.794-.953 8.973z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2091"
            d="M452.302 890.717l1.63-16.787-19.264-1.966-1.631 16.787z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2092"
            d="M450.306 906.717l1.697-13.354-19.796-2.617-1.701 13.344z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2093"
            d="M446.048 910.707l.568-4.174-13.448-1.416-.569 4.174z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2094"
            d="M444.017 918.79l.44-3.734-14.036-1.448-.44 3.733z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2095"
            d="M454.824 937.142l.557-11.116-19.515-.772-.554 11.126z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2037"
            d="M410.713 940.632l.105-16.662 19.734-.028-.105 16.663z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2038"
            d="M430.68 963.588l.235-15.963-19.846-.295-.235 15.963z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2036"
            d="M423.462 917.172l-.916-16.285-19.429.678.916 16.285z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2035"
            d="M412.257 892.068l.72-16.03-19.73-1.453-.716 16.04z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2071"
            d="M430.414 873.208l1.627-15.34-18.082-2.04-1.627 15.341z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2070"
            d="M433.061 853.92l1.918-16.514-19.458-2.294-1.914 16.525z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2069"
            d="M435.084 834.885l2.329-16.568-19.164-2.78-2.33 16.567z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2066"
            d="M443.08 790.998l.642-3.443 12.636 2.196-.643 3.443z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2086"
            d="M481.765 806.373l1.172-10.81-18.104-1.94-1.172 10.81z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2085"
            d="M483.02 792.495l1.602-15.444-17.951-1.892-1.598 15.454z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2083"
            d="M479.085 763.257l1.202-12.019-19.513-1.902-1.203 12.019z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2081"
            d="M482.988 727.177l2.495-16.32-19.146-2.922-2.505 16.323z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2079"
            d="M489.2 686.306l2.259-19.265-20.093-2.3-2.249 19.263z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2078"
            d="M490.942 660.692l1.888-15.725-19.85-2.35-1.878 15.722z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2077"
            d="M493.416 640.098l1.22-12.555-19.768-2.175-1.222 12.545z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2076"
            d="M494.846 626.397l1.97-17.504-19.79-2.563-1.969 17.504z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2075"
            d="M497.243 605.84l1.922-18.548-20.017-2.472-1.922 18.549z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2074"
            d="M483.47 578.616l.583-3.648 16.31 2.792-.586 3.637z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2073"
            d="M500.42 572.962l2.295-17.414-20.039-2.566-2.29 17.424z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2017"
            d="M380.538 921.898l-.581-16.718 19.486-.675.58 16.718z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2018"
            d="M381.586 940.022l-.581-16.717 19.482-.685.581 16.717z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2015"
            d="M368.353 875.167l.68-16.05 19.478.83-.69 16.053z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2013"
            d="M361.09 837.023l-1.296-16.502 19.423-1.535 1.307 16.5z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2012"
            d="M360.862 814.93l.364-20.491 22.096.268-.354 20.488z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2014"
            d="M371.374 852.056l-.028-9.941 19.483-.065.042 9.948z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2032"
            d="M387.31 834.443l2.203-13.169 19.228 3.222-2.206 13.158z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2050"
            d="M424.749 766.512l-.272 3.597-13.297-1.628.266-3.582z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2049"
            d="M425.878 759.342l-.273 3.597-13.296-1.628.266-3.582z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2062"
            d="M434.828 723.515l-2.583 15.775 18.697 3.35 2.582-15.775z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2061"
            d="M459 695.885l-5.912 29.11-17.047-3.382 5.909-29.12z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2048"
            d="M411.275 742.481l-1.212 13.84L430 758.01l1.212-13.84z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2060"
            d="M445.121 672.83l-2.28 14.891 17.655 2.922 2.28-14.89z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2059"
            d="M445.954 648.788l-1.375 15.026 19.844 1.877 1.378-15.016z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2058"
            d="M447.41 629.712l-1.454 17.2 19.818 1.48 1.454-17.2z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2057"
            d="M467.609 628.393l1.762-23.644-19.482-1.551-1.762 23.644z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2056"
            d="M452.697 566.63l-1.975 18.104 19.675 2.072 1.96-18.111z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2055"
            d="M454.773 545.768l-1.94 18.69 19.737 2.186 1.936-18.7z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2039"
            d="M431.41 535.764l-1.909 17.709 19.91 2.035 1.909-17.71z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2040"
            d="M427.238 562.314l-2.644 16.248 20.291 3.325 2.634-16.244z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2041"
            d="M424.407 581.496l-2.236 16.738 19.625 2.677 2.236-16.739z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2042"
            d="M422.671 599.54l-2.506 17.94 19.156 2.658 2.506-17.94z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2043"
            d="M419.052 633.194l-2.255 22.133 19.529 2.01 2.261-22.147z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2044"
            d="M416.482 659.48l-1.645 16.781 19.533 1.861 1.645-16.78z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2045"
            d="M414.048 691.22l-2.553 16.701 19.502 3.036 2.567-16.696z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2047"
            d="M412.914 726.233l-1.614 14.342 19.856 2.009 1.613-14.342z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2030"
            d="M392.986 759.535l-.253 3.262 6.862.502.253-3.262z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2029"
            d="M393.515 753.625l-.264 3.265 6.862.502.263-3.265z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2028"
            d="M393.016 718.072l-2.722 21.471 19.127 2.511 2.712-21.467z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2027"
            d="M382.135 694.9l-1.276 16.382 18.893.672 1.276-16.381z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2026"
            d="M384.705 673.415l-1.301 16.989 19.29 1.618 1.291-16.985z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2025"
            d="M385.325 654.958l-1.064 13.224 19.18 1.69 1.065-13.224z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2024"
            d="M387.481 641.816l-1.362 11.397 19.239 2.088 1.359-11.407z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2023"
            d="M390.322 617.605l-2.496 22.284 19.74 2.162 2.496-22.284z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2022"
            d="M390.55 604.05l1.102-9.351 19.357 2.295-1.103 9.352z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2002"
            d="M368.293 605.95l1.125-15.55 19.51 1.407-1.131 15.563z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2001"
            d="M370.352 552.215l1.438-16.077 17.654 1.59-1.45 16.17z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2021"
            d="M390.526 586.179l1.797-15.535 19.36 2.238-1.797 15.535z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2003"
            d="M367.5 620.763l.866-11.653 18.485 1.447-.88 11.646z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2005"
            d="M359.72 631.797l-2.61 25.43 19.633 2.018 2.61-25.43z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2004"
            d="M367.878 624.641l.025 5.65 17.603.308-.028-5.66z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2006"
            d="M357.476 660.127l-1.5 16.775 19.772 1.8 1.497-16.785z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2007"
            d="M355.932 679.402l-1.81 16.986 19.761 2.03 1.81-16.985z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2008"
            d="M352.933 701.862l-1.305 11.919 19.58 2.353 1.305-11.919z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2009"
            d="M366.19 742.56l.59-17.735 19.346.221-.59 17.735z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2010"
            d="M375.23 750.843l-.295 4.598 12.99 1.53.29-4.584z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2011"
            d="M361.777 761.413l-.77 30.81 22.417.506.763-30.796z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2034"
            d="M409.842 871.088l1.432-14.798-18.166-1.762-1.685 15.011z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2033"
            d="M412.75 841.07l-1.476 15.22-18.166-1.762 1.467-15.216z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2020"
            d="M392.505 569.124l1.571-16.473 19.486 1.854-1.644 16.363z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2019"
            d="M395.599 536.59l-1.523 16.06 19.486 1.855 1.45-16.17z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2046"
            d="M412.914 726.233l1.801-16.654 19.846 2.012-1.792 16.651z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2067"
            d="M437.351 814.961l3.87-28.33-17.927-2.274-3.83 27.922z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2064"
            d="M423.294 784.357l2.177-15.284 17.79 2.66-2.041 14.898z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2118"
            d="M481.419 901.417l-.483 26.214-19.706-.637.83-26.03z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2117"
            d="M481.419 901.417l.492-13.376-19.794-.697-.59 13.613z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2116"
            d="M462.117 887.344l.913-14.764 19.43.689-.549 14.772z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2080"
            d="M469.117 684.004l-2.87 21.952 20.385 2.591 2.567-22.241z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2163"
            d="M552.14 812.815l-1.524 10.933 19.998 3.066 1.517-10.92z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2162"
            d="M552.874 810.187l2.722-16.93 19.756 3.15-2.719 16.94z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2161"
            d="M558.51 773.571l-2.652 17.324 19.521 2.995 2.657-17.314z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2160"
            d="M561.8 751.168l-2.61 16.892 19.552 3.085 2.615-16.881z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2157"
            d="M557.76 733.725l.27 15.436 19.842.025-.27-15.437z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2137"
            d="M552.313 692.43l-3.391 13.063-18.876-4.45 3.378-13.003z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2138"
            d="M536.447 715.304l-1.096 16.736 19.884 1.378 1.096-16.737z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2139"
            d="M535.373 734.472l-1.02 16.53 19.616 1.29 1.021-16.53z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2140"
            d="M536.621 754.143l-1.396 14.672 19.635 2.413 1.396-14.672z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2142"
            d="M534.241 773.97l-1.705 12.554 20.29 2.93 1.705-12.554z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2141"
            d="M536.044 770.032l-.509 3.826 12.15 1.71.513-3.816z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2143"
            d="M532.536 786.524l-3.217 22.028 20.222 2.897 3.285-21.994z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2136"
            d="M533.424 688.04l4.146-18.16 17.76 4.127-4.157 18.164z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2184"
            d="M584.512 820.28l1.439-12.768 20.686 2.284-1.439 12.768z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2156"
            d="M561.822 705.27l-2.601 21.948 20.706 2.537 2.591-21.945z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2176"
            d="M583.927 663.755l-1.566 16.392 19.338 1.85 1.575-16.395z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2155"
            d="M573.083 630.506l-3.243 18.355 20.217 3.599 3.233-18.35z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2131"
            d="M556.285 553.564l-3.313 18.673 20.248 3.622 3.313-18.672z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2132"
            d="M552.681 576.008l-3.118 18.063 20.142 3.546 3.119-18.062z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2133"
            d="M548.484 602.488l-3.364 17.098 20.447 4.129 3.365-17.097z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2134"
            d="M544.732 622.104l-3.323 19.229 19.76 3.386 3.322-19.229z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2135"
            d="M540.848 646.013l-4.037 20.324 19.916 4.19 4.03-20.31z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2172"
            d="M635.87 610.652l2.067-15.99-19.467-1.963-2.067 15.99z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2173"
            d="M615.569 611.42l-2.578 20.392 20.956 2.608 2.588-20.396z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2174"
            d="M633.724 635.108l-2.358 18.237-20.922-2.574 2.354-18.248z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2175"
            d="M631.2 655.233l-4.055 32.891-20.875-2.568 4.064-32.895z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2177"
            d="M592.665 683.788l-5.421 28.284 30.108 5.373 5.418-28.294z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2178"
            d="M596.823 726.379l-2.182 22.016 19.44 1.984 2.196-22.01z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2180"
            d="M594.004 753.768l-1.496 15.554 20.134 1.867 1.496-15.555z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2181"
            d="M589.339 770.957l-1.154 16.632 19.074 1.321 1.154-16.633z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2186"
            d="M584.353 827.767l-1.323 15.404 17.934 2.068 1.326-15.394z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2187"
            d="M582.443 847.193l-.856 15.445 18.12 1.212.857-15.445z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2188"
            d="M580.764 864.686l-.844 11.849 19.469 1.319.847-11.839z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2189"
            d="M582.851 878.27l-1.135 16.525 20.041 2.023 1.132-16.535z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2190"
            d="M581.247 898.053l-2.023 19.33 20.273 2.134 2.012-19.326z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2191"
            d="M579.908 920.578l-1.462 15.588 18.367 1.69 1.462-15.587z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2167"
            d="M555.06 875.467l-1.439 15.23L572 891.966l1.44-15.23z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2166"
            d="M556.79 854.195l-1.537 15.433 18.343 1.655 1.541-15.424z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2153"
            d="M581.32 586.57l-3.035 15.966 20.598 4.043 3.036-15.967z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2152"
            d="M584.783 564.694l-3.231 16.96 23.992 4.352 3.242-16.964z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2182"
            d="M608.07 797.076l-1.433 12.72-20.686-2.284 1.443-12.723z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2154"
            d="M577.627 607.26l-3.29 18.19 20.165 3.64 3.279-18.186z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2108"
            d="M509.816 787.155l1.121-11.215-20.889-2.123-1.121 11.215z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2109"
            d="M488.927 785.032l-1.121 11.215 20.889 2.123 1.121-11.215z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2110"
            d="M487.806 796.247l-1.121 11.214 20.889 2.123 1.121-11.214z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2031"
            d="M388.219 819.279l2.33-13.695 20.341 3.35-2.333 13.684z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2121"
            d="M474.955 974.736l.407-7.552-18.39-.574-.413 7.562z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
        <g>
          <path
            id="2054"
            d="M405.683 790.353l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2053"
            d="M406.913 782.049l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2052"
            d="M408.06 775.766l3.958-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2051"
            d="M408.966 770.658l3.957-.014m-1.974-2.124l.018 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2063"
            d="M442.911 749.47l3.957-.015m-1.974-2.124l.018 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2084"
            d="M458.027 761.668l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2065"
            d="M442.89 778.084l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2068"
            d="M439.992 798.527l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2113"
            d="M480.592 832.807l3.956-.013m-1.973-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2112"
            d="M495.957 819.727l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2082"
            d="M467.28 734.422l3.956-.014m-1.973-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2103"
            d="M498.135 696.702l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2122"
            d="M520.033 799.683l3.957-.014m-1.974-2.124l.018 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2123"
            d="M517.068 829.842l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2164"
            d="M555.92 828.229l3.957-.014m-1.974-2.124l.017 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2165"
            d="M553.44 838.466l3.957-.014m-1.974-2.124l.018 4.892"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2159"
            d="M558.146 749.704l3.956-.014m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2158"
            d="M578.102 749.31l3.956-.013m-1.973-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2179"
            d="M589.38 745.052l3.957-.013m-1.974-2.125l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2183"
            d="M608.478 804.054l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2185"
            d="M601.607 825.834l3.957-.013m-1.974-2.125l.018 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2016"
            d="M368.812 882.908l3.957-.014m-1.974-2.124l.017 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="2072"
            d="M424.468 900.952l3.957-.013m-1.974-2.125l.018 4.893"
            className="cross"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
      </g>
      <g>
        <text x="475.272" y="318.312" className="field-label">
          A
        </text>
        <text x="411.408" y="463.682" className="object-label">
          15
        </text>
        <text x="411.718" y="440.374" className="object-label">
          14
        </text>
        <text x="412.408" y="414.771" className="object-label">
          13
        </text>
        <text x="413.617" y="390.87" className="object-label">
          12
        </text>
        <text x="414.835" y="369.78" className="object-label">
          11
        </text>
        <text x="416.747" y="347.653" className="object-label">
          10
        </text>
        <text x="418.502" y="328.899" className="object-label">
          9
        </text>
        <text x="420.681" y="307.262" className="object-label">
          8
        </text>
        <text x="424.897" y="274.72" className="object-label">
          7
        </text>
        <text x="428.24" y="245.566" className="object-label">
          6
        </text>
        <text x="430.625" y="223.371" className="object-label">
          5
        </text>
        <text x="427.485" y="193.985" className="object-label">
          4
        </text>
        <text x="430.416" y="171.312" className="object-label">
          3
        </text>
        <text x="432.98" y="150.97" className="object-label">
          2
        </text>
        <text x="435.389" y="130.923" className="object-label">
          1
        </text>
        <text x="465.87" y="222.433" className="object-label">
          19
        </text>
        <text x="470.246" y="183.098" className="object-label">
          18
        </text>
        <text x="472.772" y="161.137" className="object-label">
          17
        </text>
        <text x="505.818" y="169.033" className="object-label">
          31
        </text>
        <text x="508.71" y="149.527" className="object-label">
          30
        </text>
        <text x="502.878" y="187.981" className="object-label">
          32
        </text>
        <text x="500.03" y="208.515" className="object-label">
          33
        </text>
        <text x="495.863" y="233.785" className="object-label">
          34
        </text>
        <text x="490.554" y="272.112" className="object-label">
          36
        </text>
        <text x="488.921" y="297.543" className="object-label">
          37
        </text>
        <text x="486.978" y="323.79" className="object-label">
          38
        </text>
        <text x="484.855" y="346.553" className="object-label">
          39
        </text>
        <text x="483.531" y="367.25" className="object-label">
          40
        </text>
        <text x="481.95" y="393.099" className="object-label">
          41
        </text>
        <text x="480.331" y="418.002" className="object-label">
          42
        </text>
        <text x="479.18" y="443.274" className="object-label">
          43
        </text>
        <text x="477.676" y="466.933" className="object-label">
          44
        </text>
        <text x="444.941" y="465.022" className="object-label">
          28
        </text>
        <text x="446.993" y="441.033" className="object-label">
          27
        </text>
        <text x="447.659" y="415.97" className="object-label">
          26
        </text>
        <text x="448.871" y="391.411" className="object-label">
          25
        </text>
        <text x="451.088" y="366.349" className="object-label">
          24
        </text>
        <text x="454.558" y="322.548" className="object-label">
          22
        </text>
        <text x="457.936" y="291.51" className="object-label">
          21
        </text>
        <text x="461.117" y="262.394" className="object-label">
          20
        </text>
        <text x="492.606" y="255.675" className="object-label">
          35
        </text>
        <text x="511.599" y="130.019" className="object-label">
          29
        </text>
        <text x="475.229" y="140.532" className="object-label">
          16
        </text>
        <text x="452.668" y="344.446" className="object-label">
          23
        </text>
        <text x="544.759" y="142.41" className="object-label">
          46
        </text>
        <text x="542.377" y="161.954" className="object-label">
          47
        </text>
        <text x="539.93" y="180.925" className="object-label">
          48
        </text>
        <text x="537.566" y="199.938" className="object-label">
          49
        </text>
        <text x="533.486" y="232.882" className="object-label">
          50
        </text>
        <text x="529.576" y="271.649" className="object-label">
          51
        </text>
        <text x="526.708" y="300.411" className="object-label">
          52
        </text>
        <text x="524.062" y="328.637" className="object-label">
          53
        </text>
        <text x="520.67" y="365.521" className="object-label">
          54
        </text>
        <text x="517.368" y="395.865" className="object-label">
          55
        </text>
        <text x="514.935" y="420.039" className="object-label">
          56
        </text>
        <text x="512.5" y="445.494" className="object-label">
          57
        </text>
        <text x="510.371" y="469.023" className="object-label">
          58
        </text>
        <text x="532.212" y="469.957" className="object-label">
          73
        </text>
        <text x="534.199" y="447.96" className="object-label">
          72
        </text>
        <text x="537.207" y="421.132" className="object-label">
          71
        </text>
        <text x="540.164" y="398.504" className="object-label">
          70
        </text>
        <text x="543.974" y="368.966" className="object-label">
          69
        </text>
        <text x="548.087" y="337.168" className="object-label">
          68
        </text>
        <text x="552.511" y="304.693" className="object-label">
          67
        </text>
        <text x="556.023" y="272.254" className="object-label">
          66
        </text>
        <text x="558.28" y="247.765" className="object-label">
          65
        </text>
        <text x="559.798" y="228.668" className="object-label">
          64
        </text>
        <text x="561.932" y="209.271" className="object-label">
          63
        </text>
        <text x="563.437" y="190.356" className="object-label">
          62
        </text>
        <text x="565.264" y="171.272" className="object-label">
          61
        </text>
        <text x="567.178" y="153.059" className="object-label">
          60
        </text>
        <text x="592.824" y="158.964" className="object-label">
          74
        </text>
        <text x="591.217" y="178.759" className="object-label">
          75
        </text>
        <text x="589.65" y="197.084" className="object-label">
          76
        </text>
        <text x="585.581" y="230.961" className="object-label">
          77
        </text>
        <text x="580.904" y="266.143" className="object-label">
          78
        </text>
        <text x="578.714" y="285.259" className="object-label">
          79
        </text>
        <text x="576.198" y="304.144" className="object-label">
          80
        </text>
        <text x="573.965" y="323.565" className="object-label">
          81
        </text>
        <text x="572.023" y="343.222" className="object-label">
          82
        </text>
        <text x="566.38" y="418.676" className="object-label">
          88
        </text>
        <text x="563.323" y="450.248" className="object-label">
          89
        </text>
        <text x="562.361" y="472.898" className="object-label">
          90
        </text>
        <text x="585.526" y="459.11" className="object-label">
          98
        </text>
        <text x="587.74" y="438.516" className="object-label">
          97
        </text>
        <text x="589.229" y="420.445" className="object-label">
          96
        </text>
        <text x="592.189" y="391.742" className="object-label">
          95
        </text>
        <text x="594.802" y="371.671" className="object-label">
          94
        </text>
        <text x="597.633" y="349.269" className="object-label">
          93
        </text>
        <text x="600.487" y="326.103" className="object-label">
          92
        </text>
        <text x="602.823" y="307.928" className="object-label">
          91
        </text>
        <text x="625.784" y="331.792" className="object-label">
          100
        </text>
        <text x="621.153" y="352.85" className="object-label">
          101
        </text>
        <text x="617.595" y="374.598" className="object-label">
          102
        </text>
        <text x="614.559" y="395.06" className="object-label">
          103
        </text>
        <text x="611.553" y="416.275" className="object-label">
          104
        </text>
        <text x="570.601" y="360.433" className="object-label">
          83
        </text>
        <text x="569.6" y="369.982" className="object-label">
          84
        </text>
        <text x="568.688" y="378.454" className="object-label">
          85
        </text>
        <text x="567.775" y="387.247" className="object-label">
          86
        </text>
        <text x="566.868" y="396.742" className="object-label">
          87
        </text>
        <text x="630.424" y="307.286" className="object-label">
          99
        </text>
        <text x="576.388" y="129.157" className="object-label">
          59
        </text>
        <text x="546.012" y="123.212" className="object-label">
          45
        </text>
        <g>
          <path
            id="1015"
            d="M401.712 456.255l-.31 14.26 19.703.594.308-14.26z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1014"
            d="M401.285 448.542l.272-16.732 20.593.396-.272 16.733z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1013"
            d="M402.117 422.455l.569-16.53 20.013 1.162-.569 16.53z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1012"
            d="M403.466 398.142l.713-15.531 19.59.983-.465 15.534z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1011"
            d="M403.782 376.639l1.662-15.793 20.443 2.075-1.661 15.793z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1010"
            d="M405.964 354.328l1.483-15.493 20.083 2.144-1.483 15.493z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1009"
            d="M408.01 335.002l1.716-14.434 19.269 2.235-1.73 14.428z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1008"
            d="M410.645 314.578l1.413-15.955 18.659 1.33-1.427 15.948z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1007"
            d="M412.67 289.611l4.504-32.28 19.95 2.507-4.508 32.27z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1006"
            d="M417.249 253.59l1.886-18.13 20.096 2.082-1.886 18.13z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1005"
            d="M419.5 230.216l2.233-16.421 20.018 2.731-2.234 16.421z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1004"
            d="M416.362 200.835l2.233-16.421 20.014 2.721-2.233 16.421z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1003"
            d="M419.288 178.164l2.243-16.425 20.013 2.722-2.243 16.424z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1002"
            d="M421.85 157.822l2.243-16.425 20.017 2.732-2.247 16.414z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1001"
            d="M424.264 137.768l2.233-16.42 20.017 2.73-2.233 16.422z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1019"
            d="M459.772 197.894l-5.74 47.382 17.93 1.696 5.745-47.395z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1018"
            d="M459.86 191.368l1.755-18.152 19.017 1.612-1.755 18.152z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1017"
            d="M461.646 167.987l2.234-16.42 20.017 2.73-2.237 16.412z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1016"
            d="M464.104 147.377l2.233-16.421 20.017 2.731-2.233 16.421z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1031"
            d="M497.991 160.165l-2.312 15.285 17.966 2.452 2.312-15.285z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1030"
            d="M500.878 140.658l-2.312 15.286 17.966 2.452 2.322-15.29z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1029"
            d="M503.775 121.148l-2.319 15.3 17.963 2.441 2.322-15.289z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1032"
            d="M494.435 178.3l-2.677 16.249 19.573 3.112L514 181.416z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1033"
            d="M492.342 198.107l-2.741 18.077 18.111 2.74 2.747-18.09z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1034"
            d="M507.246 225.468l-2.629 19.372-20.138-2.724 2.636-19.385z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1036"
            d="M481.755 262.707l-2.087 16.031 19.684 2.78 2.087-16.031z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1037"
            d="M479.586 288.232l-1.183 17.264 19.844 1.357 1.193-17.267z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1038"
            d="M495.904 336.257l1.73-23.441-19.585-1.493-1.728 23.451z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1039"
            d="M475.517 338.172l-1.018 15.5 19.697 1.263 1.014-15.511z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1040"
            d="M473.932 355.937l-1.306 21.385 20.503 1.24 1.306-21.384z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1041"
            d="M472.344 383.033l-1.375 18.755 20.596 1.377 1.365-18.75z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1042"
            d="M470.856 408.016l-1.104 18.852 20.043 1.119 1.114-18.855z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1043"
            d="M469.386 433.343l-1.01 18.83 20.588 1.031 1.02-18.834z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1044"
            d="M468.024 457.91L467 474.848l20.333 1.108 1.022-16.948z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1028"
            d="M435.43 456.068l-.917 16.73 19.939 1.178.917-16.73z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1027"
            d="M436.907 430.275l-1.67 19.919 21.847 1.597 1.666-19.928z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1026"
            d="M437.869 406.571l-.511 18.318 20.091.48.511-18.317z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1025"
            d="M440.127 381.433l-1.44 18.505 18.928 1.451 1.44-18.505z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1024"
            d="M441.342 356.737l-1.325 17.731 20.817 1.493 1.325-17.731z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1022"
            d="M445.577 313.076l-1.731 16.89 19.69 2.054 1.735-16.88z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1021"
            d="M449.967 274.048l-3.659 32.696 19.582 2.228 3.673-32.69z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1020"
            d="M452.532 251.412l-2.475 19.52 19.646 2.444 2.475-19.521z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1045"
            d="M537.023 114.292l-2.034 15.143 20.016 2.698 2.031-15.154z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1046"
            d="M533.989 149.786l1.984-16.876 19.557 2.124-1.984 16.876z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1047"
            d="M551.094 171.66l2.209-16.977-19.632-2.436-2.22 16.98z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1048"
            d="M548.669 190.645l2.128-16.983-19.606-2.458-2.127 16.984z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1049"
            d="M528.838 190.231l-2.165 16.974 19.622 2.44 2.165-16.973z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1050"
            d="M540.467 255.996l5.298-44.077-19.25-2.152-5.308 44.08z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1051"
            d="M520.975 257.464l-2.295 26.687 19.494 1.683 2.298-26.677z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1052"
            d="M518.807 287.077l-2.118 24.796 17.91 1.873 2.128-24.8z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1053"
            d="M516.32 315.13l-2.468 24.794 17.952 2.22 2.47-24.795z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1054"
            d="M513.134 346.815l-4.668 34.403 19.74 3.01 4.669-34.404z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1055"
            d="M508.35 387.144l-1.614 15.347 19.638 2.095 1.627-15.34z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1056"
            d="M505.673 409.299l-1.645 19.763 20.172 1.717 1.642-19.773z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1057"
            d="M503.13 436.57l-1.653 15.428 20.394 2.42 1.653-15.429z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1058"
            d="M500.991 460.107l-1.166 16.502 19.925 1.33 1.166-16.502z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1073"
            d="M523.057 460.126l-1.64 18.451 19.94 1.211 1.65-18.454z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1072"
            d="M525.51 437.394l-2.202 18.816 19.59 2.316 2.191-18.813z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1071"
            d="M528.184 410.563l-2.127 18.836 20.184 2.3 2.116-18.831z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1070"
            d="M531.368 388.796l-2.492 16.489 20.074 2.927 2.502-16.493z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1069"
            d="M536.306 350.628l-4.451 33.955 19.787 2.721 4.452-33.955z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1068"
            d="M539.918 327.074l-2.762 17.204 19.1 2.983 2.762-17.204z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1067"
            d="M544.71 286.698l-3.947 33.621 19.563 2.37 3.933-33.628z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1066"
            d="M547.322 260.306l-2.094 22.043 19.496 1.852 2.094-22.043z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1065"
            d="M550.007 238.792l-1.668 16.1 18.218 1.845 1.664-16.11z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1064"
            d="M551.393 219.063l-1.874 16.318 18.684 2.892 1.873-16.319z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1063"
            d="M553.416 200.772l-1.347 15.334 18.38 1.663 1.347-15.333z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1062"
            d="M554.418 181.075l-1.452 16.59 19.504 1.972 1.438-16.596z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1061"
            d="M556.235 162.1l-1.468 16.572 19.525 1.773 1.469-16.572z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1060"
            d="M558.238 143.59l-1.783 16.739 19.662 2.2 1.784-16.74z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1059"
            d="M562.684 111.986l-3.38 30.837 30.802 3.505 3.367-30.844z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1074"
            d="M584.597 150.325l-1.633 15.388 18.086 1.89 1.633-15.387z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1075"
            d="M582.215 169.531l-1.624 16.548 19.628 1.907 1.625-16.548z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1076"
            d="M581.196 188.466l-1.293 15.552 18.195 1.683 1.3-15.565z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1077"
            d="M579.633 208.336l-6.03 42.491 17.925 2.76 6.031-42.491z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1078"
            d="M572.73 257.467l-1.898 15.277 18.24 2.074 1.905-15.29z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1079"
            d="M569.992 275.488L567.77 292.3l19.667 2.73 2.22-16.813z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1080"
            d="M567.317 294.694l-1.949 16.785 19.712 2.115 1.949-16.785z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1081"
            d="M565.055 314.277l-1.643 16.656 19.463 1.92 1.643-16.657z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1082"
            d="M562.964 333.8l-1.585 16.918 19.702 1.926 1.586-16.918z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1088"
            d="M557.837 404.315l-2.883 26.587 19.978 2.135 2.874-26.584z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1089"
            d="M554.108 438.787l-1.857 21.101 20.298 1.82 1.847-21.097z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1090"
            d="M552.785 465.056l-.704 14.94 19.855.744.705-14.94z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1098"
            d="M576.907 449.8l-1.894 16.292 19.131 2.328 1.894-16.292z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1097"
            d="M578.927 429.556l-1.321 16.217 18.947 1.703 1.322-16.216z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1096"
            d="M580.391 411.088l-1.809 16.115 19.486 2.6 1.809-16.115z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1095"
            d="M583.87 382.384l-2.18 16.154 18.818 2.562 2.18-16.154z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1094"
            d="M586.194 361.617l-2.557 17.177 19.77 2.931 2.56-17.168z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1093"
            d="M589.064 339.078l-2.406 17.904 19.545 2.478 2.406-17.904z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1092"
            d="M591.78 316.582l-2.033 16.543 19.45 2.5 2.03-16.554z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1091"
            d="M594.793 298.996l-1.963 15.446 18.033 2.418 1.953-15.443z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1099"
            d="M622.45 296.39l-3.404 17.891 19.351 3.901 3.405-17.89z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1100"
            d="M618.215 322.5l-2.852 15.292 17.987 3.292 2.855-15.282z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1101"
            d="M613.14 342.632l-3.197 16.768 19.213 3.667 3.207-16.771z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1102"
            d="M608.939 364.528l-2.403 17.361 19.718 2.78 2.399-17.372z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1103"
            d="M606.225 384.821l-2.866 17.07 19.54 3.407 2.86-17.057z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1104"
            d="M603.39 406.523l-2.843 16.16 19.168 3.343 2.844-16.16z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1035"
            d="M481.755 262.707l2.018-16.844 19.684 2.78-2.018 16.844z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1083"
            d="M580.206 366.639l1.064-10.469-20.273-1.942-1.064 10.469z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1084"
            d="M558.995 373.325l.938-8.628 20.273 1.942-.938 8.628z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1085"
            d="M558.108 381.642l.887-8.317 20.273 1.942-.887 8.317z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1086"
            d="M557.169 390.914l.939-9.272 20.273 1.942-.929 9.269"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1087"
            d="M576.567 402.57l.885-9.717-20.283-1.939-.886 9.717z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
          <path
            id="1023"
            d="M443.576 335.063l-1.57 16.834 19.75 1.933 1.574-16.824z"
            className="object"
            onClick = {onObjectClicked}
            onMouseEnter = {onObjectMouseEnter}
            onMouseLeave = {onObjectMouseLeave}
            onMouseMove = {onObjectMouseMove}
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default SVGMap;
